<template>
  <div class="home_main" :class="skinClassFun()">
    <div class="top_box">
      <div class="top_left_box">
        <div class="icon sport_stadium" @click="leftToolbarFun()"></div>
        <!-- <div class="text">{{ pageTitle }}</div> -->
        <div class="text select_lm" :class="projectSelectShow1 ? 'select' : ''">
          <div class="val_box" >
            <div class="val" :title="pageTitle" @click="pageTypeFun('')">{{ pageTitle }}</div>
            <div class="icon_x" @click="projectSelectFun(1)"></div>
          </div>
          <div class="select_xl_lm_bg" v-if="projectSelectShow1" @click="projectSelectFun(1)"></div>
          <div class="select_xl_lm" v-if="projectSelectShow1">
            <div class="icon"></div>
            <div class="ul scrollbar_style">
              <div class="li" :class="projectId == item.id ? 'select' : ''" v-for="(item, index) in provinceNavList" :key="index" @click="provinceItemClick(item)">
                <span class="text">{{ item.name }}</span>
                <span class="edit" v-if="role != 2" @click.stop="pageTypeFun('projectSettings', item)"></span>
              </div>
            </div>
            <div class="li" @click="pageTypeFun('projectSettings')" v-if="role == 0||role == 1||role == 3">
              {{ $t("App.home.btn_text1") }}
            </div>
          </div>
        </div>
        <div class="lock" @click="setLockStatus" v-if="pageType == ''">
          <!-- <img class="img" src="../img/lock_1.png" v-if="lockStatus == 1" /> -->
          <!-- <img class="img" src="../img/lock_2.png" v-if="lockStatus == 0" /> -->
          <div class="img lock_1" v-if="lockStatus == 1"></div>
          <div class="img lock_2" v-if="lockStatus == 0"></div>
        </div>
        <div class="refresh" @click="project_projectRefresh" v-loading="loading.project_projectRefresh" v-if="pageType == ''">
          <!-- <img class="img" src="../img/refresh.png" /> -->
           <div class="img"></div>
        </div>
      </div>
      <div class="top_right_box">
        
        <div class="zoneTime" v-if="timezoneKey||timezoneKey==='0'||timezoneKey===0"> {{zoneTime}}</div>
        <div class="icon setting" @click="rightToolbarFun()"></div>
        <div class="signOut_btn_box">
          <!-- <img class="avatar" src="../img/login/login_1.png" @click="pageTypeFun('')" alt=""  v-if="!avatar"> -->
          <div class="avatar avatar0" @click="pageTypeFun('')" v-if="!avatar"></div>
          <!-- <img class="avatar" src="../img/login/login_1.png" alt=""> -->
          <img class="avatar" :src="avatar_" @click="pageTypeFun('')" v-if="avatar">
          <div class="p_box">
            <p class="p1">{{ username }}</p>
            <p class="p2">{{ roleArr[role] }}</p>
          </div>
          <div class="logout-wrap-style" :style="{'right': 0}">
            <p @click.stop="signOut()" class="p">
              <img class="img" src="../img/iot_icon_quit.png" alt="">
              <span>{{ $t('App.signOut') }}</span>
            </p>
          </div>
        </div>
      </div>
      
    </div>
    <!-- <div class="scene_map_box"></div> -->
    <div class="scene_map_box" ref="planebaseMap">
      <img class="scene_map_box img_bg" :src="layoutImage" alt="" v-if="layoutImage">
      <div class="map_device" :class="mapDevClassFun(item)" :style="{ top: item.locationY, left: item.locationX, width: clientWidth[item.type] + 'px', height: clientHeight[item.type] + 'px' }"
        v-for="item in mapDevList" :key="'map_device ' + item.type + ' ' + item.id"></div>
      <!-- 网关 -->
      <!-- <div
        :class="'map_gateway type_' + item.type + ' ' + item.id + ' status_' + item.status + ' frameSelection_' + item.frameSelection"
        :style="{ top: item.locationY, left: item.locationX, width: clientWidth + 'px', height: clientHeight + 'px' }"
        v-for="item in gatewayList" :key="'map_gateway ' + item.type + ' ' + item.id"></div> -->
      <div class="frame_selection"
        :style="{ top: frameSelectionTop + 'px', left: frameSelectionLeft + 'px', width: frameSelectionWidth + 'px', height: frameSelectionHeight + 'px' }"
        v-show="frameSelectionShow">
        <div class="move" v-if="frameSelectionIsShow"></div>
      </div>
      
      <div class="right_click_menu_box" v-if="clickMenuMoveShow">
        <div class="right_click_menu_bg" @click="rightClickMenuClose()"></div>
        <div class="right_click_menu" :style="{ top: rightClickMenuTop, left: rightClickMenuLeft }">
          <div class="div div3" @click="mapDeviceDel()">
            <i></i>
            <span>{{ $t("App.room.text26") }}</span>
          </div>
        </div>
      </div>
      <div class="notice" v-if="pageType == ''&&noticeShow">
        <div class="point">!</div>
        <!-- <div class="span">
          <span>{{alarmDeviceList.address + alarmDeviceList.alarmContent }}</span>
        </div> -->
        <div class="span">
          <span class="text" v-for="(item, index) in alarmDeviceList" :key="index">{{ item.address }} is {{ item.alarmContent }}.</span>
        </div>
      </div>
      
    </div>

    <!-- map编辑设备 -->
    <div class="mapEditDevice scrollbar_style" v-show="mapEditDeviceTkShowbg" ref="mapEditDevice">
    </div>

    <div class="left_toolbar_box" v-if="leftToolbarShow">
      <div class="bg" @click="leftToolbarShow = false"></div>
      <div class="left_toolbar">
        <div class="icon_lj"></div>
        <div class="top_bg"></div>
        <div class="text p1">{{ $t("App.home.text1") }}</div>
        <div class="project_information">
          <!-- <div class="text p2">
            <div class="laber">{{ $t("App.home.text2") }}:</div>
            <div class="select_lm" :class="projectSelectShow0 ? 'select' : ''">
              <div class="val_box" @click="projectSelectFun(0)">
                <div class="val" :title="projectName">{{ projectName }}</div>
                <div class="icon_x"></div>
              </div>
              <div class="select_xl_lm_bg" v-if="projectSelectShow0" @click="projectSelectFun(0)"></div>
              <div class="select_xl_lm" v-if="projectSelectShow0">
                <div class="icon"></div>
                <div class="ul scrollbar_style">
                  <div class="li" :class="projectId == item.id ? 'select' : ''" v-for="(item, index) in provinceNavList" :key="index" @click="provinceItemClick(item)">
                    <span class="text">{{ item.name }}</span>
                    <span class="edit" @click.stop="pageTypeFun('projectSettings', item)"></span>
                  </div>
                </div>
                <div class="li" @click="pageTypeFun('projectSettings')" v-if="role == 0||role == 3">
                  {{ $t("App.home.btn_text1") }}
                </div>
              </div>
            </div>
          </div> -->

          <div class="flex_box">
            <div class="icon lamp_online"></div>
            <div class="text span">{{ $t("App.home.text3") }}: {{ deviceTotalStatisticsList.onlineTotal }} pcs</div>
          </div>
          <div class="flex_box">
            <div class="icon lamp_fault"></div>
            <div class="text span">{{ $t("App.home.text4") }}: {{ deviceTotalStatisticsList.faultTotal }} pcs</div>
            <div class="download_btn_1" @click="exportExcelFault()">
              <!-- <img src="../img/icon/download_icon.png" alt="" /> -->
              <div class="download_icon"></div>
            </div>
          </div>
          <div class="flex_box">
            <div class="icon lamp_outline"></div>
            <div class="text span">{{ $t("App.home.text5") }}: {{ deviceTotalStatisticsList.offlineTotal }} pcs</div>
          </div>
          <div class="flex_box">
            <div class="icon lamp_online"></div>
            <div class="icon temp"></div>
            <div class="text span">{{ $t("App.home.text6") }}: {{ deviceTotalStatisticsList.overTempTotal }} pcs</div>
            <div class="download_btn_2" @click="exportExcelOverheats()">
              <!-- <img src="../img/icon/download_icon.png" alt="" /> -->
              <div class="download_icon"></div>
            </div>
          </div>
        </div>
        <div class="nav_btn_box scrollbar_style">

          <!-- <div class="nav_btn" @click="pageTypeFun('')">
            <div class="icon home"></div>
            <div class="text">{{ $t("App.home.text7") }}</div>
          </div> -->
          <div class="nav_btn" @click="pageTypeFun('systemSetting')">
            <div class="icon system_setting"></div>
            <div class="text">{{ $t("App.home.text10") }}</div>
          </div>
          <div class="nav_btn" :class="{'noSelect':role == 2}" @click="pageTypeFun('gatewayInput')">
            <div class="icon dev_setting"></div>
            <div class="text">{{ $t("App.home.nav_btn3") }}</div>
          </div>
          <div class="nav_btn" :class="{'noSelect':role == 2}" @click="pageTypeFun('controllerInput')">
            <div class="icon dev_setting"></div>
            <div class="text">{{ $t("App.home.nav_btn1") }}</div>
          </div>
          <div class="nav_btn" @click="pageTypeFun('groupSetting')">
            <div class="icon group_setting"></div>
            <div class="text">{{ $t("App.home.nav_btn2") }}</div>
          </div>
          <div class="nav_btn" @click="pageTypeFun('sceneSetting')">
            <div class="icon sence_setting"></div>
            <div class="text">{{ $t("App.home.text8") }}</div>
          </div>
          <div class="nav_btn" @click="pageTypeFun('calendar')">
            <div class="icon calendar"></div>
            <div class="text">{{ $t("App.home.text9") }}</div>
          </div>
          <div class="nav_btn" @click="pageTypeFun('powerConsumption')">
            <div class="icon power_consumption"></div>
            <div class="text">{{ $t("App.home.text11") }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="right_toolbar_box" v-if="rightToolbarShow">
      <div class="bg" @click="rightToolbarShow = false"></div>
      <div class="right_toolbar">
        <div class="icon_lj" :style="{'right': 'calc('+rightToolbariIconLeft+'px + 3.9rem)'}"></div>
        <div class="nav_box">
          <div class="nav_btn text" @click="rightToolbarTypeFun(1)" :class="{ select: rightToolbarType == 1 }">
            {{ $t("App.home.text12") }}
          </div>
          <div class="nav_btn text" @click="rightToolbarTypeFun(2)" :class="{ select: rightToolbarType == 2 }">
            {{ $t("App.home.text13") }}
          </div>
        </div>
        <div class="cont" v-loading="loading.groupBrightness" element-loading-background="rgba(0, 0, 0, 0.3)">
          <!-- dimmingType -->
          <div class="rightToolbar1 scrollbar_style" v-if="rightToolbarType == 1">
            <!-- <div class="text lebel">{{$t('App.home.text28')}}</div>
            <div class="text val1">{{'ID1/ID8/ID10'}}</div> -->
            <div v-for="(item, index) in sceneList" :key="'scene' + index" class="li">
              <div class="text val2">{{ item.name }}</div>
              <div class="apply_box">
                <button
                  class="apply text"
                  :class="item.status == 1 ? 'select' : ''"
                  v-loading="item.sceneApplying"
                  @click="sceneApply(item)"
                >
                  {{ $t("App.home.text29") }}
                </button>
                <div class="icon_box">
                  <div class="img" @click.stop="editShowFun($event,item)"></div>
                  <!-- <img class="img" src="../img/point3.png" @click.stop="editShowFun($event,item)" /> -->
                  <div class="bg" @click.stop="editShowFun($event,item)" :class="{ show: item.editShow }"></div>
                  <div class="popper_ul" :class="{ show: item.editShow, position: item.showPosition == 'top' }">
                    <div class="icon"></div>
                    <div class="ul">
                      <div class="popper_li" @click="pageTypeFun('sceneSettingEdit', item)">
                        {{ $t("App.sceneSetting.btn1") }}
                      </div>
                      <div class="popper_li" @click="pageTypeFun('calendar', item)">
                        {{ $t("App.sceneSetting.btn2") }}
                      </div>
                      <div class="popper_li" @click="del(item)">
                        {{ $t("App.sceneSetting.btn3") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="btn">
              <div class="icon"></div>
              <div class="text">{{ $t('App.schedule.text9') }}</div>
            </div> -->
          </div>
          <div class="rightToolbar2" v-if="rightToolbarType == 2" element-loading-background="rgba(0, 0, 0, 0.5)">
            <div class="radio_li">
              <div class="lm_radio" @click="dimmingTypeFun(1)" :class="{ select: dimmingType == 1 }">
                <div class="radio_i"></div>
              </div>
              <div class="text">{{ $t("App.home.text14") }}</div>
            </div>
            <div class="radio_li">
              <div class="lm_radio" @click="dimmingTypeFun(2)" :class="{ select: dimmingType == 2 }">
                <div class="radio_i"></div>
              </div>
              <div class="text">{{ $t("App.home.text15") }}</div>
              <el-select v-model="groupId" placeholder="" popper-class="text_select">
                <el-option v-for="item in groupNavList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="flex_box">
              <div class="text span">{{ $t("App.home.text16") }}</div>
              <div class="text brightness">{{ groupBrightness + "%" }}</div>
            </div>
            <div class="slider_box">
              <el-slider
                v-model="groupBrightness"
                :format-tooltip="groupBrightnessTooltip"
                :show-tooltip="false"
              ></el-slider>
              <div class="slider_b">
                <div class="text span1">0%</div>
                <div class="text span2">100%</div>
              </div>
            </div>
            
            <div class="flex_box">
              <div class="text span">{{ $t("App.home.text41") }}</div>
              <div class="text brightness">{{ groupColor }}</div>
            </div>
            <div class="slider_box color">
              <el-slider v-model="groupColor" :style="{'--color':groupColorRgba?groupColorRgba:'#00c6ff'}" :min="2700" :max="6500"
                :show-tooltip="true"></el-slider>
              <div class="slider_b">
                <div class="text span1">2700</div>
                <div class="text span2">6500</div>
              </div>
            </div>

            <div class="bottom_btn">
              <div class="btn2 text" @click="dimming()"> {{ $t("App.ok") }} </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 灯控弹框 -->
    <div class="light_control" :class="dragType==1?'wg_control':''" v-if="lightControlShow">
      <div class="bg" @click="lightControlShowFun" v-if="!isMobile"></div>
      <div class="bg" @touchend="lightControlShowFun" v-if="isMobile"></div>
      <div class="cont" :style="{'width': lightContWidth}">
        <div class="center_box">
          <div class="flex_box">
            <div class="form_item">
              <div class="label text">{{ $t("App.home.text17") }}:</div>
              <div class="form_item_content">
                <!-- <el-input v-if="dragType == 0" v-model="lightControlForm.name"></el-input> -->
                <div v-if="dragType == 0" class="text">{{ lightControlForm.name }}</div>
                <div v-if="dragType == 1" class="text">{{ lightControlForm.name }}</div>
              </div>
            </div>
            <div class="form_item">
              <div class="label text">{{ $t("App.home.text18") }}:</div>
              <div class="form_item_content">
                <!-- <el-input v-if="dragType == 0" v-model="lightControlForm.address"></el-input> -->
                <div class="text" v-if="dragType == 0">{{ lightControlForm.address }}</div>
                <div class="text" v-if="dragType == 1">{{ lightControlForm.address }}</div>
              </div>
            </div>
            <div class="form_item" v-if="dragType == 0">
              <div class="label text">{{ $t("App.home.text20") }}:</div>
              <div class="form_item_content">
                <!-- <el-input v-model="lightControlForm.networkAddress"></el-input> -->
                <div class="text">{{ lightControlForm.networkAddress }}</div>

              </div>
            </div>
            <div class="form_item" v-if="dragType == 1">
              <div class="label text">{{ $t("App.home.text31") }}:</div>
              <div class="form_item_content">
                <!-- <el-input v-model="lightControlForm.description"></el-input> -->
                <div class="text">{{ lightControlForm.description }}</div>
              </div>
            </div>
            <div class="form_item" v-if="dragType == 0">
              <div class="label text">{{ $t("App.home.text19") }}:</div>
              <div class="form_item_content scrollbar_style" style="max-height: 11rem;">
                <!-- <el-input v-model="lightControlForm.online"></el-input> -->
                <template v-if="lightControlForm.groupStr">
                  <div class="text" v-for="(text,index) in lightControlForm.groupStr.split(',')" :key="index+'group'">{{ text }}</div>
                </template>
                <template v-if="!lightControlForm.groupStr">
                  <div class="text" >{{ lightControlForm.groupStr }}</div>
                </template>
              </div>
            </div>
          </div>
          <div class="flex_box" v-if="dragType == 0">
            <div class="form_item">
              <div class="label text">{{ $t("App.home.text21") }}:</div>
              <div class="form_item_content" style="max-width: 17rem;">
                <div class="select_lm multiple" :class="sceneSelectShow ? 'select' : ''">
                  <div class="val_box" @click="selectFun('sceneSelectShow')">
                    <div class="val" :title="lightControlForm.sceneStr">
                      {{ lightControlForm.sceneStr }}
                    </div>
                    <div class="icon_x"></div>
                  </div>
                  <div class="select_xl_lm_bg" v-if="sceneSelectShow" @click="selectFun('sceneSelectShow')"></div>
                  <div class="select_xl_lm" v-if="sceneSelectShow">
                    <div class="icon"></div>
                    <div class="ul scrollbar_style" v-if="dragType == 0">
                      <div class="li" v-for="(item, index) in lampSceneNavList" :key="index"
                        @click="sceneItemClick(item)">
                        <div class="text">{{ item.name }}</div>
                        <div class="selectDrop" :class="lightControlForm.sceneIds.indexOf(item.id) != -1 ? 'select': ''">
                          <div class="drop"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form_item height_2">
              <div class="label text">{{ $t("App.home.text22") }}:</div>
              <div class="form_item_content">
                <!-- <el-input v-model="lightControlForm.luminance"></el-input> -->

                <div class="slider_box">
                  <el-slider v-model="lightControlForm.brightness" :format-tooltip="lampBrightnessTooltip"
                    :show-tooltip="true"></el-slider>
                  <div class="slider_b">
                    <div class="text span1">0%</div>
                    <div class="text span2">100%</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form_item height_2">
              <div class="label text">{{ $t("App.home.text41") }}:</div>
              <div class="form_item_content">
                <div class="slider_box color">
                  <el-slider v-model="lightControlForm.color" :style="{'--color':colorRgba?colorRgba:'#00c6ff'}" :format-tooltip="lampColorTooltip" :min="2700" :max="6500"
                    :show-tooltip="true"></el-slider>
                  <div class="slider_b">
                    <div class="text span1">2700</div>
                    <div class="text span2">6500</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form_item">
              <div class="label text">{{ $t("App.home.text23") }}:</div>
              <div class="form_item_content">
                <!-- <el-input v-model="lightControlForm.online"></el-input> -->
                <div class="text" style="overflow-wrap: break-word;">
                  <template v-if="lightControlForm.alarmStatus == 1">
                    {{ lightControlForm.alarmContent }}

                  </template>
                  <template v-if="lightControlForm.alarmStatus == 0">
                    {{ alarmStatusArr[lightControlForm.devStatus] }}
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="flex_box">
            <div class="form_item" v-if="dragType == 0">
              <div class="label text">{{ $t("App.home.text24") }}:</div>
              <div class="form_item_content">
                <!-- <el-input v-model="lightControlForm.power"></el-input> -->
                <div class="text">{{ lightControlForm.power }}</div>
              </div>
            </div>
            <div class="form_item" v-if="dragType == 0">
              <div class="label text">{{ $t("App.home.text25") }}:</div>
              <div class="form_item_content">
                <!-- <el-input v-model="lightControlForm.curent"></el-input> -->
                <div class="text">{{ lightControlForm.current }}</div>
              </div>
            </div>
            <div class="form_item" v-if="dragType == 0">
              <div class="label text">{{ $t("App.home.text26") }}:</div>
              <div class="form_item_content">
                <!-- <el-input v-model="lightControlForm.voltage"></el-input> -->
                <div class="text">{{ lightControlForm.voltage }}</div>
              </div>
            </div>
            <div class="form_item" v-if="dragType == 1">
              <div class="label text">{{ $t("App.home.text38") }}:</div>
              <div class="form_item_content">
                <!-- <el-input v-model="lightControlForm.voltage"></el-input> -->
                <div class="text">{{ lightControlForm.updateTime }}</div>
              </div>
            </div>
            <!-- 过期时间 -->
            <div class="form_item" v-if="dragType == 1">
              <div class="label text">{{ $t("App.home.text37") }}:</div>
              <div class="form_item_content">
                <div class="text">
                  {{ lightControlForm.expirationDate }}
                </div>
                <!-- <el-date-picker
                  class="date1"
                  v-model="lightControlForm.expirationDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder=""
                  style="width: 100%;">
                </el-date-picker> -->
              </div>
            </div>
            <div class="form_item" v-if="dragType == 1">
              <div class="label text">{{ $t("App.home.text23") }}:</div>
              <div class="form_item_content">
                <!-- <el-input v-model="lightControlForm.online"></el-input> -->
                <div class="text" style="overflow-wrap: break-word;">
                    {{ alarmStatusArr[lightControlForm.online] }}
                </div>
              </div>
            </div>
            <!-- <div class="form_item">
              <div class="label text">{{ $t("App.home.text27") }}:</div>
              <div class="form_item_content">
                <div class="text">
                  {{ lightOnlineArr[lightControlForm.online] }}
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <div class="bottom_btn">
          <div class="btn1 text" @click="lightControlShowFun"> {{ $t("App.cancel") }} </div>
          <div class="btn2 text" @click="EditlightFun" v-if="dragType == 0"> {{ $t("App.ok") }} </div>
        </div>
      </div>
    </div>
    <!-- 分组弹框 -->
    <div class="light_control group_control" v-if="groupControlShow">
      <div class="bg" @click="groupControlShowFun"></div>
      <div class="cont">
        <div class="center_box">
          <div class="flex_box">
            <div class="form_item">
              <div class="label text">{{ $t("App.groupSetting.text7") }}:</div>
              <div class="form_item_content">
                <div class="text">{{ groupAddDevName }}</div>
              </div>
            </div>
            <!-- <div class="form_item">
              <div class="label text">{{ $t("App.groupSetting.text8") }}</div>
            </div> -->
            <div class="form_item">
              <div class="label text">{{ $t("App.groupSetting.text8") }}:</div>
              <div class="form_item_content">
                <div class="text">
                  <!-- <span v-for="(item,index) of groupAddDevList_" :key="index+'group_lamp'">{{ item.lampAddress }}<template v-if="index < groupAddDevList_.length-1">,</template></span> -->
                  <span v-for="(item,index) of groupAddDevList_" :key="index+'group_lamp'">{{ item.name }}<template v-if="index < groupAddDevList_.length-1">,</template></span>
                </div>
              </div>
            </div>
            <div class="form_item">
              <div class="label text">{{ $t("App.groupSetting.text4") }}:</div>
              <div class="form_item_content">
                <div class="text">{{ groupAddDevRemark }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom_btn">
          <div class="btn1 text" @click="groupControlShowFun">
            {{ $t("App.exit") }}
          </div>
          <div class="btn2 text" @click="editGroupFun">
            {{ $t("App.ok") }}
          </div>
        </div>
      </div>
    </div>
    
    <div class="group_bottom_btn" v-if="groupAddDev">
      <div class="btn1 text" @click="groupSetCancel">
        {{ $t("App.cancel") }}
      </div>
      <div class="btn2 text" @click="groupSetSave">
        {{ $t("App.ok") }}
      </div>
    </div>
    <!-- 网关详情 -->
    <div class="gateway_control" v-if="gatewayControlShow">
      <div class="bg" @click="gatewayControlShowFun"></div>
      <div class="cont">
        <div class="center_box">
          <div class="flex_box">
            <div class="form_item">
              <div class="label text">{{ $t("App.home.text17") }}:</div>
              <div class="form_item_content">
                <el-input v-model="gatewayControlForm.name"></el-input>
              </div>
            </div>
            <div class="form_item">
              <div class="label text">{{ $t("App.home.text18") }}:</div>
              <div class="form_item_content">
                <el-input v-model="gatewayControlForm.address"></el-input>
              </div>
            </div>
            <div class="form_item">
              <div class="label text">{{ $t("App.home.text31") }}:</div>
              <div class="form_item_content">
                <el-input v-model="gatewayControlForm.description"></el-input>
              </div>
            </div>
          </div>
          <div class="flex_box">
            <div class="form_item">
              <div class="label text">{{ $t("App.home.text24") }}:</div>
              <div class="form_item_content">
                <!-- <el-input v-model="gatewayControlForm.power"></el-input> -->
                <div class="text">{{ gatewayControlForm.projectId }}</div>
              </div>
            </div>
            <div class="form_item">
              <div class="label text">{{ $t("App.home.text25") }}:</div>
              <div class="form_item_content">
                <el-input v-model="gatewayControlForm.expirationDate"></el-input>
                <!-- <div class="text">{{ gatewayControlForm.expirationDate }}</div> -->
              </div>
            </div>
            <div class="form_item">
              <div class="label text">{{ $t("App.home.text26") }}:</div>
              <div class="form_item_content">
                <!-- <el-input v-model="gatewayControlForm.voltage"></el-input> -->
                <div class="text">{{ gatewayControlForm.updateTime }}</div>
              </div>
            </div>
            <div class="form_item">
              <div class="label text">{{ $t("App.home.text27") }}:</div>
              <div class="form_item_content">
                <!-- <el-input v-model="gatewayControlForm.power"></el-input> -->
                <div class="text">
                  {{ gatewayOnlineArr[gatewayControlForm.online] }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="bottom_btn">
          <div class="btn1 text" @click="gatewayControlShowFun">
            {{ $t("App.cancel") }}
          </div>
          <div class="btn2 text" @click="gatewayEditlightFun">
            {{ $t("App.ok") }}
          </div>
        </div> -->
      </div>
    </div>
    

    <scene-setting ref="sceneSetting" v-if="pageType == 'sceneSetting'" @pageTypeFun="pageTypeFun"></scene-setting>
    <scene-setting-edit v-if="pageType == 'sceneSettingEdit'" @pageTypeFun="pageTypeFun"></scene-setting-edit>
    <calendar v-if="pageType == 'calendar'" @pageTypeFun="pageTypeFun"></calendar>
    <system-setting v-if="pageType == 'systemSetting'" @pageTypeFun="pageTypeFun"></system-setting>
    <sub-account-setting v-if="pageType == 'subAccountSetting'" @pageTypeFun="pageTypeFun"></sub-account-setting>
    <project-settings v-if="pageType == 'projectSettings'" @pageTypeFun="pageTypeFun"></project-settings>
    <controller-input v-if="pageType == 'controllerInput'" @pageTypeFun="pageTypeFun"></controller-input>
    <group-setting v-if="pageType == 'groupSetting'" @pageTypeFun="pageTypeFun"></group-setting>
    <gateway-input v-if="pageType == 'gatewayInput'" @pageTypeFun="pageTypeFun"></gateway-input>
    <schedule v-if="pageType == 'schedule'" @pageTypeFun="pageTypeFun"></schedule>
    <power-consumption v-if="pageType == 'powerConsumption'" @pageTypeFun="pageTypeFun"></power-consumption>

    <!-- <calendar v-if="pageType=='calendar'"></calendar> -->
  </div>
</template>

<script type="text/javascript">
import sceneSetting from "./sceneSetting.vue";
import sceneSettingEdit from "./sceneSettingEdit.vue";
import calendar from "./calendar.vue";
import systemSetting from "./systemSetting.vue";
import subAccountSetting from "./subAccountSetting.vue";
import projectSettings from "./projectSettings.vue";
import gatewayInput from "./gatewayInput.vue";
import controllerInput from "./controllerInput.vue";
import groupSetting from "./groupSetting.vue";
import schedule from "./schedule.vue";
import powerConsumption from "./powerConsumption.vue";

import { mapGetters } from "vuex";
import allUrl from "../api/allUrl.js";
import base from "../api/base.js";
export default {
  name: "home",
  data() {
    return {
      zoneTime:null,
      timezoneKey: false,
      zoneTimefun:null,
      // themeType :'',
      noticeShow: false,
      alarmDeviceList:{
        id: "",
        name: "",
        address: "",
        alarmContent:"",
        alarmType:''
      },
      isGetList:false,
      pageType: "",
      pageTitle: "",
      projectSelectShow0: false,
      projectSelectShow1: false,

      ratio: "1",
      skins: "1",
      // editShow: false,

      leftToolbarShow: false,
      rightToolbarShow: false,
      rightToolbarType: 1,
      dimmingType: 1,
      groupId: "",
      groupOptions: [],
      groupBrightness: 0,
      groupColor: 0,

      rightToolbariIconLeft:0,

      groupControlShow:false,

      lightControlShow: false,
      
      lightContWidth : null,
      lightControlForm: {
        id: "",
        name: "",
        address: "",
        networkAddress: "",
        scenes: "",
        power: "",
        luminance: "",
        alarmStatus: "",
        current: "",
        voltage: "",
        online: "",
        brightness:"",
        color:0,

        description:"",
        projectId:"",
        expirationDate:"",
        updateTime:"",
        locationX:"",
        locationY:""
      },
      scenesOptions: [],

      alarmStatusArr: [],
      lightOnlineArr: [],
      gatewayOnlineArr:[],

      layoutImage: "",
      // planeLayoutDevInfo:{},

      img_lights_0: "",
      img_lights_1: "",
      img_lights_2: "",
      img_lights_3: "",
      img_bindingTkOpen: "",

      frameSelectionTop: 0,
      frameSelectionLeft: 0,
      frameSelectionTop_: 0,
      frameSelectionLeft_: 0,
      frameSelectionWidth: 0,
      frameSelectionHeight: 0,
      frameSelectionShow: false,
      frameSelectionIsShow: false,
      isSave: false,
      isSaveTime: null,

      mapDevList: [],
      gatewayList:[],
      dragType: "",
      buttonType: "",
      dragDeviceId: "",
      planeLayoutDevInfo: {},

      deviceTipsShow: false,

      clickMenuMoveTop: 0,
      clickMenuMoveLeft: 0,
      clickMenuMoveHeight: 0,
      clickMenuMoveWidth: 0,
      clickMenuMoveShow: false,

      rightClickMenuTop: 0,
      rightClickMenuLeft: 0,
      rightClickMenuShow: false,
      rightClickMenuType: 1,
      rightClickMenuDevId: null,
      rightClickMenu_copy_Show: false,
      rightClickMenu_paste_Show: false,
      rightClickMenu_delete_Show: false,
      mapDeviceCopyList: [],

      lockStatus: "",
      sceneSelectShow: false,
      groupSelectShow: false,
      lampSceneNavList: [],
      lampGroupNavList: [],

      /*map设备弹框*/
      mapDeviceTkShow: false,
      mapDeviceTkShowbg: false,
      mapDeviceTypeList: [
        { name: "Lights", id: "0" },
        { name: "Circadian lights", id: "1" },
        { name: "Sensor", id: "2" },
        { name: "Air purifiers", id: "3" },
      ],
      mapArrangementList: [
        { name: "Coincidence", id: "0" },
        { name: "Equidistant", id: "1" },
        { name: "Matrix", id: "2" },
      ],
      mapDeviceForm: {
        list: [{ type: "0", deviceCount: "", name: "Lights" }],
        layoutType: "0",
        columnNumber: "",
        width: "",
        space: "",
      },

      floorName: "",
      deviceInfo: {
        name: "",
        id: "",
        number: "",
        locationX: "",
        locationY: "",
        status: "",
        light: "",
        color: "",
        type: "0",
        deviceId: "",
        roomId: "",
        roomNumber: "",
      },
      deviceInfoUpdate: true,

      svpanelTop: 0,
      svpanelLeft: 0,
      offsetX: 0,
      offsetY: 0,
      clientWidth: [],
      clientHeight: [],
      mapBgWidth: 0,
      mapBgHeight: 0,

      /*编辑设备弹框*/
      mapEditDeviceTkShowbg: false,
      mapEditDeviceTkShow: false,
      mapEditDeviceForm: {
        devId: "",
        floorId: "",
        roomId: "",
        address: "",
        type: "",
        number: "",
        name: "",
        gatewayId: "",
      },

      // deviceLockTitle: 'Lock',
      // lock: '1',
      lockTitleShow: false,
      lockTitleShowTime: null,

      sensorStatusArr: ["Off-line", "On-line"],
      purifierStatus: ["Off", "Low", "Middle", "High"],

      // provinceNavList:[],
      // projectId:'',
      // projectName:'',
      sceneNavList: [],
      groupNavList: [],
      sceneList:[],

      scheduleList: [],

      loading:{
        groupBrightness:false,
        groupColor: false,
        sceneApplying: false,
        project_projectRefresh:false,
      },
      groupAddDevList_: [],

      gatewayList_:[],
      lightGatewayarr:[],
      gatewayControlShow: false,
      gatewayControlForm: {
        id: "",
        name: "",
        address: "",
        description: "",
        projectId: "",
        expirationDate: "",
        updateTime: "",
        online: "",
      },
      keywords:'',
      projectForm:{
        id:'',
        name:'',
        image:'',
        location:'',
        description:'',
      },
      protocolStr:'',
      domainName:'',
      street:'',
      type:'',

      roleArr:[],

      deviceTotalStatisticsList: {
        onlineTotal:0,
        offlineTotal:0,
        faultTotal:0,
        overTempTotal:0,
      },

      getLampTime: null,

      colorRgba: null,
      groupColorRgba: null,
      
    };
  },
  computed: {
    ...mapGetters({
      token: "token",
      client_key: "client_key",
      username: "username",
      version: "version",
      role: "role",

      id: 'id',

      groupAddDev: "groupAddDev",

      lampListUpdate: "lampListUpdate",
      userDetailsGetUpdate: 'userDetailsGetUpdate',

      remRatio: "remRatio",
      updateRemRatio: "updateRemRatio",

      projectUpdate: 'projectUpdate',

      projectId: "projectId",
      projectName: "projectName",
      provinceNavList: "provinceNavList",
      groupAddDevStr: "groupAddDevStr",
      groupAddDevIndex: 'groupAddDevIndex',
      
      getUserSettingInfoDateValue: "getUserSettingInfoDateValue",
      bjIndex: "bjIndex",
      groupAddDevName: "groupAddDevName",
      groupAddDevRemark: "groupAddDevRemark",

      isMobile: "isMobile",

      avatar:'avatar',
      themeType: 'themeType',
      // countryId: 'countryId',
      // provinceId: 'provinceId',
      // cityId: 'cityId',
      // hotelId: 'hotelId',
      // headerIdStr: 'headerIdStr',
    }),
    avatar_ () {
      let str = ''
      if(this.avatar.startsWith('http')){
        str = this.avatar;
      }else{
        str = this.protocolStr+'//'+this.domainName+'/'+this.avatar;
      }
      return str
    }
    // sensorFormModelName(){
    //     let name = '';
    //     for(let d of this.modelNav){
    //         if(d.id == this.sensorForm.model){
    //             name = d.name
    //         }
    //     }
    //     return name
    // }
  },
  components: {
    sceneSetting: sceneSetting,
    sceneSettingEdit: sceneSettingEdit,
    calendar: calendar,
    systemSetting: systemSetting,
    subAccountSetting: subAccountSetting,
    projectSettings: projectSettings,
    gatewayInput: gatewayInput,
    controllerInput: controllerInput,
    groupSetting: groupSetting,
    schedule: schedule,
    powerConsumption: powerConsumption,
  },
  beforeDestroy() {
    if (this.websocket) {
      this.websocket.close();
    }
    if(this.getLampTime){
      clearInterval(this.getLampTime)
    }
    if(this.zoneTimefun){
      clearInterval(this.zoneTimefun)
    }
  },
  mounted() {
    this.zoneTimefun = setInterval(()=>{
      this.zoneTime =  this.getLocalTime(this.timezoneKey, new Date());
    },1000)
    this.roleArr = [this.$t('App.text8'),this.$t('App.text9'),this.$t('App.text10'),this.$t('App.text16')];

    this.domainName = window.location.href.split("/")[2];
    if(this.domainName == 'localhost:8080' || this.domainName == '127.0.0.1:8080'|| url == '10.0.0.94:8080'){
        this.domainName = 'lighting.lampmind.com'
    }
    console.log(this.getUserSettingInfoDateValue,'---this.getUserSettingInfoDateValue--')
    if(this.getUserSettingInfoDateValue){
      this.pageTypeFun(this.getUserSettingInfoDateValue)
    }

    this.projectNavList();
    //获取背景图片
    let url = window.location.href.split("/")[2];
    this.protocolStr = document.location.protocol;
    this.street = url;
    if(url == 'localhost:8080' || url == '127.0.0.1:8080'|| url == '10.0.0.94:8080' || url == '10.0.0.164:8080'){
        this.street = 'lighting.lampmind.com';
        // street = 'www.iotena-web.com';
        this.protocolStr = 'https:'
    }
    // console.log(protocolStr)

    // this.projectDetailsGet();
    // this.pageTitle = this.$t("App.pageTitle1");
    this.pageTitle = this.projectName;
    // this.getUserSettingInfoSelectFun(1)

    this.alarmStatusArr = [
      this.$t("App.home.lightOnline0"),
      this.$t("App.home.lightOnline1"),
      this.$t("App.home.alarmStatus1"),
    ];
    this.lightOnlineArr = [
      this.$t("App.home.lightOnline0"),
      this.$t("App.home.lightOnline1"),
    ];
    this.gatewayOnlineArr = [
      this.$t("App.home.lightOnline0"),
      this.$t("App.home.lightOnline1"),
    ];

    this.bindingTkOpenShow = false;
    // this.mapDevList = obj.devList;
    // for (let d of this.mapDevList) {
    //   d.locationX = d.locationX < 0 ? 0 : d.locationX;
    //   d.locationX = d.locationX > 97 ? 97 : d.locationX;

    //   d.locationY = d.locationY < 0 ? 0 : d.locationY;
    //   d.locationY = d.locationY > (100 - 2 / (this.mapBgHeight / this.mapBgWidth).toFixed(4)) ? (100 - 2 / (this.mapBgHeight / this.mapBgWidth).toFixed(4)) : d.locationY;

    //   d.x1 = (d.locationX * this.mapBgWidth / 100).toFixed(4);
    //   d.y1 = (d.locationY * this.mapBgHeight / 100).toFixed(4);
    //   d.x2 = (d.locationX * this.mapBgWidth / 100 + Number(this.clientWidth.toFixed(4))).toFixed(4);
    //   d.y2 = (d.locationY * this.mapBgHeight / 100 + Number(this.clientHeight.toFixed(4))).toFixed(4);
    //   this.$set(d, 'frameSelection', 0);
    //   d.locationX = d.locationX + '%';
    //   d.locationY = d.locationY + '%';
    //   // if(d.type == '2'){
    //   this.$set(d, 'status', d.online ? d.online : '0')
    //   // }
    //   if (!d.deviceId) {
    //     d.status = 'new'
    //     this.bindingTkOpenShow = true;
    //   }
    // }
    // this.layoutImage = this.projectForm.image;
    
    // this.layoutImage = require("../img/scene_bg.png");

    const container = this.$refs.planebaseMap;
    const rect = container.getBoundingClientRect();
    this.mapBgWidth = rect.width;
    this.mapBgHeight = rect.height;
    // this.clientWidth = (this.mapBgWidth * 2) / 100;
    // this.clientHeight = (this.mapBgWidth * 2) / 100;
    this.clientWidth = [this.remRatio*3,this.remRatio*4.2];
    this.clientHeight = [this.remRatio*3,this.remRatio*4.2];
    this.draggable(container, {
      drag: (event) => {
        if (this.lockStatus == "0") {
          this.handleDrag(event, "drag");
        } else {
          this.lockTitleShow = true;
          // this.$message({
          //     message: 'Unchecked',
          //     type: 'warning'
          // });
        }
      },
      end: (event) => {
        if (this.lockStatus == "0") {
          this.handleDrag(event, "end");
        } else {
          this.lockTitleShow = true;
          // this.$message({
          //     message: 'Unchecked',
          //     type: 'warning'
          // });
        }
      },
    });
    // let storage = window.localStorage;
    // if (storage.getItem("projectObj")) {
    //   let projectObj = JSON.parse(storage.getItem("projectObj"));

    //   this.$store.commit("projectSelectFun", {
    //     projectId: projectObj.id,
    //     projectName: projectObj.name,
    //   });
    // }
    // if (storage.getItem("getUserSettingObj")) {
    //   let getUserSettingObj = JSON.parse(storage.getItem("getUserSettingObj"));

    //   this.$store.commit("getUserSettingInfoSelectFun", {
    //     getUserSettingInfoDateValue: getUserSettingObj.id,
    //   });
    // }
    // console.log(this.getUserSettingInfoDateValue,'--5-4-1-1-1')

    this.getLampTime = setInterval(()=>{
      if(this.projectId){
        this.lampListGet()
        
        this.projectAlarmGet();
      }
    },30000)
    
    this.userDetailsGet();
    
    
  },
  methods: {
    // zone 表示时区，正数为东时区，负数为西时区 ; givenDate为指定的时间
    getLocalTime(zone, givenDate) {
        // 获取指定的时间
        var given_ms = new Date(givenDate).getTime();
        // 本地时间与UTC时间的 时间偏移差(getTimezoneOffset的单位是min)
        var d = new Date();
        var offset_ms = d.getTimezoneOffset() * 60 * 1000;
        // 转为utc时间，因为各时区的utc时间相同
        var utc_ms = given_ms + offset_ms;
        // 计算出 目标时区 的标准时间
        var target_ms = utc_ms + zone * 60 * 60 * 1000;

        var dateTime = this.timestampToYMDHMS(target_ms);
        // console.log(dateTime, "dateTime");
        //   2024-08-16 11:25:00 dateTime   东八区
        //   2024-08-15 19:25:00 dateTime   西八区

        return dateTime;
    },
    // getLocalTime(8, new Date());
    // getLocalTime(-8, new Date());
    // 时间戳转为自定义时间日期格式
    timestampToYMDHMS(timestamp) {
        let date = new Date(timestamp);
        let year = date.getFullYear();
        let month =
            date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1;
        let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        let minutes =
            date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        let seconds =
            date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        let YMDHMS =year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
        return YMDHMS;
    },
    //项目设备数量统计
    deviceTotalStatisticsGet() {
      // if(!this.projectId){
      //   for(let key in this.alarmDeviceForm){
      //     this.alarmDeviceForm[key] = ''
      //   }
      //   return
      // }
      base.ajax_post(
        allUrl.project.project_deviceTotalStatistics,
        {
          username: this.username,
          version: this.version,
          token:this.token,
          id:this.projectId
        },
        {},
        data => {
          // console.log(data.data,'-444')
          this.deviceTotalStatisticsList = data.data
          
          // for(let key in this.projectForm){
          //   if(data.data[key]){
          //     this.projectForm[key] = data.data[key]
          //   }else{
          //     this.projectForm[key] = ''
          //   }
          // }
        },
        this
      )
    },
    exportExcelFault() {
      this.type = 0
      this.outAlarmDeviceToExcel()
    },
    exportExcelOverheats() {
      this.type = 1
      this.outAlarmDeviceToExcel()
    },
    //导出excel
    outAlarmDeviceToExcel() {
      base.ajax_post(
        allUrl.project.project_outAlarmDeviceToExcel,
        {
          username: this.username,
          version: this.version,
          token:this.token,
          id:this.projectId,
          type: this.type
        },
        {},
        data => {
          // console.log(data.data,'--1--5--444')
          this.outAlarmDevice = data.data
          base.download(this.protocolStr+'//'+this.street + '/' + data.data.path);
          // console.log(this.protocolStr+'//'+this.street + '/' + data.data.path,'444')

          // this.layoutImage = this.projectForm.image ? this.protocolStr+'//'+this.street + '/' + this.projectForm.image + '?v='+Math.random() : ''
          // for(let key in this.outAlarmDevice){
          //   if(this.outAlarmDevice[key].alarmContent){
          //     this.noticeShow = true
          //     // this.alarmDeviceForm[key] = data.data[key]
          //   }
          // }
        },
        this
      )
    },
    // 项目故障设备列表
    projectAlarmGet() {
      // if(!this.projectId){
      //   for(let key in this.alarmDeviceForm){
      //     this.alarmDeviceForm[key] = ''
      //   }
      //   return
      // }
      // console.log('--51--')
      base.ajax_post(
        allUrl.project.project_alarmDeviceList,
        {
          username: this.username,
          version: this.version,
          token:this.token,
          id:this.projectId
        },
        {},
        data => {
          // console.log(data.data,'--1--5--444')
          this.alarmDeviceList = data.data

          for(let key in this.alarmDeviceList){
            if(this.alarmDeviceList[key].alarmContent){
              if(this.alarmDeviceList.length > 0){
                this.noticeShow = true
              }
              
              // this.alarmDeviceForm[key] = data.data[key]
            }
            // console.log(this.alarmDeviceList[key].alarmContent,'444')
          }
        },
        this
      )
    },
    projectDetailsGet() {
      if(!this.projectId){
        for(let key in this.projectForm){
          this.projectForm[key] = ''
        }
        return
      }
      // console.log('--51--')
      base.ajax_post(
        allUrl.project.project_details,
        {
          username: this.username,
          version: this.version,
          token:this.token,
          id:this.projectId
        },
        {},
        data => {
          // console.log(data)
          for(let key in this.projectForm){
            if(data.data[key]){
              this.projectForm[key] = data.data[key]
            }else{
              this.projectForm[key] = ''
            }
          }
          // this.layoutImage = this.projectForm.image ? this.protocolStr+'//'+this.street + '/' + this.projectForm.image + '?v='+Math.random() : ''
          this.layoutImage = this.projectForm.image ? this.protocolStr+'//'+this.street + '/' + this.projectForm.image : ''
          // console.log(this.layoutImage,'--5--4--1--')
        },
        this
      )
    },
    getUserSelectFun(val){
       val = this.getUserSettingInfoDateValue
       let obj = null
       if(val == 'projectSettings'&&(this.role == 1||this.role == 2)){
        obj = {id:this.projectId}
       }
       console.log(val,obj,'---getUserSelectFun--')
      this.pageTypeFun(val,obj)
    },
    //退出登录
    signOut(){
      this.$confirm(this.$t('App.message.text41'), this.$t('App.message.text4'), {
        confirmButtonText: this.$t('App.message.text5'),
        cancelButtonText: this.$t('App.message.text6'),
        type: 'warning'
      }).then(() => {
        base.ajax_post(
        allUrl.login.logout,
        {
          username: this.username,
          clientType: this.os,
          token: this.token,
          version: this.version,
        },
        {},
        (data) => {
          this.$message({
            showClose: true,
            message: data.msg,
            type: "success",
          });
          this.pageType = "";
          this.pageTitle = "";
          this.$store.commit("getUserSettingInfoSelectFun", {
            getUserSettingInfoDateValue: null,
          });
        
          // localStorage.clear()
          // window.sessionStorage.clear()
          this.$router.push('/login')
        },
        this)

      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('App.message.text52')
        });
      });
    },
    leftToolbarFun() {
      if (this.groupAddDev) {
        return
      }
      // 关闭框选框
      this.frameSelectionShow = false;
      this.frameSelectionWidth = 0;
      this.frameSelectionHeight = 0;
      this.frameSelectionTop = 0;
      this.frameSelectionLeft = 0;
      this.leftToolbarShow = this.leftToolbarShow ? false : true;
      this.rightToolbarShow = false;
    },
    rightToolbarFun() {
      if (this.groupAddDev) {
        return
      }
      this.frameSelectionShow = false;
      this.frameSelectionWidth = 0;
      this.frameSelectionHeight = 0;
      this.frameSelectionTop = 0;
      this.frameSelectionLeft = 0;
      this.rightToolbarShow = this.rightToolbarShow ? false : true;
      if(this.rightToolbarShow){
        this.rightToolbariIconLeft = $('.signOut_btn_box').width();
      }
      this.leftToolbarShow = false;
      this.groupNavGet();
      this.sceneListGet();
    },
    rightToolbarTypeFun(val) {
      this.rightToolbarType = val;
    },
    dimmingTypeFun(val) {
      this.dimmingType = val;
    },
    dimming(){
      this.loading.groupBrightness = true;
      this.loading.groupColor = true;
      
      if (this.dimmingType == 1){
        // this.projectDimmingGet(()=>{
        //   this.loading.groupBrightness = false;
        // });
        this.projectColorSet(()=>{
          this.groupNavGet();
          this.lampListGet();
          this.sceneListGet();
          this.loading.groupBrightness = false;
        });
        // console.log('--88')
      }
      if (this.dimmingType == 2){
        // this.groupDimmingGet(()=>{
        //   this.loading.groupBrightness = false;
        // });
        this.groupColorSet(()=>{
          this.groupNavGet();
          this.lampListGet();
          this.sceneListGet();
          this.loading.groupBrightness = false;
        });
        
        // console.log('--89')

      }
    },
    groupBrightnessTooltip(val) {
      return val + "%";
    },
    lampBrightnessTooltip(val) {
      return val + "%";
    },
    lampColorTooltip(val) {
      return val;
    },
    kelvinToRGBA(kelvin, alpha = 1) {
        // 规范化输入范围
        kelvin = Math.max(2700, Math.min(6500, kelvin));
        
        // 关键色温采样点(基于CIE 1931色彩空间)
        const colorPoints = [
            { temp: 2700, r: 256, g: 247, b: 126 },
            { temp: 3045, r: 254, g: 248, b: 144 },
            { temp: 3390, r: 254, g: 248, b: 155 },
            { temp: 3735, r: 254, g: 249, b: 176 },
            { temp: 4080, r: 254, g: 250, b: 196 },
            { temp: 4425, r: 254, g: 251, b: 225 },
            { temp: 4772, r: 245, g: 253, b: 245 },
            { temp: 5120, r: 255, g: 255, b: 255 },
            { temp: 5465, r: 247, g: 250, b: 255 },
            { temp: 5810, r: 237, g: 249, b: 255 },
            { temp: 6155, r: 228, g: 248, b: 255 },
            { temp: 6500, r: 202, g: 2544, b: 254 }
        ];

        // 三次样条插值计算
        const interpolate = (x, x0, x1, y0, y1) => {
            const t = (x - x0) / (x1 - x0);
            return y0 + t * (y1 - y0);
        };

        // 查找最近的色温区间
        let lower, upper;
        for (let i = 0; i < colorPoints.length - 1; i++) {
            if (kelvin >= colorPoints[i].temp && kelvin <= colorPoints[i+1].temp) {
                lower = colorPoints[i];
                upper = colorPoints[i+1];
                break;
            }
        }

        // 计算RGB分量
        const r = Math.round(interpolate(kelvin, lower.temp, upper.temp, lower.r, upper.r));
        const g = Math.round(interpolate(kelvin, lower.temp, upper.temp, lower.g, upper.g));
        const b = Math.round(interpolate(kelvin, lower.temp, upper.temp, lower.b, upper.b));

        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    pageTypeFun(val, obj) {
      // console.log(this.getUserSettingInfoDateValue,'--5-4-1-1-1')
      if (val == "calendar") {
        // console.log(obj, "---555---");
        // console.log(obj.scheduleList[0].startDate,'---565---')
        // this.$emit('pageTypeFun',val, obj)
        if (obj) {
          if(Object.keys(obj.scheduleList).length == 0){
            this.$store.commit("scheduleTimeFun", {
              scheduleTime: "",
            });
          } else{
            this.$store.commit("scheduleTimeFun", {
              scheduleTime: obj.scheduleList[0].startDate,
            });
          }
          // this.$store.commit("scheduleTimeFun", {
          //   scheduleTime: obj.scheduleList[0].startDate,
          //   // projectPageId:obj.id,
          // });
        // console.log(obj, "---555---");
        } else {
          this.$store.commit("scheduleTimeFun", {
            scheduleTime: "",
            // projectPageId:'',
          });
        }
        this.pageTitle = this.projectName?this.projectName+' | '+this.$t("App.pageTitle2"):this.$t("App.pageTitle2");
      }
      if (val == "sceneSetting") {
        this.pageTitle = this.projectName?this.projectName+' | '+this.$t("App.pageTitle3"):this.$t("App.pageTitle3");
      }
      if (val == "") {
        this.pageTitle = this.projectName;
      }
       
      if (val == "systemSetting") {
        this.pageTitle = this.projectName?this.projectName+' | '+this.$t("App.pageTitle4"):this.$t("App.pageTitle4");
      }
      if (val == "gatewayInput") {
        if(this.role == 2){
          return
        }
        this.pageTitle = this.projectName?this.projectName+' | '+this.$t("App.pageTitle6"):this.$t("App.pageTitle6");
      }
      if (val == "controllerInput") {
        if(this.role == 2){
          return
        }
        this.pageTitle = this.projectName?this.projectName+' | '+this.$t("App.home.nav_btn1"):this.$t("App.home.nav_btn1");
      }
      if (val == "groupSetting") {
        this.pageTitle = this.projectName?this.projectName+' | '+this.$t("App.home.nav_btn2"):this.$t("App.home.nav_btn2");
        this.$store.commit('lampListUpdateFun', {
          lampListUpdate: this.lampListUpdate+1,
        })
      }
      if (val == "powerConsumption") {
        this.pageTitle = this.projectName?this.projectName+' | '+this.$t("App.pageTitle8"):this.$t("App.pageTitle8");
      }
      if (val == "projectSettings") {
        
        this.projectSelectShow0 = false;
        this.projectSelectShow1 = false;
        if (obj) {
          this.$store.commit("projectPageTypeFun", {
            projectPageType: "edit",
            projectPageId: obj.id,
          });
        } else {
          this.$store.commit("projectPageTypeFun", {
            projectPageType: "add",
            projectPageId: "",
          });
        }
      }
      if (val == "sceneSettingEdit") {
        // console.log(obj)
        if (obj) {
          this.$store.commit("sceneTypeFun", {
            sceneId: obj.id,
            sceneType: "edit",
          });
          obj.editShow = false;
        } else {
          this.$store.commit("sceneTypeFun", {
            sceneId: "",
            sceneType: "add",
          });
        }
        this.rightToolbarShow = false;
      }
      if(this.pageType == 'groupSetting'){
        this.$store.commit('lampListUpdateFun', {
          lampListUpdate: this.lampListUpdate+1,
        })
      }
      this.pageType = val;
      this.leftToolbarShow = false;
    },
    del(item) {
      this.$confirm(
        this.$t("App.message.text3"),
        this.$t("App.message.text4"),
        {
          confirmButtonText: this.$t("App.message.text5"),
          cancelButtonText: this.$t("App.message.text6"),
          type: "warning",
        }
      )
        .then(() => {
          // console.log(item.id);
          base.ajax_post(
            allUrl.scene.scene_del,
            {
              username: this.username,
              clientType: this.os,
              token: this.token,
              id: item.id,
            },
            {},
            (data) => {
              this.$message({
                showClose: true,
                message: data.msg,
                type: "success",
              });
              this.sceneNavGet();
            },
            this
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("App.message.text7"),
          });
        });
    },
    EditlightFun() {
      // if(this.lightControlForm.brightness!=this.lightControlForm.brightness_){
        // this.lampDimming();
      // }
      // if(this.lightControlForm.color!=this.lightControlForm.color_){
        this.lampColor();
      // }
      this.lightControlShow = this.lightControlShow ? false : true;
      if(this.lightControlForm.sceneIds!=this.lightControlForm.sceneIds_){
        this.deviceChangeScene()
      }
      if(!this.lightControlShow){
        this.mapEditDeviceForm.devId = null
      }
      this.lightContWidth = this.dragType == 1? '72rem':'86.71rem';
      if(this.version == 2){
        this.lightContWidth = this.dragType == 1? '72rem':'91rem';
      }
    },
    lightControlShowFun() {
      this.lightControlShow = this.lightControlShow ? false : true;
      if(!this.lightControlShow){
        this.mapEditDeviceForm.devId = null
      }
      this.lightContWidth = this.dragType == 1? '72rem':'86.71rem';
      if(this.version == 2){
        this.lightContWidth = this.dragType == 1? '72rem':'91rem';
      }
    },

    groupControlShowFun() {
      this.groupControlShow = this.groupControlShow ? false : true;
    },
    editGroupFun(){
      this.$store.commit("groupAddDevFun", {
        groupAddDev: false,
        groupAddDevList: this.groupAddDevList_,
        groupAddDevStr: '',
        groupAddDevIndex: this.groupAddDevIndex+1,
        groupAddDevType: 'save'
      });
      // console.log(this.groupAddDevList_,this.groupAddDevList,'--1--5--4-5')
      this.groupAddDevList_ = [];
      this.groupControlShow = false;
    },
    

    gatewayControlShowFun() {
      this.gatewayControlShow = this.gatewayControlShow ? false : true;
    },
    gatewayEditlightFun() {
      this.gatewayControlShow = this.gatewayControlShow ? false : true;
    },

    editShowFun(event,item) {
      // console.log(event.clientY + 7.5*this.remRatio,$('body').height())
      if(event.clientY + 7.5*this.remRatio>$('body').height()){
        item.showPosition = 'top'
      }else{
        item.showPosition = 'bottom'
      }
      item.editShow = item.editShow ? false : true;
    },
    // linkToFun(val,data){
    //     if(val == '/service'){
    //         if(data.alarmStatus == 1){
    //             let disConnectTime = '';
    //             if(data.disConnectTime){
    //                disConnectTime = new Date(data.disConnectTime).format("YYYY-mm-dd");
    //             }
    //             this.$router.push({path:val+'?floorId='+data.floorId+'&roomId='+data.roomId+'&deviceType=2'+'&daysDate='+disConnectTime});
    //         }
    //     }
    // }

    addMapDevice() {
      this.$set(this.mapDeviceForm.list, this.mapDeviceForm.list.length, {
        type: "0",
        name: "lights",
        deviceCount: "",
      });
    },
    draggable(element, options) {
      let this_ = this;
      const moveFn = function (event) {
        if (this_.lockStatus == "0") {
          event.preventDefault()
        }
        if (options.drag) {
          options.drag(event);
        }
      };
      const upFn = function (event) {
        if(this_.isMobile){
          document.removeEventListener("touchmove", moveFn);
          document.removeEventListener("touchend", upFn);
        }else{
          document.removeEventListener("mousemove", moveFn);
          document.removeEventListener("mouseup", upFn);
        }
        // document.removeEventListener("mousemove", moveFn);
        // document.removeEventListener("mouseup", upFn);
        document.onselectstart = null;
        document.ondragstart = null;

        this_.isDragging = false;

        if (options.end) {
          options.end(event);
        }
      };
      const container = this_.$refs.mapEditDevice;
      container.addEventListener("contextmenu", function (event) {
        if (this_.lockStatus == "0") {
          event.preventDefault();
        }
        event.returnvalue = false;
        return false;
      });

      element.addEventListener("contextmenu", function (event) {
        if (this_.lockStatus == "0") {
          event.preventDefault();
        }
        event.returnvalue = false;
        return false;
      });
      const container_ = this_.$refs.planebaseMap;
      const rect_ = container_.getBoundingClientRect();
      
      if(this_.isMobile){

        element.addEventListener("touchstart", function (event) {
          if (this_.lockStatus == "0"&&this.groupAddDev) {
            event.preventDefault();
          }
          this_.leftToolbarShow = false;
          this_.rightToolbarShow = false;
          let offsetLeft = event.target.offsetLeft;
          let offsetTop = event.target.offsetTop;
          event = event.touches[0];
          // console.log(event.target.className.split(" ")[0], "-----------");
          // console.log(event, "-----------");
          this_.offsetX = event.pageX - offsetLeft;
          this_.offsetY = event.pageY - offsetTop - 5.79*this_.remRatio;
          this_.buttonType = '0';
          if (event.target.className.split(" ")[0] == "right_click_menu_bg") {
            this_.rightClickMenuShow = false;
            this_.rightClickMenu_copy_Show = false;
            // this_.rightClickMenu_paste_Show = false;
            this_.rightClickMenu_delete_Show = false;
          }
          if (event.target.className.split(" ")[0] == "scene_map_box") {
            this_.dragType = "-1";
            this_.frameSelectionLeft = this_.offsetX;
            this_.frameSelectionTop = this_.offsetY;

            this_.frameSelectionIsShow = false;
            this_.frameSelectionShow = false;
            if(!this_.groupAddDev){
              for (let d of this_.mapDevList) {
                this_.$set(d, "frameSelection", 0);
              }
            }
            this_.rightClickMenuShow = false;

            this_.rightClickMenu_copy_Show = false;
            this_.rightClickMenu_delete_Show = false;
          } else if (event.target.className.split(" ")[0] == "map_device") {
            this_.dragType = event.target.className.split(" ")[2].split("_")[1];
            this_.dragDeviceId = event.target.className.split(" ")[1].split("_")[1];
            this_.isSave = false;
            this_.isSaveTime = setTimeout(function () {
              this_.isSave = true;
            }, 200);
          }
          //  else if (event.target.className.split(" ")[0] == "map_gateway") {
          //   this_.dragType = event.target.className.split(" ")[1].split("_")[1];
          //   this_.dragDeviceId = event.target.className.split(" ")[2];
          //   this_.isSave = false;
          //   this_.isSaveTime = setTimeout(function () {
          //     this_.isSave = true;
          //   }, 200);
          // } 
          else if (event.target.className.split(" ")[0] == "move") {
            // console.log("------", event);
            this_.moveLeft = event.clientX - rect_.left - this_.offsetX;
            this_.moveTop = event.clientY - rect_.top - this_.offsetY;

            this_.dragType = "-2";
            this_.dragDeviceId = "";
          } else if (event.target.className.split(" ")[0] == "click_menu_move_top") {
            // this_.clickMenuMoveTop
            this_.dragType = "-3";
            // this_.clickMenuMoveLeft = event.clientX - rect_.left - event.offsetX;
            // this_.clickMenuMoveTop = event.clientY - rect_.top - event.offsetY;
          } else {
            this_.dragType = "";
            this_.dragDeviceId = "";
          }
          if (this_.isDragging) return;
          document.onselectstart = function () {
            return false;
          };
          document.ondragstart = function () {
            return false;
          };

          document.addEventListener("touchmove", moveFn);
          document.addEventListener("touchend", upFn);
          this_.isDragging = true;

          if (options.start) {
            options.start(event);
          }
        });
      }else{
          
        element.addEventListener("mousedown", function (event) {
          this_.leftToolbarShow = false;
          this_.rightToolbarShow = false;
          // console.log(event.target.className.split(" ")[0], "-----------");
          this_.offsetX = event.offsetX;
          this_.offsetY = event.offsetY;
          this_.buttonType = event.button;
          if (event.target.className.split(" ")[0] == "right_click_menu_bg") {
            this_.rightClickMenuShow = false;
            this_.rightClickMenu_copy_Show = false;
            // this_.rightClickMenu_paste_Show = false;
            this_.rightClickMenu_delete_Show = false;
          }
          if (event.target.className.split(" ")[0] == "scene_map_box") {
            this_.dragType = "-1";
            this_.frameSelectionLeft = event.offsetX;
            this_.frameSelectionTop = event.offsetY;

            this_.frameSelectionIsShow = false;
            this_.frameSelectionShow = false;
            if(!this_.groupAddDev){
              for (let d of this_.mapDevList) {
                this_.$set(d, "frameSelection", 0);
              }
            }
            this_.rightClickMenuShow = false;

            this_.rightClickMenu_copy_Show = false;
            this_.rightClickMenu_delete_Show = false;
          } else if (event.target.className.split(" ")[0] == "map_device") {
            this_.dragType = event.target.className.split(" ")[2].split("_")[1];
            this_.dragDeviceId = event.target.className.split(" ")[1].split("_")[1];
            this_.isSave = false;
            this_.isSaveTime = setTimeout(function () {
              this_.isSave = true;
            }, 200);
          }
          //  else if (event.target.className.split(" ")[0] == "map_gateway") {
          //   this_.dragType = event.target.className.split(" ")[1].split("_")[1];
          //   this_.dragDeviceId = event.target.className.split(" ")[2];
          //   this_.isSave = false;
          //   this_.isSaveTime = setTimeout(function () {
          //     this_.isSave = true;
          //   }, 200);
          // } 
          else if (event.target.className.split(" ")[0] == "move") {
            // console.log("------", event);
            this_.moveLeft = event.clientX - rect_.left - event.offsetX;
            this_.moveTop = event.clientY - rect_.top - event.offsetY;

            this_.dragType = "-2";
            this_.dragDeviceId = "";
          } else if (event.target.className.split(" ")[0] == "click_menu_move_top") {
            // this_.clickMenuMoveTop
            this_.dragType = "-3";
            // this_.clickMenuMoveLeft = event.clientX - rect_.left - event.offsetX;
            // this_.clickMenuMoveTop = event.clientY - rect_.top - event.offsetY;
          } else {
            this_.dragType = "";
            this_.dragDeviceId = "";
          }
          if (this_.isDragging) return;
          document.onselectstart = function () {
            return false;
          };
          document.ondragstart = function () {
            return false;
          };

          document.addEventListener("mousemove", moveFn);
          document.addEventListener("mouseup", upFn);
          this_.isDragging = true;

          if (options.start) {
            options.start(event);
          }
        });
      }
    },
    handleDrag(event, type) {
      
      if(this.isMobile){
        if(event.touches[0]){
          event = event.touches[0];
        }
      }

      let this_ = this;
      const container = this.$refs.planebaseMap;
      const rect = container.getBoundingClientRect();
      let left = event.clientX - rect.left;
      let top = event.clientY - rect.top;
      left = Math.max(0, left);
      left = Math.min(left, rect.width);

      top = Math.max(0, top);
      top = Math.min(top, rect.height);
      if (this.buttonType == "0") {
        //左键
        if (this.dragType == "-1") {
          //点击背景
          if (type == "drag"&&this.groupAddDev) {
            //拖动
            this.frameSelectionShow = true;
            if (top <= this.offsetY) {
              this.frameSelectionTop = top;
              this.frameSelectionHeight = this.offsetY - top;
              // console.log(top)
            } else {
              this.frameSelectionHeight = top - this.offsetY;
            }
            if (left <= this.offsetX) {
              this.frameSelectionLeft = left;
              this.frameSelectionWidth = this.offsetX - left;
            } else {
              this.frameSelectionWidth = left - this.offsetX;
            }
            this.frameSelectionIsShow = false;
            // if(!this.groupAddDev){
            //   for (let d of this.mapDevList) {
            //     if (
            //       (this.frameSelectionLeft < d.x1 && d.x1 < this.frameSelectionLeft + this.frameSelectionWidth &&
            //         ((this.frameSelectionTop < d.y1 && d.y1 < this.frameSelectionTop + this.frameSelectionHeight) || 
            //         (this.frameSelectionTop < d.y2 && d.y2 < this.frameSelectionTop + this.frameSelectionHeight))) ||
            //       (this.frameSelectionLeft < d.x2 && d.x2 < this.frameSelectionLeft + this.frameSelectionWidth &&
            //         ((this.frameSelectionTop < d.y2 && d.y2 < this.frameSelectionTop + this.frameSelectionHeight) ||
            //           (this.frameSelectionTop < d.y1 && d.y1 < this.frameSelectionTop + this.frameSelectionHeight)))
            //     ) {
            //       this.$set(d, "frameSelection", 1);
            //       this.frameSelectionIsShow = true;
            //     } else {
            //       if(!this.groupAddDev){
            //         this.$set(d, "frameSelection", 0);
            //       }
            //     }
            //   }
            // }
          }
          if (type == "end") {
            //结束
            // console.log(this.mapDevicePasteIsTrue,'----粘贴----')
            // if (this.mapDevicePasteIsTrue) {
            //   // 粘贴
            //   console.log(this.mapDeviceCopyList);
            //   this.copyDevList({
            //     clickLocationX:
            //       (((event.clientX - rect.left) / rect.width) * 100).toFixed(
            //         4
            //       ) + "%",
            //     clickLocationY:
            //       (((event.clientY - rect.top) / rect.height) * 100).toFixed(
            //         4
            //       ) + "%",
            //     devList: this.mapDeviceCopyList,
            //   });
            //   this.frameSelectionIsShow = false;
            //   this.frameSelectionShow = false;

            //   this.rightClickMenuShow = false;
            //   this.rightClickMenu_copy_Show = false;
            //   this.rightClickMenu_paste_Show = false;
            //   this.rightClickMenu_delete_Show = false;
            //   for (let d of this.mapDevList) {
            //     this.$set(d, "frameSelection", 0);
            //   }
            //   this.mapDevicePasteIsTrue = false;
            // }
            if (this.groupAddDev) {
              // console.log(window.event.ctrlKey)
              // let groupAddDevList = [];
              // console.log(this.mapDevList,'---sds-ds-d-s-d-s')
              this.groupAddDevList_ = [];
              for (let d of this.mapDevList) {
                if (
                  (this.frameSelectionLeft < d.x1 &&
                    d.x1 < this.frameSelectionLeft + this.frameSelectionWidth &&
                    ((this.frameSelectionTop < d.y1 &&
                      d.y1 <
                      this.frameSelectionTop + this.frameSelectionHeight) ||
                      (this.frameSelectionTop < d.y2 &&
                        d.y2 <
                        this.frameSelectionTop + this.frameSelectionHeight))) ||
                  (this.frameSelectionLeft < d.x2 &&
                    d.x2 < this.frameSelectionLeft + this.frameSelectionWidth &&
                    ((this.frameSelectionTop < d.y2 &&
                      d.y2 <
                      this.frameSelectionTop + this.frameSelectionHeight) ||
                      (this.frameSelectionTop < d.y1 &&
                        d.y1 <
                        this.frameSelectionTop + this.frameSelectionHeight)))
                ) {
                  if(d.frameSelection == 1){
                    this.$set(d, "frameSelection", 0);
                  }else{
                    this.$set(d, "frameSelection", 1);
                  }
                }
                if (d.frameSelection == 1) {
                  this.groupAddDevList_.push({
                    id: d.id,
                    lampAddress: d.address,
                    type: d.type,
                    name: d.name,
                  })
                }
              }
              this.frameSelectionShow = false;
              this.frameSelectionWidth = 0;
              this.frameSelectionHeight = 0;
              this.frameSelectionTop = 0;
              this.frameSelectionLeft = 0;
            }
            if (this.frameSelectionIsShow) {
              this.frameSelectionTop_ = this.frameSelectionTop;
              this.frameSelectionLeft_ = this.frameSelectionLeft;
            } else {
              this.frameSelectionShow = false;
              this.frameSelectionWidth = 0;
              this.frameSelectionHeight = 0;
              this.frameSelectionTop = 0;
              this.frameSelectionLeft = 0;
            }
          }
        } else if (this.dragType == "0" ||this.dragType == "1" || this.dragType == "2" || this.dragType == "3" || this.dragType == "4" || this.dragType == "5" || this.dragType == "6" || this.dragType == "7") {
          //点击设备
          if (this_.isSave) {
            this.svpanelLeft = left - this.offsetX;
            this.svpanelTop = top - this.offsetY;
            // console.log(this.svpanelLeft,this.svpanelTop)
            if (this.svpanelLeft > rect.width - this.clientWidth[this.dragType]) {
              this.svpanelLeft = rect.width - this.clientWidth[this.dragType];
            }
            if (this.svpanelLeft < 0) {
              this.svpanelLeft = 0;
            }
            if (this.svpanelTop > rect.height - this.clientHeight) {
              this.svpanelTop = rect.height - this.clientHeight;
            }
            if (this.svpanelTop < 0) {
              this.svpanelTop = 0;
            }
            let locationX = '',locationY = '';
            for (let d of this.mapDevList) {
              if (d.id == this.dragDeviceId && d.type == this.dragType) {
                
                if (!(type == "end"&&this.isMobile)) {
                    this.$set( d, "locationX", ((this.svpanelLeft / rect.width) * 100).toFixed(4) + "%" );
                    this.$set( d, "locationY", ((this.svpanelTop / rect.height) * 100).toFixed(4) + "%" );
                }
                locationX = d.locationX;
                locationY = d.locationY;
                this.$set(d, "x1", this.svpanelLeft.toFixed(4));
                this.$set(d, "y1", this.svpanelTop.toFixed(4));
                this.$set(d, "x2", this.svpanelLeft.toFixed(4) + Number(this.clientWidth[this.dragType].toFixed(4)) );
                this.$set(d, "y2", this.svpanelTop.toFixed(4) + Number(this.clientHeight[this.dragType].toFixed(4)) );
                // this.deviceTipsShow = false;
                this.deviceInfoUpdate = false;
                // this.deviceInfoUpdate = true;
              }
            }
            if (type == "end") {
              this.deviceInfoUpdate = true;
              this.setDevLocation({
                devList: [
                  {
                    devId: this.dragDeviceId,
                    type: this.dragType,
                    locationX: locationX,
                    locationY: locationY,
                  },
                ],
              });
              clearTimeout(this.isSaveTime);
              this.isSave = false;
            }
          } else {
            if (type == "end"&&!this.groupAddDev) {
              clearTimeout(this.isSaveTime);
              this.isSave = false;
              // console.log(this.dragDeviceId,this.dragType)
              for (let d of this.mapDevList) {
                if (d.id == this.dragDeviceId && d.type == this.dragType) {
                  // console.log(d)
                  this.mapEditDeviceForm.devId = d.id;
                  // console.log(d.type,'--999---')
                  //灯控
                  if(this.dragType == 0) {
                    this.lampDetailsGet(data=>{
                      for (let key in this.lightControlForm) {
                        // console.log(key);
                        if (data.data[key] ||data.data[key] === 0 ||data.data[key] === "0") {
                          this.lightControlForm[key] = data.data[key];
                        }
                        if(this.lightControlForm.alarmStatus == 1){
                          this.lightControlForm.devStatus = 2;
                        }else{
                          if(this.lightControlForm.online == 1){
                            this.lightControlForm.devStatus = 1

                          }else{
                            this.lightControlForm.devStatus = 0
                          }
                        }
                      }
                      this.$set(this.lightControlForm, "brightness_", this.lightControlForm.brightness);
                      this.$set(this.lightControlForm, "color_", this.lightControlForm.color);
                      let sceneStr = "";
                      let sceneIds = [];
                      if (data.data.sceneList.length > 0) {
                        this.lampSceneNavList = data.data.sceneList;
                        for (let d of data.data.sceneList) {
                          if(d.status == 1){
                            if (sceneStr.length == 0) {
                              sceneStr = d.name;
                            } else {
                              sceneStr = sceneStr + "," + d.name;
                            }
                            sceneIds.push(d.id)

                          }
                          // console.log(d.name,'---789---')
                        }
                        // console.log(data.data.sceneList,'---5555---')
                      }else{
                        this.lampSceneNavList = [];
                      }
                        // console.log(sceneStr,sceneIds,'---5555---')
                      this.$set(this.lightControlForm, "sceneStr", sceneStr);
                      this.$set(this.lightControlForm, "sceneIds", sceneIds);
                      this.$set(this.lightControlForm, "sceneIds_", sceneIds);

                      let groupStr = "";
                      let groupIds = "";
                      if (data.data.groupList.length > 0) {
                        this.lampGroupNavList = data.data.groupList;
                        for (let d of data.data.groupList) {
                          if (groupStr == "") {
                            groupStr = d.name;
                            groupIds = d.id+'';
                          } else {
                            groupStr = groupStr + "," + d.name;
                            groupIds = groupIds + "," + d.id;
                          }
                        }
                      }
                      // console.log(groupStr,groupIds)
                      this.$set(this.lightControlForm, "groupStr", groupStr);
                      this.$set(this.lightControlForm, "groupIds", groupIds);
            
                      this.mapEditDeviceForm.address = d.deviceId;
                      this.mapEditDeviceForm.gatewayId = d.gatewayId;
                      this.mapEditDeviceForm.type = d.type;
                      this.mapEditDeviceForm.number = d.number;
                      this.mapEditDeviceForm.name = d.name;
                      this.lightControlShow = true;
                      this.lightContWidth = this.dragType == 1? '72rem':'86.71rem';
                      if(this.version == 2){
                        this.lightContWidth = this.dragType == 1? '72rem':'91rem';
                      }
                    });
                  }
                  //网关
                  if(this.dragType == 1) {
                    this.gatewayDetailsGet(data=>{
                    for (let key in this.lightControlForm) {
                      // console.log(key);
                      if (data.data[key] ||data.data[key] === 0 ||data.data[key] === "0") {
                        this.lightControlForm[key] = data.data[key];
                      }
                    }
                      // this.mapEditDeviceForm.address = d.deviceId;
                      // this.mapEditDeviceForm.gatewayId = d.gatewayId;
                      // this.mapEditDeviceForm.type = d.type;
                      // this.mapEditDeviceForm.number = d.number;
                      // this.mapEditDeviceForm.name = d.name;
                      this.lightControlShow = true;
                      this.lightContWidth = this.dragType == 1? '72rem':'86.71rem';
                      if(this.version == 2){
                        this.lightContWidth = this.dragType == 1? '72rem':'91rem';
                      }
                    });
                  }
                  break;
                  // this.getfloorNav(() => {
                  //   if (this.floorNav.length > 0) {
                  //     this.mapEditDeviceForm.floorId = this.floorId;
                  //     this.getRoomNav(this.mapEditDeviceForm.floorId, () => {
                  //       if (this.roomNav.length > 0) {
                  //         this.mapEditDeviceForm.roomId = d.roomId;
                  //       }
                  //     })
                  //   }
                  // })
                }
              }
              // 网关详情
              // for (let d of this.gatewayList) {
              //   console.log(d,'----748454----')
              //   if (d.id == this.gatewayId && d.type == this.dragType) {
              //     console.log(d,'----7----')
              //     // this.gatewayId = d.id;
              //     this.mapEditDeviceForm.gatewayId = d.id;
              //     this.gatewayDetailsGet(data=>{
              //       for (let key in this.gatewayControlForm) {
              //         console.log(key);
              //         if (data.data[key] ||data.data[key] === 0 ||data.data[key] === "0") {
              //           this.gatewayControlForm[key] = data.data[key];
              //         }
              //       }
                    
              //       // this.mapEditDeviceForm.address = d.deviceId;
              //       // this.mapEditDeviceForm.gatewayId = d.gatewayId;
              //       // this.mapEditDeviceForm.type = d.type;
              //       // this.mapEditDeviceForm.number = d.number;
              //       // this.mapEditDeviceForm.name = d.name;
              //       this.gatewayControlShow = true;
              //     });
              //     // this.getfloorNav(() => {
              //     //   if (this.floorNav.length > 0) {
              //     //     this.mapEditDeviceForm.floorId = this.floorId;
              //     //     this.getRoomNav(this.mapEditDeviceForm.floorId, () => {
              //     //       if (this.roomNav.length > 0) {
              //     //         this.mapEditDeviceForm.roomId = d.roomId;
              //     //       }
              //     //     })
              //     //   }
              //     // })
              //   }
              // }
              this.mapEditDeviceTkShowbg = true;
              this.$nextTick(function () {
                this.mapEditDeviceTkShow = true;
                // this.deviceTipsShow = false;
                this.deviceInfoUpdate = true;
              });
            }
          }
        } else if (this.dragType == "-2") {
          if (this.groupAddDev) {
            return
          }
          if (type == "drag") {
            this.svpanelLeft = left - this.offsetX;
            this.svpanelTop = top - this.offsetY;
            if (this.svpanelLeft > rect.width - this.clientWidth[this.dragType]) {
              this.svpanelLeft = rect.width - this.clientWidth[this.dragType];
            }
            if (this.svpanelLeft < 0) {
              this.svpanelLeft = 0;
            }
            if (this.svpanelTop > rect.height - this.clientHeight) {
              this.svpanelTop = rect.height - this.clientHeight;
            }
            if (this.svpanelTop < 0) {
              this.svpanelTop = 0;
            }
            this.frameSelectionTop =
              this.frameSelectionTop_ + this.svpanelTop - this.moveTop;
            this.frameSelectionLeft =
              this.frameSelectionLeft_ + this.svpanelLeft - this.moveLeft;
            for (let d of this.mapDevList) {
              if (d.frameSelection == 1) {
                this.$set(
                  d,
                  "locationX",
                  (
                    ((Number(d.x1) + this.svpanelLeft - this.moveLeft) /
                      rect.width) *
                    100
                  ).toFixed(4) + "%"
                );
                this.$set(
                  d,
                  "locationY",
                  (
                    ((Number(d.y1) + this.svpanelTop - this.moveTop) /
                      rect.height) *
                    100
                  ).toFixed(4) + "%"
                );
              }
            }
          }
          if (type == "end") {
            let devList = [];
            for (let d of this.mapDevList) {
              if (d.frameSelection == 1) {
                this.$set(
                  d,
                  "x1",
                  (Number(d.x1) + this.svpanelLeft - this.moveLeft).toFixed(4)
                );
                this.$set(
                  d,
                  "y1",
                  (Number(d.y1) + this.svpanelTop - this.moveTop).toFixed(4)
                );
                this.$set(
                  d,
                  "x2",
                  (Number(d.x1) + this.svpanelLeft - this.moveLeft).toFixed(4) +
                  Number(this.clientWidth[this.dragType].toFixed(4))
                );
                this.$set(
                  d,
                  "y2",
                  (Number(d.y1) + this.svpanelTop - this.moveTop).toFixed(4) +
                  Number(this.clientHeight[this.dragType].toFixed(4))
                );
                devList.push({
                  devId: d.id,
                  type: d.type,
                  locationX: d.locationX,
                  locationY: d.locationY,
                });
              }
            }
            this.setDevLocation({
              devList: devList,
            });
            this.frameSelectionTop_ = this.frameSelectionTop;
            this.frameSelectionLeft_ = this.frameSelectionLeft;
            this.moveLeft = this.svpanelLeft;
            this.moveTop = this.svpanelTop;
            // console.log(this.moveLeft, this.moveTop);
          }
        } else if (this.dragType == "-3") {
          this.svpanelLeft = left - this.offsetX;
          this.svpanelTop = top - this.offsetY;
          // console.log(this.svpanelLeft,rect.width - this.clickMenuMoveWidth)
          if (this.svpanelLeft > rect.width - this.clickMenuMoveWidth) {
            this.svpanelLeft = rect.width - this.clickMenuMoveWidth;
          }
          if (this.svpanelLeft < 0) {
            this.svpanelLeft = 0;
          }
          if (this.svpanelTop > rect.height - this.clickMenuMoveHeight) {
            this.svpanelTop = rect.height - this.clickMenuMoveHeight;
          }
          if (this.svpanelTop < 0) {
            this.svpanelTop = 0;
          }
          // console.log(this.clickMenuMoveTop)
          this.clickMenuMoveTop = this.svpanelTop;
          this.clickMenuMoveLeft = this.svpanelLeft;
        }
      }
      //右键
      if (this.buttonType == "2") {
        if (type == "end") {
          // if(event.target.className.split(' ')[0] == 'right_click_menu_bg'){
           
          //     this.rightClickMenuShow = false;
          //     this.rightClickMenu_copy_Show = false;
          //     this.rightClickMenu_paste_Show = false;
          //     this.rightClickMenu_delete_Show = false;
          // }

          if (event.target.className.split(" ")[0] == "map_device") {
            // console.log(this.buttonType, this.dragType,this.dragDeviceId,'-----')
            this.devDelId = this.dragDeviceId;
            this.devDelType = this.dragType;
            this.clickMenuMoveShow = true;
            this.rightClickMenuLeft = ((event.clientX - rect.left)/ rect.width * 100).toFixed(4)+'%';
           this.rightClickMenuTop = ((event.clientY - rect.top)/ rect.height * 100).toFixed(4)+'%';

            // this.$confirm(
            //   this.$t("App.message.text3"),
            //   this.$t("App.message.text4"),
            //   {
            //     confirmButtonText: this.$t("App.message.text5"),
            //     cancelButtonText: this.$t("App.message.text6"),
            //     type: "warning",
            //   }
            // )
            // .then(() => {
              if(this.dragType == 0){
                // this.pageTypeFun('controllerInput')
                // this.lampDel(this.dragDeviceId)

              }
              if(this.dragType == 1){
                // this.gatewayDel(this.dragDeviceId)
                // this.pageTypeFun('gatewayInput')
              }
            // })
            // .catch(() => {
            //   this.$message({
            //     type: "info",
            //     message: this.$t("App.message.text7"),
            //   });
            // });
            
          //   this.rightClickMenuDevId = event.target.className.split(" ")[2];
          //   this.rightClickMenuLeft =
          //     (((event.clientX - rect.left) / rect.width) * 100).toFixed(4) +
          //     "%";
          //   this.rightClickMenuTop =
          //     (((event.clientY - rect.top) / rect.height) * 100).toFixed(4) +
          //     "%";

          //   this.selectDevId = event.target.className.split(" ")[2];

          //   this.selectDevType = event.target.className.split(" ")[1].split("_")[1];

          //   this.rightClickMenuShow = true;
          //   this.rightClickMenu_copy_Show = true;
          //   this.rightClickMenu_paste_Show = false;
          //   this.rightClickMenu_delete_Show = true;
          //   this.rightClickMenuType = 1;
          }
          if (event.target.className.split(" ")[0] == "frame_selection") {
            this.rightClickMenuLeft =
              (((event.clientX - rect.left) / rect.width) * 100).toFixed(4) +
              "%";
            this.rightClickMenuTop =
              (((event.clientY - rect.top) / rect.height) * 100).toFixed(4) +
              "%";

            this.rightClickMenuShow = true;
            this.rightClickMenu_copy_Show = true;
            this.rightClickMenu_paste_Show = false;
            this.rightClickMenu_delete_Show = true;
            this.rightClickMenuType = 2;
          }
          if (event.target.className.split(" ")[0] == "scene_map_box") {
            this.rightClickMenuLeft =
              ((event.offsetX / rect.width) * 100).toFixed(4) + "%";
            this.rightClickMenuTop =
              ((event.offsetY / rect.height) * 100).toFixed(4) + "%";

            this.clickLocationX =
              (((event.clientX - rect.left) / rect.width) * 100).toFixed(4) +
              "%";
            this.clickLocationY =
              (((event.clientY - rect.top) / rect.height) * 100).toFixed(4) +
              "%";
            if (this.mapDeviceCopyList.length > 0) {
              this.rightClickMenu_paste_Show = true;
            }
            if (this.rightClickMenu_paste_Show) {
              this.rightClickMenuShow = true;
            }
          }
        }
      }
      // console.log(left,top,this.dragType,this.clientWidth)
    },
    rightClickMenuClose() {
      this.clickMenuMoveShow = false;
      this.rightClickMenuShow = false;
      this.rightClickMenu_copy_Show = false;
      // this.rightClickMenu_paste_Show = false;
      this.rightClickMenu_delete_Show = false;
    },
    mapDeviceCopy(type) {
      if (type == "click") {
        let isTrue = true;
        this.rightClickMenuType = 2;
        for (let d of this.mapDevList) {
          if (d.frameSelection == 1) {
            isTrue = false;
          }
        }
        if (isTrue) {
          this.$message({
            message: "Please select the devices",
            type: "warning",
          });
          return;
        }
      }
      this.rightClickMenuShow = false;
      this.rightClickMenu_copy_Show = false;
      this.rightClickMenu_paste_Show = true;
      this.rightClickMenu_delete_Show = false;
      this.mapDeviceCopyList = [];
      if (this.rightClickMenuType == 1) {
        for (let d of this.mapDevList) {
          if (d.id == this.rightClickMenuDevId) {
            this.mapDeviceCopyList.push({
              type: d.type,
              locationX: parseFloat(d.locationX),
              locationY: parseFloat(d.locationY),
            });
          }
        }
      } else {
        for (let d of this.mapDevList) {
          if (d.frameSelection == 1) {
            this.mapDeviceCopyList.push({
              type: d.type,
              locationX: parseFloat(d.locationX),
              locationY: parseFloat(d.locationY),
            });
          }
        }
      }
      if (type == "click") {
        this.frameSelectionShow = false;
      }
      // console.log(this.mapDeviceCopyList, this.rightClickMenuType);
    },
    // mapDevicePaste(type) {
    //   if (type == "click") {
    //     if (this.mapDevicePasteIsTrue) {
    //       this.mapDevicePasteIsTrue = false;
    //     } else {
    //       if (this.mapDeviceCopyList.length > 0) {
    //         this.mapDevicePasteIsTrue = true;
    //       } else {
    //         this.$message({
    //           message: "Please copy the device first",
    //           type: "warning",
    //         });
    //       }
    //     }
    //   } else {
    //     this.copyDevList({
    //       clickLocationX: this.clickLocationX,
    //       clickLocationY: this.clickLocationY,
    //       devList: this.mapDeviceCopyList,
    //     });
    //     this.frameSelectionIsShow = false;
    //     this.frameSelectionShow = false;

    //     this.clickMenuMoveShow = false;
    //     this.rightClickMenu_copy_Show = false;
    //     this.rightClickMenu_paste_Show = false;
    //     this.rightClickMenu_delete_Show = false;
    //     for (let d of this.mapDevList) {
    //       this.$set(d, "frameSelection", 0);
    //     }
    //   }
    // },
    mapDeviceDel() {
      // if (type == "click") {
      //   let devList = [];
      //   for (let d of this.mapDevList) {
      //     if (d.frameSelection == 1) {
      //       devList.push({
      //         id: d.id,
      //         type: d.type,
      //       });
      //     }
      //   }
      //   console.log(devList, this.mapDevList);
      //   if (devList.length == 0) {
      //     this.$message({
      //       message: "Please select the devices",
      //       type: "warning",
      //     });
      //     return;
      //   }
      //   this.rightClickMenuType = 2;
      // }
      this.$confirm(
        this.$t("App.message.text3"),
        this.$t("App.message.text4"),
        {
          confirmButtonText: this.$t("App.message.text5"),
          cancelButtonText: this.$t("App.message.text6"),
          type: "warning",
        }
      )
      .then(() => {
        // let devList = [];
            // console.log(this.buttonType, this.devDelType,this.devDelId,'--99199---')
            if(this.devDelType == 0){
              // this.pageTypeFun('controllerInput')
              this.lampDel(this.devDelId)
            }
            if(this.devDelType == 1){
              this.gatewayDel(this.devDelId)
              // this.pageTypeFun('gatewayInput')
            }
        // this.frameSelectionIsShow = false;
        // this.frameSelectionShow = false;

        this.rightClickMenuShow = false;
        this.clickMenuMoveShow = false;
        // this.rightClickMenu_copy_Show = false;
        // this.rightClickMenu_paste_Show = false;
        // this.rightClickMenu_delete_Show = false;
        // for (let d of this.mapDevList) {
        //   this.$set(d, "frameSelection", 0);
        // }
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: this.$t("App.message.text7"),
        });
      });
    },
    //删除灯控
    lampDel(id) {
      base.ajax_post(
        allUrl.lamp.lamp_del,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          id: id,
        },
        {},
        (data) => {
          this.lampListGet();
          this.$message({
            showClose: true,
            message: data.msg,
            type: "success",
          });
        },
        this
      )
    },
    //删除网关
    gatewayDel(id) {
      base.ajax_post(
        allUrl.gateway.gateway_del,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          id: id,
        },
        {},
        (data) => {
          this.lampListGet();
          this.$message({
            showClose: true,
            message: data.msg,
            type: "success",
          });
        },
        this
      )
    },
    //编辑网关
    gatewayUpdate() {
      // let d = JSON.parse(JSON.stringify(obj))
      base.ajax_post(
        allUrl.gateway.gateway_update,
        {
          username: this.username,
          version: this.version,
          token:this.token,
          id: this.mapEditDeviceForm.devId,
          name: this.gatewayDetailsList.name,
          address: this.gatewayDetailsList.address,
          description: this.gatewayDetailsList.description,
          expirationDate: this.gatewayDetailsList.expirationDate,
        },
        {},
        data => {
          for(let d of this.gatewayList){
            d.dataType = 'text'
          }
          this.$message({
            showClose: true,
            message: data.msg,
            type: 'success'
          });
          // console.log(this.gatewayList)
        },
        this
      )
    },
    /*修改设备位置信息*/
    setDevLocation(data) {
      // console.log(data.devList);
      let devId = "";
      let locationX = "";
      let locationY = "";
      // if(data.length == 1){
      devId = data.devList[0].devId;
      let type = data.devList[0].type;
      locationX = data.devList[0].locationX;
      locationY = data.devList[0].locationY;

      locationX = locationX.replace("%", "");
      locationY = locationY.replace("%", "");
      // }
      base.ajax_post(
        allUrl.lamp.lamp_updateLocation,
        {
          username: this.username,
          client_key: this.client_key,
          token: this.token,
          id: devId,
          type: type,
          locationX: locationX,
          locationY: locationY,
        },
        {},
        (data) => {
          this.$message({
            showClose: true,
            message: data.msg,
            type: "success",
          });
        },
        this
      );
    },
    /*拷贝设备*/
    // copyDevList(data) {
      // console.log(data);
      // base.ajax_post(
      //   allUrl.room.copyDevList,
      //   {
      //     username: this.username,
      //     client_key: this.client_key,
      //     token: this.token,
      //     floorId: this.floorId,
      //     clickLocationX: data.clickLocationX,
      //     clickLocationY: data.clickLocationY,
      //     devList: data.devList,
      //   },
      //   {},
      //   data => {
      //     this.mapDeviceCopyList = [];
      //     this.getPlaneLayoutInfo('0');
      //     this.$message({
      //       showClose: true,
      //       message: data.msg,
      //       type: 'success'
      //     });
      //   },
      //   this
      // )
    // },
    /*删除设备*/
    // delDevList(data) {
      // console.log(data);
      // if (data.devList.length > 0) {
      //   base.ajax_post(
      //     allUrl.room.delDev,
      //     {
      //       username: this.username,
      //       client_key: this.client_key,
      //       token: this.token,
      //       devList: data.devList,
      //     },
      //     {},
      //     data => {
      //       this.getPlaneLayoutInfo('0');
      //       this.$message({
      //         showClose: true,
      //         message: data.msg,
      //         type: 'success'
      //       });
      //     },
      //     this
      //   )
      // }
    // },
    sceneApply(obj) {
      if (obj.sceneApplying) {
        return
      }
      let status = 0;
      if(obj.status == 1){
        status = 0;
      }else{
        status = 1;
      }
      obj.sceneApplying = true;
      base.ajax_post(
        allUrl.scene.scene_apply,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          id: obj.id,
          status:status,
        },
        {},

        data => {
          this.$message({
            showClose: true,
            message: data.msg,
            type: 'success'
          });

          obj.sceneApplying = false;
          this.sceneListGet();
        },
        this, () => {
          obj.sceneApplying = false;
        })

        // (data) => {
        //   this.$message({
        //     showClose: true,
        //     message: data.msg,
        //     type: "success",
        //   });
        //   this.sceneNavGet();
        // },
        // this)
      ;
    },
    groupItemClick(data) {
      // obj.groupIds
      let idss = data.id;
      let groupNames = this.lightControlForm.groupStr;
      let groupIds = this.lightControlForm.groupIds;
      if (groupIds.indexOf(idss) == -1) {
        if (groupNames == "") {
          groupNames = data.name;
          groupIds = idss;
        } else {
          groupNames = groupNames + "," + data.name;
          groupIds = groupIds + "," + idss;
        }
      } else {
        let names = "";
        if (groupIds.indexOf(idss) == 0) {
          idss = idss + ",";
          names = data.name + ",";
        } else {
          idss = "," + idss;
          names = "," + data.name;
        }
        groupIds = groupIds.replace(idss, "");
        groupNames = groupNames.replace(names, "");
        // groupIds = groupIds.slice(obj.groupIds.indexOf(idss),idss.length);
      }
      // for(let d of this.groupNavList){
      //   if(d.select == 1){
      //   }
      // }
      // console.log(groupIds, groupNames);
      this.$set(this.lightControlForm, "groupStr", groupNames);
      this.$set(this.lightControlForm, "groupIds", groupIds);
    },
    sceneItemClick(data) {
      // obj.groupIds
      let idss = data.id;
      let sceneNamesArr = [];
      let sceneIdsArr = [];
      if(this.lightControlForm.sceneStr){
        sceneNamesArr = this.lightControlForm.sceneStr.split(',');
        sceneIdsArr = this.lightControlForm.sceneIds;
      }
      // console.log(sceneNamesArr,sceneIdsArr)
      if (sceneIdsArr.indexOf(idss) == -1) {
        sceneIdsArr.push(data.id)
        sceneNamesArr.push(data.name)
        // if (sceneNames == "") {
        //   sceneNames = data.name;
        //   sceneIds = idss;
        // } else {
        //   sceneNames = sceneNames + "," + data.name;
        //   sceneIds = sceneIds + "," + idss;
        // }
      } else {
        sceneIdsArr.splice(sceneIdsArr.indexOf(idss),1)
        sceneNamesArr.splice(sceneIdsArr.indexOf(idss),1)
        // let names = "";
        // if (sceneIds.indexOf(idss) == 0) {
        //   idss = idss + ",";
        //   names = data.name + ",";
        // } else {
        //   idss = "," + idss;
        //   names = "," + data.name;
        // }
        // sceneIds = sceneIdsArr.join(',');
        // sceneNames = sceneNamesArr.join(',');
        // groupIds = groupIds.slice(obj.groupIds.indexOf(idss),idss.length);
      }
      // for(let d of this.groupNavList){
      //   if(d.select == 1){
      //   }
      // }
      // console.log(sceneIdsArr, sceneNamesArr);
      this.$set(this.lightControlForm, "sceneStr", sceneNamesArr.join(','));
      this.$set(this.lightControlForm, "sceneIds", sceneIdsArr);
    },
    selectFun(val) {
      this.$set(this, val, this[val] ? false : true);
    },
    lampListGet() {
      base.ajax_post(
        allUrl.lamp.lamp_lampList,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          projectId: this.projectId,
        },
        {},
        (data) => {
          this.mapDevList = data.data;
          for (let d of this.mapDevList) {
            // console.log(d.locationY);
            // brightness
            d.type = 0;
            d.locationX = d.locationX < 0 ? 0 : d.locationX;
            d.locationX = d.locationX > 98 ? 98 : d.locationX;

            d.locationY = d.locationY < 0 ? 0 : d.locationY;
            d.locationY = d.locationY > 100 - 2 / (this.mapBgHeight / this.mapBgWidth).toFixed(4) ? 100 - 2 / (this.mapBgHeight / this.mapBgWidth).toFixed(4) : d.locationY;

            d.x1 = ((d.locationX * this.mapBgWidth) / 100).toFixed(4);
            d.y1 = ((d.locationY * this.mapBgHeight) / 100).toFixed(4);
            d.x2 = ( (d.locationX * this.mapBgWidth) / 100 + Number(this.clientWidth[0].toFixed(4)) ).toFixed(4);
            d.y2 = ( (d.locationY * this.mapBgHeight) / 100 + Number(this.clientHeight[0].toFixed(4)) ).toFixed(4);
            this.$set(d, "frameSelection", 0);
            d.locationX = d.locationX + "%";
            d.locationY = d.locationY + "%";
            // if(d.type == '2'){
            let status = '0';
            if(d.online == 0){
              status = 0
            }else{
              if(d.alarmStatus == 1){
                status = 2
              }else{
                status = 1
                if(d.status == 0){
                  status = 0
                }
              }
            }
            this.$set(d, "status", status);
            // this.$set(d, "status", d.alarmStatus == 1 ? '2' : "0");
            
            // }
            if (!d.id) {
              d.status = "new";
              this.bindingTkOpenShow = true;
            }
            this.$set(d, 'status_', d.status)
          }
          this.mapDevList.forEach((item) => {
            if(item.gatewayId){
              if(this.lightGatewayarr[item.gatewayId]){
                this.lightGatewayarr[item.gatewayId] = this.lightGatewayarr[item.gatewayId] + ',' + item.id;
              }else{
                this.lightGatewayarr[item.gatewayId] = item.id
              }
            }
          });
          if(this.pageType != "groupSetting"){
            this.gatewayListGet();
          }
          // console.log(this.lightGatewayarr,'---8888---')
        },
        this,()=>{
          if(this.getLampTime){
            clearInterval(this.getLampTime)
          }
        }
      );
    },
    //项目下所有灯控调光
    projectDimmingGet(cellback) {
      base.ajax_post(
        allUrl.project.project_projectDimming,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          id: this.projectId,
          brightness: this.groupBrightness
        },
        {},
        (data) => {
          if(cellback){
            cellback()
          }
          this.$message({
            showClose: true,
            message: data.msg,
            type: "success",
          });
        },
        this,()=>{
          if(cellback){
            cellback()
          }
        }
      )
    },
    //项目下所有灯控调光
    projectColorSet(cellback) {
      base.ajax_post(
        allUrl.project.project_projectSetColor,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          id: this.projectId,
          brightness: this.groupBrightness,
          color: this.groupColor
        },
        {},
        (data) => {
          if(cellback){
            cellback()
          }
          this.$message({
            showClose: true,
            message: data.msg,
            type: "success",
          });
        },
        this,()=>{
          if(cellback){
            cellback()
          }
        }
      )
    },
    //分组下所有灯控调光
    groupDimmingGet(cellback) {
      base.ajax_post(
        allUrl.group.group_groupDimming,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          id: this.groupId,
          brightness: this.groupBrightness
        },
        {},
        (data) => {
          if(cellback){
            cellback()
          }
          this.$message({
            showClose: true,
            message: data.msg,
            type: "success",
          });
        },
        this,()=>{
          if(cellback){
            cellback()
          }
        }
      )
    },
    //分组下所有灯控调色温
    groupColorSet(cellback) {
      base.ajax_post(
        allUrl.group.group_groupSetColor,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          id: this.groupId,
          brightness: this.groupBrightness,
          color: this.groupColor
        },
        {},
        (data) => {
          if(cellback){
            cellback()
          }
          this.$message({
            showClose: true,
            message: data.msg,
            type: "success",
          });
        },
        this,()=>{
          if(cellback){
            cellback()
          }
        }
      )
    },
    //单个灯控调光
    lampDimming() {
      base.ajax_post(
        allUrl.lamp.lamp_dimming,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          id: this.mapEditDeviceForm.devId,
          brightness: this.lightControlForm.brightness
        },
        {},
        (data) => {
          this.lightControlForm.brightness_ = this.lightControlForm.brightness;
          this.$message({
            showClose: true,
            message: data.msg,
            type: "success",
          });
        },
        this,()=>{
          this.lightControlForm.brightness = this.lightControlForm.brightness_;
        }
      )
    },
    lampColor() {
      base.ajax_post(
        allUrl.lamp.lamp_setColor,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          id: this.mapEditDeviceForm.devId,
          brightness: this.lightControlForm.brightness,
          color: this.lightControlForm.color
        },
        {},
        (data) => {
          this.lightControlForm.color_ = this.lightControlForm.color;
          this.lightControlForm.brightness_ = this.lightControlForm.brightness;
          this.$message({
            showClose: true,
            message: data.msg,
            type: "success",
          });
        },
        this,()=>{
          this.lightControlForm.color = this.lightControlForm.color_;
          this.lightControlForm.brightness = this.lightControlForm.brightness_;
        }
      )
    },
    deviceChangeScene() {
      base.ajax_post(
        allUrl.scene.deviceChangeScene,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          deviceId: this.mapEditDeviceForm.devId,
          brightness: this.lightControlForm.sceneIds
        },
        {},
        (data) => {
          this.$message({
            showClose: true,
            message: data.msg,
            type: "success",
          });
        },
        this
      )
    },
    lampDetailsGet(callback) {
      base.ajax_post(
        allUrl.lamp.lamp_details,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          id: this.mapEditDeviceForm.devId,
        },
        {},
        (data) => {
          if(callback){
            callback(data)
          }
        },
        this
      );
    },
    projectNavList() {
      console.log('--projectNavList--')
      base.ajax_post(
        allUrl.project.project_nav,
        {
          username: this.username,
          version: this.version,
          token: this.token,
        },
        {},
        (data) => {
          this.$store.commit("provinceNavListSelectFun", {
            provinceNavList: data.data,
          });
          if (this.provinceNavList.length>0) {
            if(!this.projectId){
              this.$store.commit("projectSelectFun", {
                projectId: this.provinceNavList[0].id,
                projectName: this.provinceNavList[0].name,
              });
            }
          }else{
            // this.pageTypeFun('projectSettings')
            return
          }
          this.getUserSelectFun();
          this.sceneListGet();

          this.sceneNavGet();
          this.groupNavGet();
          this.lampListGet();
          this.getLockStatus();
          this.projectDetailsGet();
          this.projectAlarmGet();
          this.deviceTotalStatisticsGet();
          // this.gatewayListGet();
          this.$nextTick(function(){
            this.isGetList = true
          })
        },
        this
      );
    },
    //情景下拉列表
    sceneNavGet() {
      base.ajax_post(
        allUrl.scene.scene_nav,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          projectId: this.projectId,
        },
        {},
        (data) => {
          for (let d of data.data) {
            d.editShow = false;
          }
          this.sceneNavList = data.data;
        },
        this
      );
    },
    // 情景列表
    sceneListGet() {
      // console.log(this.formReportQuestion)
      // baseApi.ajax_post(
      base.ajax_post(
        allUrl.scene.scene_list,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          clientType: this.os,
          keywords: this.keywords,
          projectId: this.projectId,
        },
        {},
        data => {
          let sceneList = []
          for (let d of data.data.list) {
            d.editShow = false;
            d.sceneApplying = false;
            d.subHeight = d.subSceneList.length;
            d.showPosition = 'bottom';
            // console.log(d.subSceneList)
            sceneList.push(d)
          }
          this.$set(this,'sceneList',sceneList)
          // } else {
          //   this.$message({
          //     showClose: true,
          //     message: data.msg,
          //     type: 'success'
          //   });
          // }
        },
        this, () => { })
    },
    groupNavGet() {
      base.ajax_post(
        allUrl.group.group_groupList,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          projectId: this.projectId,
        },
        {},
        (data) => {
          this.groupNavList = data.data;
        },
        this
      );
    },
    getLockStatus() {
      base.ajax_post(
        allUrl.project.project_getLockStatus,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          id: this.projectId,
        },
        {},
        (data) => {
          this.lockStatus = data.data.lockStatus;
          // console.log(data);
        },
        this
      );
    },
    setLockStatus() {
      if (this.lockStatus == 1) {
        this.lockStatus = 0;
      } else {
        this.lockStatus = 1;
      }
      base.ajax_post(
        allUrl.project.project_setLockStatus,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          id: this.projectId,
          lockStatus: this.lockStatus,
        },
        {},
        (data) => {
          this.$message({
            showClose: true,
            message: data.msg,
            type: "success",
          });
          // this.lockStatus = data.data;
          // console.log(data);
        },
        this,
        () => {
          if (this.lockStatus == 1) {
            this.lockStatus = 0;
          } else {
            this.lockStatus = 1;
          }
        }
      );
    },
    project_projectRefresh() {
      if (this.loading.project_projectRefresh) {
        return
      }
      this.loading.project_projectRefresh = true;
      base.ajax_post(
        allUrl.project.project_projectRefresh,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          id: this.projectId,
        },
        {},
        (data) => {
          this.loading.project_projectRefresh = false;
          this.$message({
            showClose: true,
            message: data.msg,
            type: "success",
          });
        },
        this,
        () => {
          this.loading.project_projectRefresh = false;
        }
      );
    },

    projectSelectFun(val) {
      if (this['projectSelectShow'+val]) {
        this['projectSelectShow'+val] = false;
      } else {
        this['projectSelectShow'+val] = true;
      }
    },
    provinceItemClick(data) {
      // this.projectId = data.id;
      // this.projectName = data.name;
      this.noticeShow = false;
      
      this.$store.commit("projectSelectFun", {
        projectId: data.id,
        projectName: data.name,
      });
      this.projectSelectShow0 = false;
      this.projectSelectShow1 = false;
      // this.sceneNavGet();
      // this.groupNavGet();
      // this.projectSelectFun();
      this.sceneListGet();
      this.pageTypeFun('')
    },
    // 网关列表
    gatewayListGet() {
      base.ajax_post(
        allUrl.gateway.gateway_gatewayList,
        {
          username: this.username,
          version: this.version,
          token:this.token,
          projectId:this.projectId
        },
        {},
        data => {
          // console.log(data)
          for(let d of data.data){
            d.dataType = 'text'
          }
          this.gatewayList = data.data;
          // this.gatewayList_ = JSON.parse(JSON.stringify(data.data));
          // console.log(this.gatewayList)

          for (let d of this.gatewayList) {
            // brightness
            d.type = 1;
            d.locationX = d.locationX < 0 ? 0 : d.locationX;
            d.locationX = d.locationX > 98 ? 98 : d.locationX;

            d.locationY = d.locationY < 0 ? 0 : d.locationY;
            d.locationY =
              d.locationY >
                100 - 2 / (this.mapBgHeight / this.mapBgWidth).toFixed(4)
                ? 100 - 2 / (this.mapBgHeight / this.mapBgWidth).toFixed(4)
                : d.locationY;

            d.x1 = ((d.locationX * this.mapBgWidth) / 100).toFixed(4);
            d.y1 = ((d.locationY * this.mapBgHeight) / 100).toFixed(4);
            d.x2 = (
              (d.locationX * this.mapBgWidth) / 100 +
              Number(this.clientWidth[1].toFixed(4))
            ).toFixed(4);
            d.y2 = (
              (d.locationY * this.mapBgHeight) / 100 +
              Number(this.clientHeight[1].toFixed(4))
            ).toFixed(4);
            this.$set(d, "frameSelection", 0);
            d.locationX = d.locationX + "%";
            d.locationY = d.locationY + "%";
            // if(d.type == '2'){
            this.$set(d, "status", d.online ? d.online : "0");
            // }
            if (!d.id) {
              d.status = "new";
              this.bindingTkOpenShow = true;
            }
            this.mapDevList.push(d)
            // console.log('-sd-s-s-ddsds',this.mapDevList)

          }
        },
        this
      )
    },
    // 网关详情
    gatewayDetailsGet(callback) {
      base.ajax_post(
        allUrl.gateway.gateway_details,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          id: this.mapEditDeviceForm.devId
        },
        {},
        (data) => {
          // console.log(data.data,'--4--5--1--4')
          this.gatewayDetailsList = data.data;
          if(callback){
            callback(data)
          }
        },
        this
      );
    },
    groupSetCancel(){ 
      this.$store.commit("groupAddDevFun", {
        groupAddDev: false,
        groupAddDevList: this.groupAddDevList_,
        groupAddDevStr: '',
        groupAddDevIndex: this.groupAddDevIndex+1,
        groupAddDevType: 'cancel'
      });
      this.groupAddDevList_ = [];
    },
    groupSetSave(){
      this.groupControlShow = true;
      // console.log(this.groupAddDevList_)
      // this.$store.commit("groupAddDevFun", {
      //   groupAddDev: false,
      //   groupAddDevList: this.groupAddDevList_,
      //   groupAddDevStr: '',
      //   groupAddDevIndex: this.groupAddDevIndex+1,
      //   groupAddDevType: 'save'
      // });
      // console.log(this.groupAddDevList_,this.groupAddDevList,'--1--5--4-5')
      // this.groupAddDevList_ = [];
    },
    mapDevClassFun(item){
      let obj = {};
      obj[item.type+'_'+item.id] = true;
      obj['type_' + item.type] = true;
      obj['status_' + item.status] = true;
      obj['frameSelection_' + item.frameSelection] = true;
      // if(item.frameSelection != 1){
      //   obj['frameSelection_1'] = true;
      // }
      if(this.mapEditDeviceForm.devId == item.id){
        obj['frameSelection_2'] = true;
      }
      // :class="'type_' + item.type + ' ' + item.id + ' status_' + item.status + ' frameSelection_' + item.frameSelection"

        // this.mapEditDeviceForm.devId
      return obj
    },
    skinClassFun(){
      let obj = {};
      obj['cn'] = this.version == '1';
      obj['ja'] = this.version == '2';
      obj['ratio_1920_1080'] = this.ratio == '1';
      if(this.themeType == 1){
        obj['themeType_' + 1] = true;
      }
      if(this.themeType == 2){
        obj['themeType_' + 2] = true;
      }
      // obj['themeType_' + 1] = true;
      return obj
    },
    // 用户消息详情
    userDetailsGet() {
      base.ajax_post(
        allUrl.user.user_userDetails,
        {
          username: this.username,
          version: this.version,
          token: this.token,
          clientType: this.os,

          id: this.id,
        },
        {},
        (data) => {
          console.log(data.data,'-9696555')
          this.timezoneKey = data.data.timezone;
          // this.themeType = data.data.themeType;
          this.$store.commit('themeTypeFun', {
            themeType: data.data.themeType,
          })
        },
        this,
        () => {}
      );
    },
  },
  watch: {
    groupColor: function(){
      this.groupColorRgba = this.kelvinToRGBA(this.groupColor);
    },
    'lightControlForm.color': function(){
      this.colorRgba = this.kelvinToRGBA(this.lightControlForm.color);
    },
    bjIndex: function () {
      this.projectDetailsGet();
      // this.bjIndex = this.bjIndex + 1
    },
    lockTitleShow: function () {
      if (this.lockTitleShow) {
        this.$message({
          showClose: true,
          message: "Not unlocked",
          type: "warning",
        });
        let this_ = this;
        clearTimeout(this_.lockTitleShowTime);
        this.lockTitleShowTime = setTimeout(function () {
          this_.lockTitleShow = false;
          clearTimeout(this_.lockTitleShowTime);
        }, 3000);
      }
    },
    // getUserSettingInfoDateValue: function () {
    //   // if(this.isGetList){
    //   //   this.sceneNavGet();
    //   //   this.groupNavGet();
    //   //   this.lampListGet();
    //   //   this.getLockStatus();

    //     let getUserSettingObj = {
    //       getUserSettingInfoDateValue: this.getUserSettingInfoDateValue,
    //     };
    //     let storage = window.localStorage;
    //     storage.setItem("getUserSettingObj", JSON.stringify(getUserSettingObj));
    //   // }
    // },
    projectId: function () {
      console.log(this.isGetList,this.projectId,'--projectId--')
      if(this.isGetList&&this.projectId){
        this.sceneNavGet();
        this.groupNavGet();
        this.lampListGet();
        this.getLockStatus();
        this.projectDetailsGet();
        this.projectAlarmGet();
        this.deviceTotalStatisticsGet();
        let projectObj = {
          name: this.projectName,
          id: this.projectId,
        };
        let storage = window.localStorage;
        storage.setItem("projectObj", JSON.stringify(projectObj));
        if(!this.pageTitle){
          this.pageTitle = this.projectName;
        }
      }
    },
    projectUpdate: function () {
      console.log(this.isGetList,this.projectId,'--projectUpdate--')
      let storage = window.localStorage;
      if(this.isGetList&&this.projectId){
        this.sceneNavGet();
        this.groupNavGet();
        this.mapDevList = [];
        this.lampListGet();
        this.getLockStatus();
        this.projectDetailsGet();
        this.projectAlarmGet();
        this.deviceTotalStatisticsGet();
        let projectObj = {
          name: this.projectName,
          id: this.projectId,
        };
        storage.setItem("projectObj", JSON.stringify(projectObj));
        if(!this.pageTitle){
          this.pageTitle = this.projectName;
        }
      }else{
        this.pageTitle = '';
        let projectObj = {
          name: '',
          id: '',
        };
        storage.setItem("projectObj", JSON.stringify(projectObj));
      }
    },
    projectName: function () {
      this.pageTitle = this.projectName;
    },
    lampListUpdate: function () {
      this.lampListGet();
    },
    userDetailsGetUpdate: function (){
      this.userDetailsGet();
    },
    groupAddDev: function () {
      if(this.groupAddDev){
        this.groupAddDevList_ = [];
        for (let d of this.mapDevList) {
          if(this.groupAddDevStr){
            for(let str of this.groupAddDevStr.split(',')){
              if(d.type == 0){
                if(d.address == str){
                  this.$set(d, "frameSelection", 1);
                  this.groupAddDevList_.push({
                    id: d.id,
                    lampAddress: d.address,
                    type: d.type,
                    name: d.name,
                  })
                  break;
                }else{
                  this.$set(d, "frameSelection", 0);
                }
              }
            }
          }else{
            this.$set(d, "frameSelection", 0);
          }
        }
      }else{
        // console.log('-dsa-asd-asd-')
        for (let d of this.mapDevList) {
            if(d.type == 0){
              this.$set(d, "frameSelection", 0);
            }
          }
      }
    },
    groupAddDevIndex:function (){
      this.groupAddDevList_ = [];
      // console.log(this.groupAddDevStr)
      for (let d of this.mapDevList) {
        if(this.groupAddDevStr){
          for(let str of this.groupAddDevStr.split(',')){
            if(d.type == 0){
              if(d.address == str){
                this.$set(d, "frameSelection", 1);
                this.groupAddDevList_.push({
                  id: d.id,
                  lampAddress: d.address,
                  type: d.type,
                  name: d.name,
                })
                break;
              }else{
                this.$set(d, "frameSelection", 0);
              }
            }
          }
        }else{
          this.$set(d, "frameSelection", 0);
        }
      }
    }
  },
};
</script>

<style type="text/css" lang="less">
.home_main {
  width: 100%;
  height: 100%;
  // height: 105rem;
  // min-height: 89.82rem;
  // min-width: 120rem;
  margin: 0 auto;
  overflow: hidden;
  position: relative;

  // display: flex;
  // background: #F6F8FA;
  &.ja{
    .scene_map_box{
      .right_click_menu_box{
        .right_click_menu{
          width: initial;
          // padding: 0 0.5rem;
        }
      }
    }
  }
  .top_box {
    height: 7.37rem;
    background: #f6f8fa;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .top_left_box {
      display: flex;
      align-items: center;

      .sport_stadium {
        width: 3.33rem;
        height: 2.54rem;
        background-image: url("../img/icon/sport_stadium.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin-left: 1.84rem;
        margin-right: 2.28rem;
        cursor: pointer;
      }

      .text {
        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3a636f;
      }
    }
    .top_right_box {
      display: flex;
      .setting {
        width: 4.12rem;
        height: 4.12rem;
        background-image: url("../img/icon/setting.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin-right: 1.32rem;
        cursor: pointer;
      }
    }
  }

  .scene_map_box {
    position: relative;
    width: 100%;
    height: calc(100% - 5.79rem);
    // background-image: url("../img/login/background.png");
    // background-position: center;
    // background-repeat: no-repeat;
    // background-size: contain;
    background-size: 100% 100%;
    .img_bg{
      width:100%;height:100%;
    }
    .right_click_menu_box {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      .right_click_menu_bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      .right_click_menu {
        position: absolute;
        width: 9.2rem;
        background: rgba(255, 255, 255, 1);
        border-radius: 0.17rem;
        box-shadow: 0rem 0.17rem 0.83rem 0rem rgba(101, 112, 133, 0.2);

        .div {
          height: 2.2rem;
          line-height: 2.2rem;
          display: flex;
          align-items: center;
          cursor: context-menu;

          i {
            display: inline-block;
            margin: 0 0.5rem 0 1rem;
            width: 1rem;
            height: 1rem;
            background-size: 100% 100%;
            background-position: center;
            // background-image: url(../img/room/map);
          }

          span {
            font-size: 1rem;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
          }

          &:hover {
            background: rgba(230, 250, 246, 1);

            span {
              color: rgba(5, 207, 171, 1);
            }
          }

          // &.div1 {
          //   i {
          //     background-image: url(../img/room/map/copy_0.png);
          //   }
          //   &:hover {
          //     i {
          //       background-image: url(../img/room/map/copy_1.png);
          //     }
          //   }
          // }
          // &.div2 {
          //   i {
          //     background-image: url(../img/room/map/paste_0.png);
          //   }
          //   &:hover {
          //     i {
          //       background-image: url(../img/room/map/paste_1.png);
          //     }
          //   }
          // }
          // &.div3 {
          //   i {
          //     background-image: url(../img/room/map/delete_0.png);
          //   }
          //   &:hover {
          //     i {
          //       background-image: url(../img/room/map/delete_1.png);
          //     }
          //   }
          // }
        }
      }
    }

    .click_menu_move {
      position: absolute;
      width: 7.5rem;
      // height: 9rem;
      background: rgba(255, 255, 255, 1);
      border-radius: 0.17rem;
      box-shadow: 0rem 0.17rem 0.83rem 0rem rgba(101, 112, 133, 0.2);

      .click_menu_move_top {
        width: 100%;
        height: 2.3rem;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        // background-image: url(../img/room/map/move_top.png);
        background-size: 60% 40%;
        background-position: center;
        background-repeat: no-repeat;
        // img{
        //     max-width: 100%;
        //     height: 0.8rem;
        // }
      }

      .div {
        height: 2.2rem;
        line-height: 2.2rem;
        display: flex;
        align-items: center;
        cursor: context-menu;

        i {
          display: inline-block;
          margin: 0 0.5rem 0 1rem;
          width: 1rem;
          height: 1rem;
          background-size: 100% 100%;
          background-position: center;
          // background-image: url(../img/room/map);
        }

        span {
          font-size: 1rem;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
        }

        &:hover,
        &.select {
          background: rgba(230, 250, 246, 1);

          span {
            color: rgba(5, 207, 171, 1);
          }
        }

        // &.div1 {
        //   i {
        //     background-image: url(../img/room/map/copy_0.png);
        //   }
        //   &:hover {
        //     i {
        //       background-image: url(../img/room/map/copy_1.png);
        //     }
        //   }
        // }
        // &.div2 {
        //   i {
        //     background-image: url(../img/room/map/paste_0.png);
        //   }
        //   &:hover,
        //   &.select {
        //     i {
        //       background-image: url(../img/room/map/paste_1.png);
        //     }
        //   }
        // }
        // &.div3 {
        //   i {
        //     background-image: url(../img/room/map/delete_0.png);
        //   }
        //   &:hover {
        //     i {
        //       background-image: url(../img/room/map/delete_1.png);
        //     }
        //   }
        // }
      }
    }

    .device_tips {
      position: absolute;
      width: 14.5rem;
      height: 12.5rem;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0rem 0.25rem 0.67rem 0rem rgba(101, 112, 133, 0.15);
      border-radius: 0.17rem;
      border: 0.08rem solid rgba(5, 207, 171, 1);

      p {
        display: flex;
        justify-content: space-between;
        margin: 0.5rem 0;

        .span1 {
          width: 5.5rem;
          padding-left: 1.2rem;
          font-size: 1rem;
          font-family: AlibabaPuHuiTiR;
          color: rgba(51, 51, 51, 1);
        }

        .span2 {
          flex: 1;
          font-size: 1rem;
          font-family: AlibabaPuHuiTiR;
          color: rgba(101, 112, 133, 1);

          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          vertical-align: middle;
        }
      }
    }

    .map_tips {
      position: absolute;
      bottom: 10.8rem;
      left: 0;

      &:hover {
        .div1 {
          display: block;
        }

        .div2 {
          display: flex;
        }
      }

      .div1 {
        position: absolute;
        width: 18rem;
        height: 7.5rem;
        border-left: 0.2rem solid rgba(5, 207, 171, 1);
        background: rgba(255, 255, 255, 1);
        display: none;

        p {
          display: flex;
          justify-content: space-between;
          align-items: center;

          &.p1 {
            margin-top: 1rem;

            i {
              background: rgba(5, 207, 171, 1);
            }
          }

          &.p2 {
            margin-top: 0.5rem;

            i {
              background: rgba(255, 219, 0, 1);
            }
          }

          &.p3 {
            margin-top: 0.5rem;

            i {
              background: rgba(255, 12, 77, 1);
            }
          }

          i {
            margin-left: 1rem;
            display: inline-block;
            width: 0.33rem;
            height: 0.33rem;
            border-radius: 50%;
          }

          .span1 {
            margin-left: 0.8rem;
            font-size: 1rem;
            font-family: AlibabaPuHuiTiR;
            color: rgba(51, 51, 51, 1);
          }

          .span2 {
            margin-right: 1rem;
            font-size: 1rem;
            font-family: AlibabaPuHuiTiR;
            color: rgba(101, 112, 133, 1);
          }
        }
      }

      .div2 {
        position: absolute;
        top: 7.5rem;
        left: 3.3rem;
        display: flex;
        width: 14.7rem;
        height: 3.33rem;
        background: rgba(246, 248, 250, 1);
        text-align: center;
        display: none;

        div {
          flex: 1;

          img {
            margin-top: 0.5rem;
            height: 1rem;
          }

          p {
            font-size: 1rem;
            font-family: AlibabaPuHuiTiR;
            color: rgba(51, 51, 51, 1);
          }

          &.circadianLights {
            img {
              margin-top: 0.8rem;
              height: 0.7rem;
            }
          }
        }
      }

      .div3 {
        position: absolute;
        top: 7.5rem;
        left: 0;
        width: 3.3rem;
        height: 3.33rem;
        background: rgba(5, 207, 171, 1);
        border-radius: 0rem 0rem 0rem 0.17rem;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          color: #fff;
        }
      }
    }

    .frame_selection {
      position: absolute;
      border: 1px solid rgba(5, 207, 171, 1);
      background: rgba(5, 207, 171, 0.2);

      .move {
        position: absolute;
        right: 0rem;
        bottom: 0;
        width: 1.25rem;
        height: 1.25rem;
        border-radius: 50%;
        border: 0.08rem solid rgba(5, 207, 171, 1);
        background-position: center;
        background-size: 100% 100%;
        // background-image: url("../img/room/map/move.png");
        cursor: pointer;
      }
    }
    .map_gateway {
      position: absolute;
      width: 3rem;
      height: 3rem;
      background-position: center;
      background-size: 75% 75%;
      cursor: pointer;
      background-color: #f4fbfd;
      border-radius: 50%;
      background-repeat: no-repeat;
      &.type_0 {
        &.status_0 {
          background-image: url("../img/icon/gateway_0_0.png");
          // background-size: 65%;
          // &:hover {
          //   background-image: url("../img/icon/map_device_0_0_hover.png");
          // }
          // &.frameSelection_1 {
          //   background-image: url("../img/icon/map_device_0_0_hover.png");
          // }
        }

        &.status_1 {
          background-image: url("../img/icon/gateway_0_1.png");
          // background-size: 65%;
          // &:hover {
          //   background-image: url("../img/icon/map_device_0_1_hover.png");
          // }
          // &.frameSelection_1 {
          //   background-image: url("../img/icon/map_device_0_1_hover.png");
          // }
        }

        &.status_2 {
          background-image: url("../img/icon/lamp_outline.png");
          
          // &:hover {
          //   background-image: url("../img/icon/map_device_0_1_hover.png");
          // }
          // &.frameSelection_1 {
          //   background-image: url("../img/icon/map_device_0_1_hover.png");
          // }
        }

        &.status_new {
          background-image: url("../img/icon/map_device_0_0.png");
          // &:hover {
          //   background-image: url("../img/room/map/map_device_0_new_hover.png");
          // }
          // &.frameSelection_1 {
          //   background-image: url("../img/room/map/map_device_0_new_hover.png");
          // }
        }
      }
    }
    
    .map_device {
      position: absolute;
      width: 3rem;
      height: 3rem;
      background-position: center;
      background-size: 75% 75%;
      cursor: pointer;
      background-color: #f4fbfd;
      border-radius: 50%;
      background-repeat: no-repeat;

      &.type_0 {
        &.status_0 {
          background-image: url("../img/icon/lamp_outline_.png");
          background-size: 65%;
          // &:hover {
          //   background-image: url("../img/icon/map_device_0_0_hover.png");
          // }
          // &.frameSelection_1 {
          //   background-image: url("../img/icon/map_device_0_0_hover.png");
          // }
        }

        &.status_1 {
          background-image: url("../img/icon/lamp_.png");
          // &:hover {
          //   background-image: url("../img/icon/map_device_0_1_hover.png");
          // }
          // &.frameSelection_1 {
          //   background-image: url("../img/icon/map_device_0_1_hover.png");
          // }
        }

        &.status_2 {
          background-image: url("../img/icon/lamp_fault_.png");
          background-size: 65%;
          // &:hover {
          //   background-image: url("../img/icon/map_device_0_1_hover.png");
          // }
          // &.frameSelection_1 {
          //   background-image: url("../img/icon/map_device_0_1_hover.png");
          // }
        }
        &.status_3 {
          background-image: url("../img/icon/lamp_select.png");
          background-size: 65%;
          // &:hover {
          //   background-image: url("../img/icon/map_device_0_1_hover.png");
          // }
          // &.frameSelection_1 {
          //   background-image: url("../img/icon/map_device_0_1_hover.png");
          // }
        }
        &.status_select {
          background-image: url("../img/icon/lamp_outline.png");
          // &:hover {
          //   background-image: url("../img/icon/map_device_0_1_hover.png");
          // }
          // &.frameSelection_1 {
          //   background-image: url("../img/icon/map_device_0_1_hover.png");
          // }
        }

        &.status_fenzhu {
          background-image: url("../img/icon/lamp_outline.png");
          // background-image: url("../img/icon/lamp_select.png");
          border:2px solid #0086f9;
          background-size: 50%;
          // &:hover {
          //   background-image: url("../img/icon/map_device_0_1_hover.png");
          // }
          // &.frameSelection_1 {
          //   background-image: url("../img/icon/map_device_0_1_hover.png");
          // }
        }

        &.status_new {
          background-image: url("../img/icon/map_device_0_0.png");
          // &:hover {
          //   background-image: url("../img/room/map/map_device_0_new_hover.png");
          // }
          // &.frameSelection_1 {
          //   background-image: url("../img/room/map/map_device_0_new_hover.png");
          // }
        }
        &.frameSelection_1 {
          background-image: url("../img/icon/lamp_group.png");
          // border:2px solid #0086f9;
        }
        &.frameSelection_2 {
          background-image: url("../img/icon/lamp_select.png");
          // border:2px solid #0086f9;
        }
      }

      &.type_1 {
        // width: 8.55rem;
        // height: 8.55rem;
        &.status_0 {
          width: 8.55rem;
          height: 8.55rem;
          background-image: url("../img/icon/gateway_0_0.png");
          background-size: 65%;
          // &:hover {
          //   background-image: url("../img/room/map/map_device_1_0_hover.png");
          // }
          // &.frameSelection_1 {
          //   background-image: url("../img/room/map/map_device_1_0_hover.png");
          // }
        }
        &.status_1 {
          width: 8.55rem;
          height: 8.55rem;
          background-image: url("../img/icon/gateway_0_1.png");
          background-size: 65%;
          // &:hover {
          //   background-image: url("../img/room/map/map_device_1_1_hover.png");
          // }
          // &.frameSelection_1 {
          //   background-image: url("../img/room/map/map_device_1_1_hover.png");
          // }
        }
        // &.status_new {
        //   background-image: url("../img/room/map/map_device_1_0.png");
          // &:hover {
          //   background-image: url("../img/room/map/map_device_1_new_hover.png");
          // }
          // &.frameSelection_1 {
          //   background-image: url("../img/room/map/map_device_1_new_hover.png");
          // }
        // }
        &.frameSelection_1 {
          border:2px solid #0086f9;
        }
      }
      
      // &.type_2 {
      //   &.status_0 {
      //     background-image: url("../img/room/map/map_device_2_0.png");
      //     &:hover {
      //       background-image: url("../img/room/map/map_device_2_0_hover.png");
      //     }
      //     &.frameSelection_1 {
      //       background-image: url("../img/room/map/map_device_2_0_hover.png");
      //     }
      //   }
      //   &.status_1 {
      //     background-image: url("../img/room/map/map_device_2_1.png");
      //     &:hover {
      //       background-image: url("../img/room/map/map_device_2_1_hover.png");
      //     }
      //     &.frameSelection_1 {
      //       background-image: url("../img/room/map/map_device_2_1_hover.png");
      //     }
      //   }
      //   &.status_new {
      //     background-image: url("../img/room/map/map_device_2_new.png");
      //     &:hover {
      //       background-image: url("../img/room/map/map_device_2_new_hover.png");
      //     }
      //     &.frameSelection_1 {
      //       background-image: url("../img/room/map/map_device_2_new_hover.png");
      //     }
      //   }
      // }
      // &.type_3 {
      //   &.status_0 {
      //     background-image: url("../img/room/map/map_device_3_0.png");
      //     &:hover {
      //       background-image: url("../img/room/map/map_device_3_0_hover.png");
      //     }
      //     &.frameSelection_1 {
      //       background-image: url("../img/room/map/map_device_3_0_hover.png");
      //     }
      //   }
      //   &.status_1 {
      //     background-image: url("../img/room/map/map_device_3_1.png");
      //     &:hover {
      //       background-image: url("../img/room/map/map_device_3_1_hover.png");
      //     }
      //     &.frameSelection_1 {
      //       background-image: url("../img/room/map/map_device_3_1_hover.png");
      //     }
      //   }
      //   &.status_new {
      //     background-image: url("../img/room/map/map_device_3_new.png");
      //     &:hover {
      //       background-image: url("../img/room/map/map_device_3_new_hover.png");
      //     }
      //     &.frameSelection_1 {
      //       background-image: url("../img/room/map/map_device_3_new_hover.png");
      //     }
      //   }
      // }
      // &.type_4 {
      //   &.status_0 {
      //     background-image: url("../img/room/map/map_device_0_0.png");
      //     &:hover {
      //       background-image: url("../img/room/map/map_device_0_0_hover.png");
      //     }
      //     &.frameSelection_1 {
      //       background-image: url("../img/room/map/map_device_0_0_hover.png");
      //     }
      //   }
      //   &.status_1 {
      //     background-image: url("../img/room/map/map_device_0_1.png");
      //     &:hover {
      //       background-image: url("../img/room/map/map_device_0_1_hover.png");
      //     }
      //     &.frameSelection_1 {
      //       background-image: url("../img/room/map/map_device_0_1_hover.png");
      //     }
      //   }
      //   &.status_new {
      //     background-image: url("../img/room/map/map_device_0_new.png");
      //     &:hover {
      //       background-image: url("../img/room/map/map_device_0_new_hover.png");
      //     }
      //     &.frameSelection_1 {
      //       background-image: url("../img/room/map/map_device_0_new_hover.png");
      //     }
      //   }
      // }
      // &.type_5 {
      //   &.status_0 {
      //     background-image: url("../img/room/map/map_device_0_0.png");
      //     &:hover {
      //       background-image: url("../img/room/map/map_device_0_0_hover.png");
      //     }
      //     &.frameSelection_1 {
      //       background-image: url("../img/room/map/map_device_0_0_hover.png");
      //     }
      //   }
      //   &.status_1 {
      //     background-image: url("../img/room/map/map_device_0_1.png");
      //     &:hover {
      //       background-image: url("../img/room/map/map_device_0_1_hover.png");
      //     }
      //     &.frameSelection_1 {
      //       background-image: url("../img/room/map/map_device_0_1_hover.png");
      //     }
      //   }
      //   &.status_new {
      //     background-image: url("../img/room/map/map_device_0_new.png");
      //     &:hover {
      //       background-image: url("../img/room/map/map_device_0_new_hover.png");
      //     }
      //     &.frameSelection_1 {
      //       background-image: url("../img/room/map/map_device_0_new_hover.png");
      //     }
      //   }
      // }
      // &.type_6 {
      //   &.status_0 {
      //     background-image: url("../img/room/map/map_device_0_0.png");
      //     &:hover {
      //       background-image: url("../img/room/map/map_device_0_0_hover.png");
      //     }
      //     &.frameSelection_1 {
      //       background-image: url("../img/room/map/map_device_0_0_hover.png");
      //     }
      //   }
      //   &.status_1 {
      //     background-image: url("../img/room/map/map_device_0_1.png");
      //     &:hover {
      //       background-image: url("../img/room/map/map_device_0_1_hover.png");
      //     }
      //     &.frameSelection_1 {
      //       background-image: url("../img/room/map/map_device_0_1_hover.png");
      //     }
      //   }
      //   &.status_new {
      //     background-image: url("../img/room/map/map_device_0_new.png");
      //     &:hover {
      //       background-image: url("../img/room/map/map_device_0_new_hover.png");
      //     }
      //     &.frameSelection_1 {
      //       background-image: url("../img/room/map/map_device_0_new_hover.png");
      //     }
      //   }
      // }
      // &.type_7 {
      //   &.status_0 {
      //     background-image: url("../img/room/map/map_device_0_0.png");
      //     &:hover {
      //       background-image: url("../img/room/map/map_device_0_0_hover.png");
      //     }
      //     &.frameSelection_1 {
      //       background-image: url("../img/room/map/map_device_0_0_hover.png");
      //     }
      //   }
      //   &.status_1 {
      //     background-image: url("../img/room/map/map_device_0_1.png");
      //     &:hover {
      //       background-image: url("../img/room/map/map_device_0_1_hover.png");
      //     }
      //     &.frameSelection_1 {
      //       background-image: url("../img/room/map/map_device_0_1_hover.png");
      //     }
      //   }
      //   &.status_new {
      //     background-image: url("../img/room/map/map_device_0_new.png");
      //     &:hover {
      //       background-image: url("../img/room/map/map_device_0_new_hover.png");
      //     }
      //     &.frameSelection_1 {
      //       background-image: url("../img/room/map/map_device_0_new_hover.png");
      //     }
      //   }
      // }
      // &.status_new{
      //     background-image:url('../img/room/map_device_new.png');
      //     &:hover{
      //         background-image:url('../img/room/map_device_hover.png');
      //     }
      // }
    }
  }

  .left_toolbar {
    position: absolute;
    top: 7.37rem;
    left: 0;
    width: 30rem;
    height: calc(100% - 7.37rem);
    // background: rgba(255, 255, 255, 0.85);
    // background-image: url("../img/home/leftMenu_bg.png");
    background: rgba(255, 255, 255, 0.85);
    z-index: 2;

    .p1 {
      font-size: 1.8rem;
      font-family: Calibri;
      font-weight: normal;
      color: #3a636f;
      margin-top: 1.14rem;
      margin-left: 1.93rem;
    }

    .project_information {
      margin: 1rem auto 5rem;
      width: 27.11rem;
      height: 22.89rem;
      background: #f4fbfd;
      border-radius: 1.75rem;
      padding: 2.6rem 0 0 2rem;

      .p2 {
        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3a636f;
        margin-bottom: 1.4rem;
      }

      .flex_box {
        display: flex;
        position: relative;
      }

      .lamp_online {
        width: 2.72rem;
        height: 2.72rem;
        background-image: url("../img/icon/lamp_online.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin-right: 1.93rem;
        margin-bottom: 1.3rem;
      }

      .lamp_fault {
        width: 1.84rem;
        height: 2.37rem;
        background-image: url("../img/icon/lamp_fault.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin-right: 2.37rem;
        margin-bottom: 1.4rem;
        margin-left: 0.53rem;
      }

      .lamp_outline {
        width: 1.84rem;
        height: 2.37rem;
        background-image: url("../img/icon/lamp_outline.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin-right: 2.37rem;
        margin-bottom: 1rem;
        margin-left: 0.53rem;
      }

      .temp {
        position: absolute;
        left: 2.63rem;
        top: 1.14rem;
        width: 0.79rem;
        height: 1.67rem;
        background-image: url("../img/icon/temp.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .span {
        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3a636f;
      }
    }

    .nav_btn {
      width: 100%;
      height: 4.21rem;
      display: flex;
      align-items: center;
      cursor: pointer;
      padding-left: 3.7rem;
      user-select: none;

      &:hover .home {
        background-image: url("../img/icon/home_hover.png");
      }

      &:hover .sence_setting {
        background-image: url("../img/icon/sence_setting_hover.png");
      }

      &:hover .calendar {
        background-image: url("../img/icon/calendar_hover.png");
      }

      &:hover .system_setting {
        background-image: url("../img/icon/system_setting_hover.png");
      }

      &:hover .power_consumption {
        background-image: url("../img/icon/power_consumption_hover.png");
      }

      .home {
        width: 2.81rem;
        height: 2.63rem;
        background-image: url("../img/icon/home.png");
        margin-right: 1.58rem;
      }

      .sence_setting {
        width: 2.72rem;
        height: 2.72rem;
        background-image: url("../img/icon/sence_setting.png");
        margin-right: 1.58rem;
      }

      .calendar {
        width: 2.72rem;
        height: 2.72rem;
        background-image: url("../img/icon/calendar.png");
        margin-right: 1.58rem;
      }

      .system_setting {
        width: 2.72rem;
        height: 2.72rem;
        background-image: url("../img/icon/system_setting.png");
        margin-right: 1.58rem;
      }

      .power_consumption {
        width: 2.72rem;
        height: 2.72rem;
        background-image: url("../img/icon/power_consumption.png");
        margin-right: 1.58rem;
      }

      .text {
        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3a636f;
      }

      // background: linear-gradient(-90deg, rgba(255, 255, 255, 1),rgba(0, 198, 255, 1), rgba(0, 198, 255, 1));

      &:hover {
        // background: linear-gradient(-90deg, #FFFFFF, #00C6FF);
        .text {
          color: rgba(244, 251, 253, 1);
        }

        background-image: url("../img/left_toolbar_nav_btn.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  .right_toolbar {
    position: absolute;
    right: 0;
    top: 7.37rem;
    width: 30rem;
    height: calc(100% - 7.37rem);
    background: rgba(255, 255, 255, 0.85);
    z-index: 2;

    .nav_box {
      display: flex;

      .nav_btn {
        user-select: none;
        flex: 1;
        height: 3.95rem;
        line-height: 3.95rem;
        text-align: center;
        cursor: pointer;

        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3a636f;

        &.select {
          background: #00c6ff;
          color: #f4fbfd;
        }
      }
    }

    .cont {
      padding-top: 8rem;

      .radio_li {
        padding-left: 2.7rem;
        display: flex;
        align-items: center;

        .lm_radio {
          cursor: pointer;
          width: 2.54rem;
          height: 2.54rem;
          border: 0.18rem solid #3a636f;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0);
          display: flex;
          align-items: center;
          justify-content: center;

          .radio_i {
            display: none;
            width: 1.23rem;
            height: 1.23rem;
            background: #00c6ff;
            border-radius: 50%;
          }

          &.select {
            border: 0.18rem solid #00c6ff;

            .radio_i {
              display: inline-block;
            }
          }
        }

        .text {
          margin-left: 1.67rem;
          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
          line-height: 4.39rem;
        }

        .el-select {
          margin-left: 3rem;
          width: 12rem;

          .el-input__inner {
            border-color: rgba(58, 99, 111, 1);
            height: 2.5rem;
            line-height: 2.5rem;

            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3a636f;
          }
        }
      }

      .flex_box {
        margin-top: 8rem;
        display: flex;
        align-items: center;
        margin-left: 3.4rem;

        .span {
          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
        }

        .brightness {
          margin-left: 3.16rem;
          // width: 6.14rem;
          padding: 0 1.2rem;
          height: 2.37rem;
          line-height: 2.37rem;
          border: 0.1rem solid #3a636f;
          border-radius: 0.26rem;

          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
        }
      }

      .slider_box {
        margin-top: 3.6rem;
        margin-left: 2.28rem;
        margin-right: 2.28rem;
      }
    }
  }

  .light_control {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    &.group_control{
      .cont {
        width: 60rem;
        .center_box {
          .flex_box {
            width: 100%;
          }
          .form_item {
            display: flex;
            align-items: center;
            .label{
              margin-right: 1rem;
            }
          }
        }
      }
    }
    .bg {
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgba(7, 7, 7, 0);
      z-index: 0;
    }
    .cont {
      width: 81.67rem;
      // height: 40.88rem;
      background: rgba(244, 251, 253, 0.8);
      border-radius: 0.44rem;
      padding: 2.81rem;
      position: relative;
      z-index: 1;
      .center_box {
        display: flex;
        // align-items: center;
        flex-wrap: wrap; //换行
        align-content: flex-start; //display flex 布局换行后行间距清空。

        .flex_box {
          width: (33.33% - 3.33rem);

          &:nth-child(3n-1) {
            margin: 0 auto;
          }
        }

        .form_item {
          // margin-bottom: 1.5rem;
          height: 8rem;

          &.height_2 {
            height: 16rem;
          }

          .label {
            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3a636f;
          }

          .form_item_content {
            .el-input__icon {
              line-height: 4rem;
            }

            .el-input__inner {
              background: rgba(255, 255, 255, 0);
              height: 4rem;
              line-height: 4rem;
              border: 0;
              border-bottom: 0.15rem solid #3a636f;
              border-radius: 0;

              font-size: 1.8rem;
              font-family: Calibri;
              font-weight: normal;
              color: #3a636f;
            }

            .slider_box {
              margin-top: 0.6rem;
              // margin-left: 2.28rem;
              // margin-right: 2.28rem;
            }
          }
        }
      }

      .bottom_btn {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .btn1 {
          width: 9.91rem;
          height: 4.18rem;
          line-height: 4.18rem;
          text-align: center;
          background: #f4fbfd;
          border: 0.09rem solid #3a636f;
          border-radius: 0.26rem;

          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
          cursor: pointer;
        }

        .btn2 {
          width: 9.91rem;
          height: 4.18rem;
          line-height: 4.18rem;
          text-align: center;
          background: rgba(0, 198, 255, 1);
          border: 0px solid #3a636f;
          border-radius: 0.26rem;

          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #ffffff;
          cursor: pointer;
        }
      }
    }
  }
  .group_bottom_btn{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 2rem;
    .btn1 {
      width: 7.43rem;
      height: 3.13rem;
      line-height: 3.13rem;
      text-align: center;
      background: #f4fbfd;
      border: 0.09rem solid #3a636f;
      border-radius: 0.26rem;

      font-size: 1.8rem;
      font-family: Calibri;
      font-weight: normal;
      color: #3a636f;
      cursor: pointer;
    }

    .btn2 {
      width: 7.43rem;
      height: 3.13rem;
      line-height: 3.13rem;
      text-align: center;
      background: rgba(0, 198, 255, 1);
      border: 0px solid #3a636f;
      border-radius: 0.26rem;

      font-size: 1.8rem;
      font-family: Calibri;
      font-weight: normal;
      color: #ffffff;
      cursor: pointer;
    }
  }
}

.ratio_1920_1080 {
  min-height: 56rem;

  .select_lm {
    margin-left: 0.5rem;
    position: relative;
    &.noSelect{
      .val_box{
        background:rgba(128,128,128,0.5);
        cursor: no-drop;
      }
    }
    &.multiple {
      .li {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .selectDrop {
        margin-left: 1rem;
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 50%;
        border: 0.15rem solid #00c6ff;
        display: flex;
        align-items: center;
        justify-content: center;
        visibility: hidden;

        &.select {
          visibility: initial;
        }

        .drop {
          width: 0.55rem;
          height: 0.55rem;
          background: #00c6ff;
          border-radius: 50%;
        }
      }
    }

    &.select {
      .val_box {
        .icon_x {
          transform: rotateZ(90deg);
        }
      }
    }

    .val_box {
      min-width: 16.97rem;
      height: 2.17rem;
      line-height: 2.17rem;
      border-radius: 0.2rem;
      border: 0.1rem solid #3a636f;
      padding-left: 0.5rem;
      padding-right: 1.2rem;
      cursor: pointer;
      display: flex;
      // align-items: center;
      justify-content: space-between;

      .i {
        top: 0.3rem;
        left: -1.5rem;
        position: absolute;
        margin-right: 0.5rem;
        color: #ff0101;
      }

      .val {
        font-family: Calibri;
        font-weight: normal;
        font-size: 1.8rem;
        color: #3a636f;
        margin-right: 0.5rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .icon_x {
        // transition: all 0.5s;
        position: absolute;
        top: 0.3rem;
        right: 1rem;
        width: 1.6rem;
        height: 1.6rem;
        transform: rotateZ(90deg);
        background-image: url("../img/icon/rightArrow.png");
        background-position: center;
        background-size: 100% 100%;
      }
    }

    .select_xl_lm_bg {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      z-index: 1;
    }

    .select_xl_lm {
      position: absolute;
      right: 0;
      top: 2.9rem;
      // width: 14rem;
      // height: 12rem;
      border: 0.1rem solid #3a636f;
      border-radius: 0.5rem;
      z-index: 1002;
      background: #f4fbfd;

      .ul {
        background: #f4fbfd;
        border-radius: 1rem;
        position: relative;
        z-index: 1;
        max-height: 20rem;
        margin: 0 0.5rem;
      }

      .icon {
        position: absolute;
        right: 1.2rem;
        top: -0.5rem;
        width: 1rem;
        height: 1rem;
        background: #f4fbfd;
        border-top: 0.1rem solid #3a636f;
        border-left: 0.1rem solid #3a636f;
        // border-radius: 0.1rem;
        transform: rotateZ(45deg);
      }

      .li {
        padding-left: 1.25rem;
        padding-right: 1rem;
        height: 2.5rem;
        line-height: 2.5rem;
        font-family: Calibri;
        font-weight: normal;
        font-size: 1.8rem;
        color: #3a636f;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &.select{
          background: #e3f9ff;
        }
        .edit {
          margin-left: 1rem;
          visibility: hidden;
          display: inline-block;
          width: 1.5rem;
          height: 1.5rem;
          background-image: url("../img/icon/edit.png");
          background-size: 100%;
          background-position: center;
        }
        &:hover {
          background: #e3f9ff;
          .edit {
            visibility: initial;
          }
        }
        .text {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .top_box {
    height: 5.79rem;
    background: #f6f8fa;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .top_left_box {
      display: flex;
      align-items: center;
      .select_lm{
        .val_box{
          border-radius: 0.5rem;
          height: 3.5rem;
          line-height: 3.5rem;
          border-bottom: 0.15rem solid #3a636f;
          padding-right: 3rem;
          .val{
            font-size: 1.8rem;
          }
          .icon_x {
            top: 1rem;
          }
        }
        .select_xl_lm {
          top: 4.2rem;
          width: 16.97rem;
        }
      }
      .sport_stadium {
        width: 2rem;
        height: 1.4rem;
        background-image: url("../img/icon/sport_stadium.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin-left: 1.84rem;
        margin-right: 2.28rem;
        cursor: pointer;
      }

      .text {
        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3a636f;
      }

      .lock {
        margin-left: 3.55rem;
        cursor: pointer;
        .img {
          width: 2.1rem;
          height: 2.43rem;
        }
        .img.lock_1 {
          background-image: url("../img/lock_1.png");
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          // width: 100%;
          // height: 100%;
        }
        .img.lock_2 {
          background-image: url("../img/lock_2.png");
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          
          // height: 1.4rem;
        }
      }
      .refresh{
        margin-left: 2rem;
        cursor: pointer;
        .img {
          height: 2.43rem;
          width: 2.43rem;
        // }
          background-image: url("../img/refresh.png");
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }
    }

    .top_right_box {
      margin-right: 0.7rem;
      align-items: center;
      .zoneTime {
        margin-right: 1rem;
        color: #3a636f;
        font-size: 1.8rem;
      }
      .setting {
        width: 3rem;
        height: 3rem;
        background-image: url("../img/icon/setting.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin-right: 1.5rem;
        cursor: pointer;
        // align-items: center;
      }
      .signOut_btn_box {
        position: relative;
        display: flex;
        cursor: pointer;
        height: 5.79rem;
        display: flex;
        align-items: center;
        margin-right: 1rem;
        .avatar{
          // width: 2.22rem;
          // height:2.22rem;
          width: 3rem;
          height: 3rem;
          margin-right: 0.7rem;
        }
        .avatar0 {
          background-image: url(../img/login/login_1.png);
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      .p_box{
        .p1{
          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: 400 ;
          color: #3a636f;
        }
        .p2{
          font-size: 1rem;
          font-family: Calibri;
          font-weight: 400 ;
          color: #3a636f;
        }
      }
      .logout-wrap-style{
        display: none;
        position: absolute;
        top: 5.8rem;
        left: -3.2rem;
        z-index: 9999;
        background-color:#f6f8fa;
        border-radius:0.39rem 0.39rem 0.39rem 0.39rem;
        width: 12.58rem;
        height: 3.16rem;
        line-height: 3.16rem;

        font-family: Calibri;
        font-weight: 400;
        color: #3a636f;
        
        font-size: 1.8rem;
        // color: #777A8A;
        box-shadow: 0rem 0.13rem 0.66rem 0rem rgba(0,0,0,0.08);
        white-space: nowrap;
        margin-right: 1rem;
        .p{
          display: flex;
          align-items: center;
          .img{
            width: 2rem;
            height: 2rem;
            margin: 0 0.53rem 0 0.53rem;
          }
        }
      }
      &:hover {
        .logout-wrap-style {
          display: block;
        }
      }
    }
    }
    
  }

  .left_toolbar {
    position: absolute;
    top: 6.9rem;
    left: 0;
    width: 30rem;
    height: calc(100% - 5.78rem);
    background: rgba(255, 255, 255, 0.85);
    // background-image: url("../img/home/leftMenu_bg.png");
    z-index: 2;
    .top_bg{
      width: 100%;
      height: 1.2rem;
      background-color: #f4fbfd;
    }
    .icon_lj {
      position: absolute;
      width: 1.6rem;
      height: 1.6rem;
      background: #f4fbfd;
      transform: rotateZ(45deg);
      top: -0.8rem;
      left: 2rem;
    }
    .p1 {
      font-size: 1.8rem;
      font-family: Calibri;
      font-weight: normal;
      color: #3a636f;
      margin-top: 3.88rem;
      margin-left: 2.96rem;
    }

    .project_information {
      margin: 1.84rem auto 2.11rem;
      width: 25rem;
      height: 17rem;
      background: #f4fbfd;
      border-radius: 1.75rem;
      padding: 1.97rem 0 0 1.51rem;

      .p2 {
        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3a636f;
        margin-bottom: 1.4rem;
        display: flex;
        align-items: center;
      }

      .flex_box {
        display: flex;
        position: relative;
        margin-bottom: 0.5rem;
      }

      .lamp_online {
        width: 2.04rem;
        height: 2.04rem;
        background-image: url("../img/icon/lamp_online.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin-right: 1.45rem;
        margin-bottom: 0.99rem;
      }

      .lamp_fault {
        width: 1.38rem;
        height: 1.78rem;
        background-image: url("../img/icon/lamp_fault.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin-right: 1.78rem;
        margin-bottom: 1.25rem;
        margin-left: 0.33rem;
      }

      .lamp_outline {
        width: 1.38rem;
        height: 1.78rem;
        background-image: url("../img/icon/lamp_outline.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin-right: 1.71rem;
        margin-bottom: 1rem;
        margin-left: 0.33rem;
      }

      .temp {
        position: absolute;
        left: 1.63rem;
        top: 0.86rem;
        width: 0.59rem;
        height: 1.25rem;
        background-image: url("../img/icon/temp.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .span {
        // font-size: 1.23rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3a636f;

        font-size: 1.64rem;
      }

      .download_btn_1 {
        position: absolute;
        top: 0.5rem;
        right: 2.63rem;
        width: 1.78rem;
        height: 1.64rem;
        cursor: pointer;
        .download_icon {
          background-image: url("../img/icon/download_icon.png");
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          width: 100%;
          height: 100%;
        }
      }

      .download_btn_2 {
        position: absolute;
        top: 0.5rem;
        right: 2.63rem;
        width: 1.78rem;
        height: 1.64rem;
        cursor: pointer;

        .download_icon {
          background-image: url("../img/icon/download_icon.png");
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          width: 100%;
          height: 100%;
        }
      }
    }
    .nav_btn_box{
      height: calc(100% - 32rem);
    }
    .nav_btn {
      width: 100%;
      height: 3.16rem;
      display: flex;
      align-items: center;
      cursor: pointer;
      padding-left: 3.7rem;
      user-select: none;
      margin-bottom: 1.2rem;
      &:hover .home {
        background-image: url("../img/icon/home_hover.png");
      }

      &:hover .sence_setting {
        background-image: url("../img/icon/sence_setting_hover.png");
      }

      &:hover .calendar {
        background-image: url("../img/icon/calendar_hover.png");
      }

      &:hover .system_setting {
        background-image: url("../img/icon/system_setting_hover.png");
      }

      &:hover .dev_setting {
        background-image: url("../img/icon/dev_setting_hover.png");
      }

      &:hover .group_setting {
        background-image: url("../img/icon/group_setting_hover.png");
      }

      &:hover .power_consumption {
        background-image: url("../img/icon/power_consumption_hover.png");
      }

      .home {
        width: 2.11rem;
        height: 1.95rem;
        background-image: url("../img/icon/home.png");
        margin-right: 1.18rem;
      }

      .sence_setting {
        width: 2.04rem;
        height: 2.04rem;
        background-image: url("../img/icon/sence_setting.png");
        margin-right: 1.18rem;
      }

      .calendar {
        width: 2.04rem;
        height: 2.04rem;
        background-image: url("../img/icon/calendar.png");
        margin-right: 1.18rem;
      }

      .system_setting {
        width: 2.11rem;
        height: 1.91rem;
        background-image: url("../img/icon/system_setting.png");
        margin-right: 1.12rem;
      }

      .dev_setting {
        width: 2.17rem;
        height: 2.04rem;
        background-image: url("../img/icon/dev_setting.png");
        margin-right: 1.18rem;
      }

      .group_setting {
        width: 2.76rem;
        height: 2.17rem;
        background-image: url("../img/icon/group_setting.png");
        margin-right: 0.79rem;
      }

      .power_consumption {
        width: 1.71rem;
        height: 1.71rem;
        background-image: url("../img/icon/power_consumption.png");
        margin-right: 1.38rem;
      }

      .text {
        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3a636f;
      }

      // background: linear-gradient(-90deg, rgba(255, 255, 255, 1),rgba(0, 198, 255, 1), rgba(0, 198, 255, 1));

      &:hover {
        // background: linear-gradient(-90deg, #FFFFFF, #00C6FF);
        .text {
          color: rgba(244, 251, 253, 1);
        }

        background-image: url("../img/left_toolbar_nav_btn.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      &.noSelect{
        
        &:hover {
          background:rgba(128,128,128,0.5);
          cursor: no-drop;
        }
      }
    }
  }

  .left_toolbar_box{
    position: absolute;
    top: 0;left: 0;right: 0;bottom: 0;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.2);
    .bg{
      width: 100%;height: 100%;
    }
  }
  .right_toolbar_box{
    position: absolute;
    top: 0;left: 0;right: 0;bottom: 0;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.2);
    .bg{
      width: 100%;height: 100%;
    }
  }
  .right_toolbar {
    position: absolute;
    right: 0;
    top: 6.9rem;
    width: 40rem;
    height: calc(100% - 6.9rem);
    background: rgba(255, 255, 255, 0.85);
    z-index: 2;

    .icon_lj {
      position: absolute;
      width: 1.6rem;
      height: 1.6rem;
      background: #f4fbfd;
      transform: rotateZ(45deg);
      top: -0.8rem;
      right: 10.3rem;
    }

    .nav_box {
      display: flex;
      position: relative;
      z-index: 1;

      .nav_btn {
        user-select: none;
        flex: 1;
        height: 3rem;
        line-height: 3rem;
        text-align: center;
        cursor: pointer;

        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3a636f;
        background: rgba(244, 251, 253, 1);

        &.select {
          background: #00c6ff;
          color: #f4fbfd;
        }
      }
    }

    .cont {
      padding-top: 0rem;
      height: calc(100% - 3rem);
      .radio_li {
        padding-left: 2.7rem;
        display: flex;
        align-items: center;

        .lm_radio {
          cursor: pointer;
          width: 1.91rem;
          height: 1.91rem;
          border: 0.13rem solid #3a636f;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0);
          display: flex;
          align-items: center;
          justify-content: center;

          .radio_i {
            display: none;
            width: 0.92rem;
            height: 0.92rem;
            background: #00c6ff;
            border-radius: 50%;
          }

          &.select {
            border: 0.13rem solid #00c6ff;

            .radio_i {
              display: inline-block;
            }
          }
        }

        .text {
          margin-left: 1.67rem;
          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
          line-height: 4.39rem;
        }

        .el-select {
          margin-left: 3rem;
          width: 12rem;

          .el-input__inner {
            border-color: rgba(58, 99, 111, 1);
            background: rgba(0, 0, 0, 0);
            height: 2.5rem;
            line-height: 2.5rem;

            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3a636f;
          }

          .el-input__icon {
            font-size: 1.8rem;
            line-height: 2rem;
            color: #3a636f;
          }
        }
      }

      .flex_box {
        margin-top: 2rem;
        display: flex;
        align-items: center;
        margin-left: 3.4rem;

        .span {
          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
        }

        .brightness {
          margin-left: 3.16rem;
          // width: 6.14rem;
          padding: 0 1.2rem;

          height: 2.5rem;
          line-height: 2.5rem;

          border: 0.1rem solid #3a636f;
          border-radius: 0.26rem;

          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
        }
      }

      .slider_box {
        // margin-top: 3.6rem;
        margin-left: 2.28rem;
        margin-right: 2.28rem;
      }

      .rightToolbar2 {
        padding-top: 3.22rem;
        .bottom_btn {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          width: 100%;
          margin-top: 2rem;
          padding: 0 2rem;
          .btn2 {
            width: 8rem;
            height: 3rem;
            line-height: 3rem;
            text-align: center;
            background: rgba(0, 198, 255, 1);
            border: 0px solid #3a636f;
            border-radius: 0.26rem;

            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #ffffff;
            cursor: pointer;
          }
        }
      }

      .rightToolbar1 {
        padding-top: 2.63rem;
        padding-left: 2.83rem;
        padding-right: 1rem;
        height: 100%;

        .li {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 2.5rem;
        }

        .lebel {
          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
        }

        .val1 {
          // margin-top: 1.18rem;
          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
        }

        .val2 {
          // margin-top: 4.61rem;
          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
        }

        .apply_box {
          // margin-left: auto;
          // margin-top: 1.51rem;
          display: flex;
          align-items: center;

          .apply {
            width: 9.2rem;
            height: 3.5rem;
            line-height: 2.5rem;
            border: 0.1rem solid #3a636f;
            border-radius: 0.44rem;
            background-color: rgba(244, 251, 253, 0);

            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3a636f;
            cursor: pointer;

            &.select {
              background-color: #00c6ff;
              border-color: #00c6ff;
              color: #fff;
            }
          }

          .icon_box {
            position: relative;
            display: flex;
            align-items: center;
            width: 3rem;
            justify-content: center;

            .img {
              // margin-top: 2.81rem;
              // margin-left: 3.71rem;
              // margin-right: 3.8rem;
              width: 0.5rem;
              background-image: url(../img/point3.png);
              background-position: center;
              background-size: 100% 100%;

              height: 2rem;
              padding: 0;
              cursor: pointer;
            }

            .bg {
              position: fixed;
              top: 0;
              left: 0;
              top: 0;
              bottom: 0;
              right: 0;
              background: rgba(0, 0, 0, 0);
              z-index: 1;
              display: none;

              &.show {
                display: block;
              }
            }

            .popper_ul {
              // background: #fff;
              // width: 10.35rem;
              // height: 8.51rem;
              background: #f4fbfd;
              border: 1px solid #3a636f;
              border-radius: 0.44rem;

              display: none;
              position: absolute;
              top: 3rem;
              right: 0rem;
              z-index: 2;
              &.position{
                top: initial;
                bottom: 3rem;
                .icon {
                  top: initial;
                  bottom: -0.5rem;
                  border-top: none;
                  border-left: none;
                  border-bottom: 0.1rem solid #3a636f;
                  border-right: 0.1rem solid #3a636f;
                }
              }

              .ul {
                background: #f4fbfd;
                border-radius: 0.44rem;
                position: relative;
                z-index: 1;
                padding-top: 0.5rem;
              }

              .icon {
                position: absolute;
                right: 0.9rem;
                top: -0.5rem;
                width: 1rem;
                height: 1rem;
                background: #f4fbfd;
                border-top: 0.1rem solid #3a636f;
                border-left: 0.1rem solid #3a636f;
                // border-radius: 0.1rem;
                transform: rotateZ(45deg);
              }

              .popper_li {
                font-size: 1.8rem;
                font-family: Calibri;
                font-weight: normal;
                color: #3a636f;
                // margin-left: 1rem;
                // margin-right: 1rem;
                white-space: nowrap;
                margin: 0 1rem 0.5rem 1rem;
                cursor: pointer;
              }

              // .popper_li_1 {
              //   font-size: 1.83rem;
              //   font-family: Calibri;
              //   font-weight: normal;
              //   color: #3a636f;
              //   margin-left: 1.4rem;
              //   margin-top: 0.8rem;
              // }
              // font-size: 1.83rem;
              // font-family: Calibri;
              // font-weight: normal;
              // color: #3A636F;
              &.show {
                display: block;
              }
            }
          }
        }

        .btn {
          margin-top: 4.28rem;
          // width: 15.88rem;
          width: 8.37rem;
          // padding: 0 0.5rem;
          height: 2.04rem;
          line-height: 2.04rem;
          border: 0.09rem solid #3a636f;
          border-radius: 0.44rem;
          display: flex;
          align-items: center;
          cursor: pointer;

          .icon {
            margin: 0 0.79rem 0 0.5rem;
            width: 1.51rem;
            height: 1.51rem;
            background-image: url(../img/icon/btn_bg1.png);
            background-position: center;
            background-size: 100% 100%;
          }
        }
      }
    }
  }

  .light_control {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    &.wg_control{
      .cont {
        .center_box{

          .flex_box{
            width: 50%;
          }
        }
      }
    }
    .bg {
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgba(7, 7, 7, 0);
      z-index: 0;
    }

    .cont {
      width: 86.71rem;
      // height: 36.18rem;
      background: rgba(244, 251, 253, 1);
      padding: 3.36rem 4.93rem 0 3.42rem;
      opacity: 0.9;
      border-radius: 0.39rem;
      .center_box {
        display: flex;
        // align-items: center;
        flex-wrap: wrap; //换行
        align-content: flex-start; //display flex 布局换行后行间距清空。

        .flex_box {
          width: (33.33% - 3.33rem);

          &:nth-child(3n-1) {
            margin: 0 auto;
          }
        }

        .form_item {
          // margin-bottom: 1.5rem;
          display: flex;
          align-items: center;
          height: 6rem;

          &.height_2 {
            height: 9rem;
            display: flex;
            // align-items: center;
            flex-wrap: wrap; //换行
            align-content: flex-start; //display flex 布局换行后行间距清空。
            .label,.form_item_content{
              width: 100%;
            }

          }

          .label {
            margin-right: 0.5rem;
            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3a636f;
          }

          .form_item_content {
            .text {
              // height: 2.5rem;
              // line-height: 2.5rem;
              font-size: 1.8rem;
              font-family: Calibri;
              font-weight: normal;
              color: #3a636f;
            }
            .select_lm {
              margin-left: 0rem;
            }
            .val_box {
              height: 2.5rem;
              line-height: 2.5rem;
              border: none;
              border-bottom: 0.15rem solid #3a636f;
              // padding: 0 0.5rem;
            }
            .el-input__icon {
              line-height: 2.5rem;
            }

            .el-input__inner {
              background: rgba(255, 255, 255, 0);
              height: 2.5rem;
              line-height: 2.5rem;
              border: 0;
              border-bottom: 0.15rem solid #3a636f;
              border-radius: 0;

              font-size: 1.8rem;
              font-family: Calibri;
              font-weight: normal;
              color: #3a636f;
            }

            .slider_box {
              margin-top: 2.6rem;
              // margin-left: 2.28rem;
              // margin-right: 2.28rem;
            }
          }
        }
      }

      .bottom_btn {
        display: flex;
        justify-content:flex-end;
        align-items: center;
        margin-top: 3rem;
        margin-bottom: 3.36rem;
        .btn1 {
          width: 9.47rem;
          height: 3.16rem;
          line-height: 3.16rem;
          text-align: center;
          background: #f4fbfd;
          border: 0.09rem solid #3a636f;
          border-radius: 0.26rem;
          margin-right: 5.2rem;

          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
          cursor: pointer;
        }

        .btn2 {
          border-radius: 0.2rem;
          border: 0.99px solid #00C6FF;

          width: 7.43rem;
          height: 3.13rem;
          line-height: 3.13rem;
          text-align: center;
          background: rgba(0, 198, 255, 1);
          // border: 0px solid #3a636f;

          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #ffffff;
          cursor: pointer;
        }
      }
    }
  }
  .notice {
    background: rgba(244, 251, 253, 0.9);
    height: 3.55rem;
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    display: flex;
    .point {
      font-family: Adobe Heiti Std;
      font-weight: normal;
      font-size: 1.8rem;
      color: #E4F9FF;
      background: #FF0000;
      border-radius: 50%;
      // border: 1px solid #FF0000;
      width: 2.38rem;
      height: 2.38rem;
      line-height: 2.38rem;
      // line-height: 3.55rem;
      margin: 0.79rem 1.05rem 2.76rem 0;
      // padding: 0 0 2.76rem 0;
      text-align: center;
    }
    .span {
      line-height: 3.55rem;
      font-family: Calibri;
      font-weight: 400;
      font-size: 1.8rem;
      color: #FF0000;
      overflow: hidden;
    }
  }
}

.home_main.themeType_1{
  .top_box {
    background: #fe5e08;
    .top_left_box {
      .sport_stadium {
        background-image: url("../img/orange/sport_stadium.png");
      }
      .lock {
        .img.lock_1 {
          background-image: url("../img/orange/lock_1.png");
        }
        .img.lock_2 {
          background-image: url("../img/orange/lock_2.png");
        }
      }
      .refresh {
        .img {
          width: 1.54rem;
          height: 1.54rem;
          background-image: url("../img/orange/refresh.png");
        }
      }
      .text {
        color: #682411;
      }
      .select_lm {
        .icon_x {
          width: 0.8rem;
          height: 1.2rem;
          right: 1.4rem;
          top: 1.2rem;
          background-image: url("../img/orange/rightArrow.png");
        }
      }
    }
    .top_right_box {
      .zoneTime {
        color: #ffffff;
      }
      .signOut_btn_box .p_box .p1 ,
      .signOut_btn_box .p_box .p2{
        color: #ffffff;
      }
      .setting {
        background-image: url("../img/orange/setting.png");
      }
      .signOut_btn_box .avatar0 {
        background-image: url(../img/orange/login_2.png);
      }
      .logout-wrap-style{
        background-color:#faedda;
        color: #682411;
        box-shadow: 0rem 0.13rem 0.66rem 0rem rgba(0,0,0,0.08);
      }
    }
  }
  .select_lm {
    .val_box{
      background: #faedda;
      
      border: 0.15rem solid #682411;
      .val {
        color: #682411;
      }
    }
    &.noSelect{
      .val_box{
        background:rgba(128,128,128,0.5);
        cursor: no-drop;
      }
    }
    &.multiple {
      .selectDrop {
        border: 0.15rem solid #e09259;
        .drop {
          background: #e09259;
        }
      }
    }
  }
  .select_xl_lm {
    border: 0.1rem solid #682411;
    background: #faedda;
    .ul {
      background: #faedda;
    }
    .icon {
      border-top: 0.1rem solid #682411;
      border-left: 0.1rem solid #682411;
    }
    .li {
      color: #682411;
      .edit {
        background-image: url("../img/orange/edit.png");
      }
      &.select {
        background: #fdbe6e;
      }
      &:hover {
        background: #fdbe6e;
        
      }
    }
  }

  .left_toolbar {
    // border: 0.1rem solid #682411;
    background: rgba(250 , 237 , 218 , 0.85);
    .icon_lj {
      background: #faedda;
    }
    .top_bg {
      background: #faedda;
    }
    .text {
      color: #682411;
    }
    .project_information {
      background: rgba(242, 205, 155, 0.5);
    }
    .download_btn_1 {
      height: 1.5rem;
      .download_icon {
        background-image: url("../img/orange/download_icon.png");
      }
    }
    .download_btn_2 {
      height: 1.5rem;
      .download_icon {
        background-image: url("../img/orange/download_icon.png");
      }
    }
    .nav_btn {
      &:hover .home {
        background-image: url("../img/icon/home_hover.png");
      }

      &:hover .sence_setting {
        background-image: url("../img/icon/sence_setting_hover.png");
      }

      &:hover .calendar {
        background-image: url("../img/icon/calendar_hover.png");
      }

      &:hover .system_setting {
        background-image: url("../img/icon/system_setting_hover.png");
      }

      &:hover .dev_setting {
        background-image: url("../img/icon/dev_setting_hover.png");
      }

      &:hover .group_setting {
        background-image: url("../img/icon/group_setting_hover.png");
      }

      &:hover .power_consumption {
        background-image: url("../img/icon/power_consumption_hover.png");
      }
      .home {
        background-image: url("../img/orange/home.png");
      }
      .sence_setting {
        background-image: url("../img/orange/sence_setting.png");
      }
      .calendar {
        background-image: url("../img/orange/calendar.png");
      }
      .system_setting {
        background-image: url("../img/orange/system_setting.png");
      }
      .dev_setting {
        background-image: url("../img/orange/dev_setting.png");
      }
      .group_setting {
        background-image: url("../img/orange/group_setting.png");
      }
      .power_consumption {
        background-image: url("../img/orange/power_consumption.png");
      }
      &:hover {
        // background: linear-gradient(-90deg, #FFFFFF, #00C6FF);
        background-image: none;
        background-color: #fdbe6e;
      }
      &.noSelect{
        
        &:hover {
          background:rgba(128,128,128,0.5);
          cursor: no-drop;
        }
      }
    }
  }
  .right_toolbar {
    background: rgba(250 , 237 , 218 , 0.85);
    .icon_lj {
      background: #faedda;
    }
    .nav_box {
      .nav_btn {
        color: #682411;
        background: #faedda;
        &.select {
          background: #fdbe6e;
          color: #f4fbfd;
        }
      }
    }
    .cont {
      .radio_li {
        .lm_radio {
          border: 0.13rem solid #3a636f;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0);
          .radio_i {
            background: #e09259;
          }
          &.select {
            border: 0.13rem solid #e09259;
          }
        }
        .text {
          color: #682411;
        }
        .el-select {
          .el-input__inner {
            border-color: #682411;
            background: rgba(0, 0, 0, 0);
            color: #682411;
          }
          .el-input__icon {
            font-size: 1.8rem;
            line-height: 2rem;
            color: #682411;
          }
          .el-select-dropdown__item {
            &:hover {
                background: #faedda;
            }
          }
        }
      }

      .flex_box {
        margin-top: 8rem;
        display: flex;
        align-items: center;
        margin-left: 3.4rem;
        .span {
          color: #682411;
        }
        .brightness {
          border: 0.1rem solid #682411;
          color: #682411;
        }
      }
      .rightToolbar2 {
        .bottom_btn {
          .btn2 {
            background: #f44336;
            border: 0px solid #682411;
            color: #ffffff;
          }
        }
        .radio_li {
          .el-select-dropdown.text_select {
            border: 1px solid #682411;
            .el-select-dropdown {
              opacity: 0.9;
              border: 1px solid #682411;
            }
            .el-select-dropdown__item{
              color: #682411;
            }
          }
        }
        .slider_box .slider_b .span1, 
        .slider_box .slider_b .span2 {
          color: #682411;
        }
        
      }
      .rightToolbar1 {
        .lebel , .val1, .val2 {
          color: #682411;
        }
        .apply_box {
          .apply {
            border: 0.1rem solid #682411;
            background-color: #f2cd9b;
            color: #682411;
            &.select {
              background-color: #f44336;
              border-color: #f44336;
              color: #fff;
            }
          }
          .icon_box {
            position: relative;
            display: flex;
            align-items: center;
            width: 3rem;
            // height: 2rem;
            justify-content: center;

            .img {
              // margin-top: 2.81rem;
              // margin-left: 3.71rem;
              // margin-right: 3.8rem;
              background-image: url(../img/orange/point3.png);
              height: 2rem;
              width: 0.5rem;
              padding: 0 ;
              cursor: pointer;
            }

            .bg {
              position: fixed;
              top: 0;
              left: 0;
              top: 0;
              bottom: 0;
              right: 0;
              background: rgba(0, 0, 0, 0);
              z-index: 1;
              display: none;

              &.show {
                display: block;
              }
            }

            .popper_ul {
              // background: #fff;
              // width: 10.35rem;
              // height: 8.51rem;
              background: #faedda;
              border: 1px solid #682411;
              border-radius: 0.44rem;

              display: none;
              position: absolute;
              top: 3rem;
              right: 0rem;
              z-index: 2;
              &.position{
                top: initial;
                bottom: 3rem;
                .icon {
                  top: initial;
                  bottom: -0.5rem;
                  border-top: none;
                  border-left: none;
                  border-bottom: 0.1rem solid #682411;
                  border-right: 0.1rem solid #682411;
                }
              }

              .ul {
                background: #faedda;
                border-radius: 0.44rem;
                position: relative;
                z-index: 1;
                padding-top: 0.5rem;
              }

              .icon {
                position: absolute;
                right: 0.9rem;
                top: -0.5rem;
                width: 1rem;
                height: 1rem;
                background: #faedda;
                border-top: 0.1rem solid #682411;
                border-left: 0.1rem solid #682411;
                // border-radius: 0.1rem;
                transform: rotateZ(45deg);
              }

              .popper_li {
                font-size: 1.8rem;
                font-family: Calibri;
                font-weight: normal;
                color: #682411;
                // margin-left: 1rem;
                // margin-right: 1rem;
                white-space: nowrap;
                margin: 0 1rem 0.5rem 1rem;
                cursor: pointer;
              }
              &.show {
                display: block;
              }
            }
          }
        }

        .btn {
          margin-top: 4.28rem;
          // width: 15.88rem;
          width: 8.37rem;
          // padding: 0 0.5rem;
          height: 2.04rem;
          line-height: 2.04rem;
          border: 0.09rem solid #3a636f;
          border-radius: 0.44rem;
          display: flex;
          align-items: center;
          cursor: pointer;

          .icon {
            margin: 0 0.79rem 0 0.5rem;
            width: 1.51rem;
            height: 1.51rem;
            background-image: url(../img/icon/btn_bg1.png);
            background-position: center;
            background-size: 100% 100%;
          }
        }
      }
    }
  }
  .light_control {
    .cont {
      background: #faedda;
      .center_box {
        .form_item {
          .label {
            color: #682411;
          }
          .form_item_content {
            .text {
              color: #682411;
            }
            .val_box {
              border-bottom: 0.15rem solid #682411;
              // padding: 0 0.5rem;
              .icon_x {
                width: 1rem;
                height: 1.7rem;
                background-image: url("../img/orange/rightArrow.png");
              }
            }
            .el-input__inner {
              background: rgba(255, 255, 255, 0);
              border-bottom: 0.15rem solid #682411;
              color: #682411;
            }
          }
        }
      }
      .bottom_btn {
        .btn1{
          background: #f2cd9b;
          border: 0.09rem solid #682411;
          color: #682411;
        }
        .btn2{
          background: #f44336;
          border: 0.09rem solid #f44336;
          color: #ffffff;
        }
      }
    }
  }
  .group_bottom_btn{
    .btn1 {
      background: #f2cd9b;
      border: 0.1rem solid #682411;
      color: #682411;
    }
    .btn2 {
      background: #f44336;
      border: 0.09rem solid #f44336;
      color: #ffffff;
    }
  }
  .select_popper.el-select-dropdown {
      background: #faedda;
      border: 0.09rem solid #682411;
      border-radius: 0.44rem;
      .el-select-dropdown__item{
        &:hover {
          background: #fdbe6e;
        }
      }
     
    }
  .scrollbar_style::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 0.5rem;
    // background: #DAE6E0;
    background: #682411;
  }
  .scrollbar_style::-webkit-scrollbar-track {/*滚动条里面轨道*/
      background: #faedda;
  }
  
  //账户设置
  .systemSetting_main{
    background: rgba(250,237,218,0.85);
    .cont_left {
      .p1{
        color: #682411;
      }
      .avatar_box .avatar {
            &.avatar0{
              background-image: url(../img/orange/login_1.png);
            }
        }
      .select1 .select_lm {
        .val_box{
          background: #faedda;
          border: 0.15rem solid #682411;
          color: #682411;
          .icon_x {
            width: 0.8rem;
            height: 1.4rem;
            right: 1.6rem;
            top: 1.1rem;
            background-image: url("../img/orange/rightArrow.png");
          }
        }
        .select_xl_lm {
          border: 0.1rem solid #682411;
          background: #faedda;
          .icon {
            border-top: 0.1rem solid #682411;
            border-left: 0.1rem solid #682411;
          }
          .ul {
            background: #faedda;
            .text {
              color: #682411;
              .form_item .btn{
                  &.btn0{
                    background-image: url('../img/orange/btn_bg1.png');
                  }
              }
            }
            .li {
              // background: #fdbe6e;
              &.select {
                background: #fdbe6e;
              }
              &:hover {
                background: #fdbe6e;
                
              }
            }
          }
        }
      }
      .form_box {
        background: rgba(242, 205, 155, 0.5);
        .input1 .el-input__inner {
          background: #faedda;
          border: 0.09rem solid #682411;
          color: #682411;
        }
        // .input1 {
        //   .el-input__prefix {
        //     .icon {
        //       // width: 100%;
        //     }
        //     .icon.icon1 {
        //       background-image: url(../img/orange/login_1.png);
        //     } 
        //     .icon.icon2 {
        //       background-image: url(../img/orange/login_1.png);
        //     } 
        //     .icon.icon3 {
        //       background-image: url(../img/orange/login_3.png);
        //     } 
        //     .icon4 {
        //       background-image: url(../img/orange/login_4.png);
        //       // width: 5.53rem;
        //       height: 1.8rem;
        //     }
        //   }
        
        // }
        .addUser_btn {
          width: 5.1rem;
          height: 4.4rem;
          background-image: url(../img/orange/icon_add.png);
          .icon {
            display: none;
          }
        }
        .btn_box .btn1{
          background: #f2cd9b;
          border: 0.09rem solid #682411;
          color: #682411;
        }
        .btn_box .btn2{
          background: #f44336;
          border: 0.09rem solid #f44336;
          color: #ffffff;
        }
      }
    }
    .cont_right {
      .p1{
        color: #682411;
      }
      .input1 .select_lm {
        .val_box{
          // background: #faedda;
          border: 0.15rem solid #682411;
          .icon {
            background-image: url(../img/orange/timeZone.png);
          }
          .val {
            color: #682411;
          }
          .icon_x {
            width: 0.8rem;
            height: 1.4rem;
            right: 1.6rem;
            top: 1rem;
            background-image: url("../img/orange/rightArrow.png");
          }
        }
        .select_xl_lm {
          border: 0.1rem solid #682411;
          background: #faedda;
          .icon {
            border-top: 0.1rem solid #682411;
            border-left: 0.1rem solid #682411;
          }
          .ul {
            background: #faedda;
            .text {
              color: #682411;
            }
          }
          .li {
            // background: #fdbe6e;
            &.select {
              background: #fdbe6e;
            }
            &:hover {
              background: #fdbe6e;
              
            }
          }
        }
      }
      .skin_setting{
        .li {
          &.add {
            background-image: url(../img/orange/btn_bg1.png);
            background-position: center;
            background-size: 100% 100%;
          }
        }
      }
      .contacts_settings {
        .box{
          background: #e09259;
          border: 0.1rem solid #682411;
          .box_r .el-input .el-input__inner {
            background: #faedda;
            border: 0.09rem solid #682411;
            color: #682411;
          }
          .box_r .el-input.input3 .el-input__inner {
            background: #faedda;
            // border: 0.09rem solid #682411;
            color: #682411;
          }
          .box_l .text {
            color: #682411;
          }
          &.box3 {
            .box_l {
              flex-direction: column;
              .icon {
                width: 1.6rem;
                height: 2.5rem;
                margin: 0.2rem 0 0;
                background-image: url(../img/orange/icon3.png);
              }
            }
          }
        }
        // .box.box3 .box_l .icon {
        //   background-image: url(../img/orange/icon3.png);
        // }
        
      }
      .project_settings .button,
      .btn_box .btn1{
        background: #f2cd9b;
        border: 0.09rem solid #682411;
        color: #682411;
      }
      .btn_box .btn2{
        background: #f44336;
        border: 0.09rem solid #f44336;
        color: #ffffff;
        &.noSelect{
          background:rgba(128,128,128,0.5);
          border-color:rgba(128,128,128,0.5);
          cursor: no-drop;
        }
      }
    }
  }
  //情景设置 
  .scensSetting_main {
    background: rgba(250,  237, 218, 0.9);
    .search {
      .el-input__inner {
        border: 0.09rem solid #682411;
        background: rgb(255, 252, 249);
        color: #682411;
      }
    }
    .cont_ul {
      background: rgb(255, 252, 249);
      .sceneSettingBox {
        border-bottom: 0.1rem solid #682411;
        .title {
          .el-icon-arrow-right {
            color: #682411;
          }
          .text {
            color: #682411;
          }
          .box_2 {
            .apply {
              border: 0.1rem solid #682411;
              background-color: #f2cd9b;
              color: #682411;
              &.select {
                background-color: #f44336;
                border-color: #f44336;
                color: #fff;
              }
            }
            // .img {
            //   background-image: url(../img/orange/point3.png);
            //   width: 1rem;
            //   height: 2rem;
            //   background-position: center;
            //   background-repeat: no-repeat;
            //   background-size: 100% 100%;

            //   // margin-top: 2.81rem;
            //   padding: 0 0.5rem;
            //   margin: 0;
            //   cursor: pointer;
            // }
            .icon_box {

              .img {
                background-image: url(../img/orange/point3.png);
                width: 1rem;
                height: 2rem;
                background-position: center;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                padding: 0;
                width: 0.5rem;
                padding: 0 ;
              }
              // .img {
              //   // margin-top: 2.81rem;
              //   height: 2rem;
              //   padding: 0 0.5rem;
              //   cursor: pointer;
              // }
              .popper_ul {
                background: #faedda;
                border: 1px solid #682411;
                &.position{
                  .icon {
                    border-top: none;
                    border-left: none;
                    border-bottom: 0.1rem solid #682411;
                    border-right: 0.1rem solid #682411;
                  }
                }
                .ul {
                  background: #faedda;
                }
                .icon {
                  background: #faedda;
                  border-top: 0.1rem solid #682411;
                  border-left: 0.1rem solid #682411;
                }
                .popper_li {
                  color: #682411;
                }
                &.show {
                  display: block;
                }
              }
            }
          }
        }
        .body_paragraph {
          .paragraph {
            color: #682411;
          }
        }
      }
    }
    .flex_box {
      .button {
        background: #f44336;
        border: 0.09rem solid #f44336;
        color: #ffffff;
      }
    }
    .el-icon-circle-plus-outline {
      color: #682411;
    }
    .dialog_box{
      .form_box{
        background: #FFFFFF;
        border: 1px solid #682411;
        opacity: 1;
        .span{
          color: #682411;
        }
        .btn_box{
          .btn1{
            background: #f2cd9b;
            border: 0.1rem solid #682411;
            color: #682411;
          }
          .btn2{
            background: #f44336;
            border: 0.09rem solid #f44336;
            color: #ffffff;
          }
        }
      }
    }
  }
  //情景编辑
  .sceneSettingEdit_main {
    background-image: none;
    background: rgba(250,  237, 218, 0.85);
    // .select_lm {
      
    //   .val_box {
    //     // background: #F4FBFD;
    //     background: rgba(244, 251, 253, 1);
    //     .icon_x {
    //       width: 1rem;
    //       background-image: url("../img/orange/rightArrow.png");
    //     }
    //   }
    //   .select_xl_lm {
    //     .ul {
    //       background: #faedda;
    //     }
    //   }
    // }
    // .select_lm.multiple .selectDrop {
    //   border: 0.13rem solid #e09259;
    //   .drop {
    //     background: #e09259;
    //   }
    // }
    .foot_box {
      .paging_box {
        .paging {
          color: #682411;
        }
        .icon {
          &.icon1 {
            background-image: url('../img/orange/paging.png');
            transform: rotateZ(180deg);
          }

          &.icon2 {
            background-image: url('../img/orange/paging.png');
          }
        }
      }
      .btn1 {
        background: #f2cd9b;
        border: 0.09rem solid #682411;
        color: #682411;
      }
      .btn2 {
        background: #f44336;
        border: 0.09rem solid #f44336;
        color: #ffffff;
      }
    }
    .addBtn {
      background-image: url(../img/orange/btn_bg1.png);
    }
    .form_box {
      .flex_box {
        .delBtn {
          background: #f2cd9b;
          border: 0.1rem solid #682411;
          color: #682411;
        }
      }
      .form_item {
        .label {
          color: #682411;
        }
        .text_box {
          border: 0.1rem solid #682411;
          color: #682411;
        }

        .form_item_content {
          .label {
            color: #682411;
          }
          .el-input__inner {
            background-color: #faedda;
            border: 0.1rem solid #682411;
            // background-color: rgba(0, 0, 0, 0);
            color: #682411;
          }

        }
        .input1 {
          .el-input__inner {
            border-bottom: 0.1rem solid #682411;
            background-color: rgba(0, 0, 0, 0);
            color: #682411;
          }
        }
        .span {
          color: #682411;
        }

        .el-input .el-select__caret {
          color: #682411;
        }
      }
    }
    .slider_box .el-silder_runway {
      background: #fdbe6e;
    }
    .el-tooltip__popper.is-dark{
      color: #682411;
    }
  }
  //子账户
  .subAccountSetting_main {
    background: rgba(250,  237, 218, 0.9);
    .cont_left{
      .p1{
        color: #682411;
        .i{
          color: #FF0101;
        }
      }
      .form_box{
        margin-top: 1.78rem;
        width: 29.47rem;
        height: 40.39rem;
        background: rgba(242, 205, 155, 0.5);
        border-radius: 0.88rem;
        padding: 3.95rem 0 0 0;
        position: relative;
        .select_lm{
          margin: 0 auto 2.96rem;
          width: 24.41rem;
          .val_box{
            background: #faedda;
            border: 0.15rem solid #682411;
            .val {
              color: #682411;
            }
          }
          .select_xl_lm{
            width: 24.41rem;
            top: 3.8rem;
          }
        }
        .input1 {
          .el-input__inner{
            background: #faedda;
            border: 0.09rem solid #682411;
            color: #682411;
          }
          .span{
            color: #682411;
          }
          .el-input .el-select__caret{
            color: #682411;
          }
        }
        
        .btn_box .btn1{
          background: #f2cd9b;
          border: 0.09rem solid #682411;
          color: #682411;
        }
        .btn_box .btn2{
          background: #f44336;
          border: 0.09rem solid #f44336;
          color: #ffffff;
        }
      }
    }
    .cont_right{
      .p1{
        color: #682411;
        .i{
          color: #FF0101;
        }
      }
      .list_box{
        background: rgba(242, 205, 155, 0.5);
        .tr{
          border-bottom: 0.09rem solid #682411;
          .th,.td{
            border-right: 0.09rem solid #682411;
          }
          .th{
            color: #682411;
            background: #faedda;
          }
          .td{
            color: #682411;
          }
        }
      }
    }
    .dialog_box{
      .form_box{
        background: rgba(255, 251, 244, 0.9);
        // background: #FFFFFF;
        .input1 {
          .el-input__inner{
            border: 0.09rem solid #682411;
            background-color: rgba(0,0,0,0);
            color: #682411;
          }
          .span{
            color: #682411;
          }
          .el-input .el-select__caret{
            color: #682411;
          }
        }
        .btn_box{
          .btn1{
            background: #f2cd9b;
            border: 0.09rem solid #682411;
            color: #682411;
          }
          .btn2{
            background: #f44336;
            border: 0.09rem solid #f44336;
            color: #ffffff;
          }
        }
      }
    }
    .select_popper.el-select-dropdown {
      background: #faedda;
      border: 0.09rem solid #682411;
      border-radius: 0.44rem;
      .el-select-dropdown__item{
        &:hover {
          background: #fdbe6e;
        }
      }
     
    }
  }
  //项目设置
  .projectSettings_main{
    background-image: none;
    background: rgba(250,237,218,0.85);
    .cont_left{
      .p1{
        color: #682411;
        .i{
          color: #FF0101;
        }
      }
      .form_box{
        .form_item{
          .icon{
            &.btn{
              background-image: url('../img/orange/icon7.png');
            }
          }
          .icon4{
            background-image: url('../img/orange/icon4.png');
          }
          .icon5{
            background-image: url('../img/orange/icon5.png');
          }
          .icon6{
            background-image: url('../img/orange/icon6.png');
          }
          .icon7{
            background-image: url('../img/orange/icon7.png');
          }
          .el-input__inner{
            border: 0.09rem solid #682411;
            background-color: rgba(0,0,0,0);
            color: #682411;
          }
          .span{
            color: #682411;
          }
          .el-input .el-select__caret{
            color: #682411;
          }


        }
      }
    }
    .cont_right{
      .p1{
        color: #682411;
      }
      .flex_box{
        .icon{
            &.btn{
              background-image: url('../img/orange/btn_bg1.png');
              cursor: pointer;
            }
          }
          .icon8{
            background-image: url('../img/orange/dev_setting.png');
          }
          // .icon9{
          //   background-image: url('../img/icon/icon9.png');
          // }
      }
    }
    
    .btn_box{
      .btn1 {
        background: #f2cd9b;
        border: 0.09rem solid #682411;
        color: #682411;
      }
      .btn2 {
        background: #f44336;
        border: 0.09rem solid #f44336;
        color: #ffffff;
      }
    }
    .project_completed{
      .form_box{
        background: #FFFFFF;
        border: 0px solid #3A636F;
        opacity: 0.9;
        .span{
          color: #682411;
        }
        .btn_box2{
          .btn2{
            background: #f44336;
            border: 0.09rem solid #f44336;
            color: #ffffff;
          }
        }
      }
    }
  }
  //日程表
  .calendar_main{
    background: rgba(250,  237, 218, 0.85);
    .calendar_right {
      background: rgba(250,  237, 218, 0.8);
      border-left: 0.09rem solid #682411;
      .p {
        color: #682411;
        &:hover{
          color: rgba(58,99,11,0.8);
        }
        .el-button--text{
          color: #682411;
          &:hover{
            color: rgba(104,36,17,0.8);
          }
        }
      }
      .flex_box .button {
        background: #f44336;
        border: 0.09rem solid #f44336;
        color: #ffffff;
      }
    }
    .calendar_top {
      .span1 {
        color: #682411;
      }
      .btn_box {
        .btn1,.btn2,.btn3,.btn4 {
          background: rgba(242,205,155,0.5);
          border: 0.09rem solid #682411;
          color: #682411;
        }
      }
    }
    .calendar_cont {
      .li {
        background: rgba(242,205,155,0.5);
        .i_box {
          .i {
            background: #682411;
          }
        }
        &:nth-child(1) {
          background: rgba(244, 251, 253, 0);
          .div {
            border-bottom: 0.09rem solid #682411 !important;
            border-top: 0.18rem solid #682411 !important;
          }
        }
        .div {
          color: #682411;
          width: 100%;
          border-bottom: 0.09rem solid #682411;
          border-right: 0.09rem solid #682411;
          &:nth-child(7n + 1) {
            border-left: 0.09rem solid #682411;
          }
          &.noOne {
            color: rgba(0, 0, 0, 0.2);
          }
        }
      }
      .li1 {
        .div {
          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #682411;
        }
      }
    }
  }
  //功耗
  .powerConsumption {
    background: rgba(250,  237, 218, 0.85);
    .powerConsumption_box {
      .powerConsumption_title {
        .el-select {
          .el-input__inner {
            border: 1px solid #682411;
            color: #682411;
          }
          .el-select__caret {
            color: #682411;
          }
          .el-select-dropdown {
            opacity: 0.9;
            border: 1px solid #682411;
          }
          .el-select-dropdown__item .selected {
            color: #682411;
            background-color: aliceblue;
          }
          .el-popper[x-placement^=bottom] .popper__arrow {
            left: 171px;
            border-bottom-color: #682411;
          }
        }

        .sport {
          margin-left: 1.84rem;
          border-radius: 0.33rem;
          border: 0px solid #682411;
        }
        .upload {
          .img {
            background-image: url("../img/orange/download_icon.png");
          }
        }
        .select1 {
          .select_lm1 {
            .val_box1 {
              border: 1px solid #682411;
              color: #682411;
              .i {
                color: #ff0101;
              }
              .val {
                color: #682411;
              }
              .icon_x {
                top: 0.6rem;
                right: 0.8rem;
                width: 1rem;
                height: 1.5rem;
                background-image: url("../img/orange/rightArrow.png");
              }
            }
            .select_xl_lm {
              border: 0.1rem solid #682411;
              background: #faedda;
              .ul {
                background: #faedda;
              }
              .icon {
                background: #faedda;
                border-top: 0.1rem solid #682411;
                border-left: 0.1rem solid #682411;
              }

              .li {
                color: #682411;
                // .edit {
                //   background-image: url("../img/icon/edit.png");
                // }
                &:hover {
                  background: #fdbe6e;
                }
              }
            }
          }
          .span {
            color: #682411;
          }
        }
      }
      .powerConsumption_body {
        // background: rgba(244, 251, 253, 0.9);
        background: rgba(250, 237, 218, 1);
        .echarts_line {
          position: absolute;
          margin-top: 1rem;
        }
      }
    }
    .el-select__caret {
      color: #682411;
      font-size: 1.8rem;
    }
    .el-select-dropdown {
      opacity: 0.9;
      border: 1px solid #682411;
    }
    .el-select-dropdown__item .selected {
      color: #682411;
      background-color: aliceblue;
      font-weight: 500;
    }
    .el-popper[x-placement^=bottom] .popper__arrow {
      left: 171px;
      border-bottom-color: #682411;
    }
    .el-select-dropdown__item.selected {
        color: #682411;
        font-weight: 500;
        background-color: #682411;
    }
  }
  //添加日程
  .schedule_main {
    background: rgba(250,  237, 218, 0.85);
    .cont_box {
      .p1 {
        color: #682411;
        .i {
          margin-right: 0.5rem;
          color: #ff0101;
        }
      }
      .form_box {
        .input1 {
          .el-input__inner {
            border: 0.09rem solid #682411;
            background-color: rgba(0, 0, 0, 0);
            color: #682411;
          }
          .span {
            color: #682411;
          }
          .el-input .el-select__caret {
            color: #682411;
          }
        }
        .picker {
          .el-input__inner {
            border: 0.09rem solid #682411;
            background-color: rgba(0, 0, 0, 0);
            color: #682411;
          }
          .el-icon-time,
          .el-icon-date {
            &:before {
              color: #682411;
            }
          }

          .el-icon-circle-close {
            &:before {
              color: #682411;
            }
          }
        }
      }
      .flex_box {
        .flex_li {
          background: #faedda;
          color: #682411;
          &.select {
            background: #fdbe6e;
            color: #fff;
          }
        }
      }
      .add_btn {
        .icon {
          background-image: url(../img/orange/btn_bg1.png);
        }
      }
    }
    .btn_box {
      .btn1 {
        background: #f2cd9b;
        border: 0.1rem solid #682411;
        color: #682411;
      }
      .btn2 {
        background: #f44336;
        border: 0.09rem solid #f44336;
        color: #ffffff;
      }
    }
    .project_completed{
      .form_box{
        background: #FFFFFF;
        border: 0px solid #3A636F;
        opacity: 0.9;
        .span{
          color: #682411;
        }
        .btn_box{
          .btn2{
            background: #f44336;
            border: 0.09rem solid #f44336;
            color: #ffffff;
          }
        }
      }
    }
    .select_lm .select_xl_lm {
      .icon,.ul {
        background: #faedda;
      }
    }
    .select_lm .val_box .icon_x {
      width: 0.8rem;
      height: 1.3rem;
      top: 0.6rem;
      background-image: url("../img/orange/rightArrow.png");
    }
  }
  //网关
  .gatewayInput_main{
    .cont_right{
      .table_box {
        background: rgba(250,  237, 218, 0.9);
        .date1 {
          .el-input__inner {
            border: 0.09rem solid #682411;
            background-color: rgba(0, 0, 0, 0);
            color: #682411;
          }
        }
        .input1 {
          .el-input__inner {
            border: 0.09rem solid #682411;
            background-color: rgba(0, 0, 0, 0);
            color: #682411;
          }
        }
        .tr {
          color: #682411;
          &:nth-child(2n + 1) {
            background: rgba(250, 237, 218, 0.9);
            opacity: 0.9;
          }
          .searchBtn {
            background: #f2cd9b;
            border: 0.1rem solid #682411;
            color: #682411;
          }
          .wifiBtn {
            background: #f2cd9b;
            border: 0.1rem solid #682411;
            color: #682411;
          }
          .delBtn {
            background: #f2cd9b;
            border: 0.1rem solid #682411;
            color: #682411;
          }
        }
        
      }
      .foot_box {
        background: #faedda;
        .btn3 {
          background-image: url(../img/orange/btn_bg1.png);
        }
        .btn1 {
          background: #f2cd9b;
          border: 0.1rem solid #682411;
          color: #682411;
        }
        .btn2 {
          background: #f44336;
          border: 0.09rem solid #f44336;
          color: #ffffff;
        }
      }
    }
    .wifi_wrap{
      .wifi_box{
        background: rgba(250, 237, 218, 0.9);
        .wifi_top{
          color: #682411;
        }
        .wifi_cont {
          .el-form-item__label,.el-input__inner{
            color: #682411;
          }
          
        }
        .wifi_btn{
          .btn1{
            background: #f2cd9b;
            border: 0.1rem solid #682411;
            color: #682411;
          }
          .btn2{
            background: #f44336;
            border: 0.09rem solid #f44336;
            color: #ffffff;
          }
        }
      }
    }
    .dialog_wrap{
      .dialog_box{
        background: rgba(250, 237, 218, 0.9);
        .dialog_top{
          color: #682411;
        }
        .dialog_cont{
          .el-checkbox{
            .el-checkbox__label{
              color: #682411;
            }
          }
        }
      }
      .dialog_cont {
        .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
          background-color: #e09259;
          border-color: #e09259;
        }
      }
      .bottom_btn {
        .btn1 {
          background: #f2cd9b;
          border: 0.1rem solid #682411;
          color: #682411;
        }
        .btn2 {
          background: #f44336;
          border: 0.09rem solid #f44336;
          color: #ffffff;
        }
        .btn3{
          background: #f2cd9b;
          border: 0.1rem solid #682411;
          color: #682411;

        }
      }
    }
  }
  //分组
  .groupSetting_main {
    .cont_right {
      .table_box {
        background: rgba(250,  237, 218, 0.9);
        .btn{
          background: #f2cd9b;
          border: 0.1rem solid #682411;
          color: #682411;
        }
        .icon_x{
          background-image: url("../img/orange/rightArrow.png");
        }
        .lamp_list{
          border: 0.1rem solid #682411;
          // background: rgba(250, 237, 218, 0.9);
          .li {
            color: #682411;
          }
        }
        .input1 {
          .el-input__inner {
            border: 0.09rem solid #682411;
            background-color: rgba(0, 0, 0, 0);
            color: #682411;
          }
          .el-select__tags {
            .el-tag--small {
              color: #682411;
            }
          }
          .el-select__input {
            background-color: rgba(0, 0, 0, 0);
            color: #682411;
          }
          .span {
            color: #682411;
          }
          .el-input .el-select__caret {
            color: #682411;
          }
        }
        .tr {
          color: #682411;
          // background: rgba(250, 237, 218, 0.9);
          background: none;
          border-bottom: 2px solid rgba(250, 237, 218, 0.9);
          &:nth-child(2n + 1) {
            background: rgba(250, 237, 218, 0.9);
          }
          &.select{
            background: #fdbe6e;
            color: #ffffff;
          }
        }
        .trd {
          color: #682411;
          background: none;
          border-bottom: 2px solid rgba(250, 237, 218, 0.9);
          &:nth-child(2n + 1) {
            background: rgba(250, 237, 218, 0.9);
          }
        }
      }
      .foot_box{
        background: #faedda;
        opacity: 0.9;
        .btn1 {
          background: #f2cd9b;
          border: 0.1rem solid #682411;
          color: #682411;
        }
        .btn2 {
          background: #f44336;
          border: 0.09rem solid #f44336;
          color: #ffffff;
        }
        .btn3.icon{
          background-image: url(../img/orange/btn_bg1.png);
        }
      }
    }
    .project_completed{
      position: fixed;
      top: 0;right: 0;left: 0;bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      
      .bg{
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0);
        z-index: -1;
        opacity: 0.5;
      }
      .form_box{
        position: relative;
        width: 36.51rem;
        height: 18.09rem;
        padding-top: 2.83rem;
        background: #FFFFFF;
        border: 0px solid #3A636F;
        border-radius: 0.2rem;
        opacity: 0.9;
        .span{
          font-family: Calibri;
          color: #3A636F;
          text-align: center;
          width: 23.22rem;
          font-weight: 400;
          font-size: 1.8rem;
          color: #4C717C;
          margin: auto;
        }
        .btn_box{
          // position: absolute;
          // bottom: 0rem;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 5.07rem;
          // margin: 4.47rem auto 0;
          // width: 26.69rem;
          
          .btn2{
            width: 6.25rem;
            height: 2.63rem;
            background: #00C6FF;
            border-radius: 0.2rem;
            line-height: 2.63rem;
            border: 0.09rem solid #00C6FF;
            text-align: center;
            cursor: pointer;
            user-select: none;

            font-family: Calibri;
            font-weight: 400;
            font-size: 1.8rem;
            color: #FFFFFF;
          }
        }
      }
    }
  }
  //灯控
  .controllerInput_main {
    .cont_right {
      .table_box {
        background: rgba(250,  237, 218, 0.9);
        // opacity: 0.9;
        .date1{
          .el-input__inner {
            border: 0.09rem solid #682411;
            background-color: rgba(0, 0, 0, 0);
            color: #682411;
          }
        }
        .input1 {
          .el-input__inner {
            border: 0.09rem solid #682411;
            background-color: rgba(0, 0, 0, 0);
            color: #682411;
          }
          .el-select__tags {
            .el-tag--small {
              color: #682411;
            }
          }
          .el-select__input {
            background-color: rgba(0, 0, 0, 0);
            color: #682411;
          }
          .span {
            color: #682411;
          }
          .el-input .el-select__caret {
            color: #682411;
          }
        }
        .tr {
          color: #682411;
          &:nth-child(2n + 1) {
            background: rgba(250, 237, 218, 0.9);
            opacity: 0.9;
          }
        }
        .delBtn {
          background: #f2cd9b;
          border: 0.1rem solid #682411;
          color: #682411;
        }
      }
      .foot_box{
        background: #faedda;
        .btn1 {
          background: #f2cd9b;
          border: 0.1rem solid #682411;
          color: #682411;
        }
        .btn2 {
          background: #f44336;
          border: 0.09rem solid #f44336;
          color: #ffffff;
        }
        .btn3.icon{
          background-image: url(../img/orange/btn_bg1.png);
        }
      }
    }
    .project_completed{
      .form_box{
        background: #FFFFFF;
        border: 0px solid #3A636F;
        opacity: 0.9;
        .span{
          color: #682411;
        }
        .btn_box{
          .btn2{
            background: #f44336;
            border: 0.09rem solid #f44336;
            color: #ffffff;
          }
        }
      }
    }
  }
}
.home_main.themeType_2{
  .top_box {
    background: #2e2e2e;
    .top_left_box {
      .sport_stadium {
        background-image: url("../img/orange/sport_stadium.png");
      }
      .lock {
        .img.lock_1 {
          background-image: url("../img/orange/lock_1.png");
        }
        .img.lock_2 {
          background-image: url("../img/orange/lock_2.png");
        }
      }
      .refresh {
        .img {
          width: 1.54rem;
          height: 1.54rem;
          background-image: url("../img/orange/refresh.png");
        }
      }
      .text {
        color: #2e2e2e;
      }
      .select_lm {
        .icon_x {
          width: 0.8rem;
          height: 1.2rem;
          right: 1.4rem;
          top: 1.2rem;
          background-image: url("../img/grey/rightArrow.png");
        }
      }
    }
    .top_right_box {
      .zoneTime {
        color: #ffffff;
      }
      .signOut_btn_box .p_box .p1 ,
      .signOut_btn_box .p_box .p2{
        color: #ffffff;
      }
      .setting {
        background-image: url("../img/orange/setting.png");
      }
      .signOut_btn_box .avatar0 {
        background-image: url(../img/orange/login_2.png);
      }
      .logout-wrap-style{
        background-color:#dcdcdc;
        color: #2e2e2e;
        box-shadow: 0rem 0.13rem 0.66rem 0rem rgba(0,0,0,0.08);
      }
    }
  }
  .select_lm {
    .val_box{
      background: #dcdcdc;
      border: 0.15rem solid #2e2e2e;
      .val {
        color: #2e2e2e;
      }
      .icon_x {
        background-image: url('../img/grey/rightArrow.png');
        width: 0.7rem;
        height: 1.2rem;
        right: 1.4rem;
        top: 0.6rem;
      }
    }
    &.multiple {
      .selectDrop {
        border: 0.15rem solid #2e2e2e;
        .drop {
          background: #2e2e2e;
        }
      }
    }
  }
  .select_xl_lm {
    border: 0.1rem solid #2e2e2e;
    background: #dcdcdc;
    .ul {
      background: #dcdcdc;
    }
    .icon {
      border-top: 0.1rem solid #2e2e2e;
      border-left: 0.1rem solid #2e2e2e;
      background: #dcdcdc;
    }
    .li {
      color: #2e2e2e;
      .edit {
        background-image: url("../img/grey/edit.png");
      }
      &.select {
        background: #eeeeee;
      }
      &:hover {
        background: #eeeeee;
        
      }
    }
  }

  .left_toolbar {
    background: rgba(220 , 220 , 220 , 0.85);
    .icon_lj {
      background: #b5b5b5;
    }
    .top_bg {
      background: #b5b5b5;
    }
    .text {
      color: #2e2e2e;
    }
    .project_information {
      background: rgba(181 , 181 , 181 , 0.5);
    }
    .download_btn_1, .download_btn_2 {
      height: 1.5rem;
      .download_icon {
        background-image: url("../img/grey/download_icon.png");
      }
    }
    .nav_btn {
      &:hover .home {
        background-image: url("../img/icon/home_hover.png");
      }

      &:hover .sence_setting {
        background-image: url("../img/icon/sence_setting_hover.png");
      }

      &:hover .calendar {
        background-image: url("../img/icon/calendar_hover.png");
      }

      &:hover .system_setting {
        background-image: url("../img/icon/system_setting_hover.png");
      }

      &:hover .dev_setting {
        background-image: url("../img/icon/dev_setting_hover.png");
      }

      &:hover .group_setting {
        background-image: url("../img/icon/group_setting_hover.png");
      }

      &:hover .power_consumption {
        background-image: url("../img/icon/power_consumption_hover.png");
      }
      .home {
        background-image: url("../img/grey/home.png");
      }
      .sence_setting {
        background-image: url("../img/grey/sence_setting.png");
      }
      .calendar {
        background-image: url("../img/grey/calendar.png");
      }
      .system_setting {
        background-image: url("../img/grey/system_setting.png");
      }
      .dev_setting {
        background-image: url("../img/grey/dev_setting.png");
      }
      .group_setting {
        background-image: url("../img/grey/group_setting.png");
      }
      .power_consumption {
        background-image: url("../img/grey/power_consumption.png");
      }
      &:hover {
        // background: linear-gradient(-90deg, #FFFFFF, #00C6FF);
        background-image: none;
        background-color: #2e2e2e;
      }
      &.noSelect{
        
        &:hover {
          background:rgba(128,128,128,0.5);
          cursor: no-drop;
        }
      }
    }
  }
  .right_toolbar {
    background: rgba(220 , 220 , 220 , 0.85);
    .icon_lj {
      background: #b5b5b5;
    }
    .nav_box {
      .nav_btn {
        color: #2e2e2e;
        background: #b5b5b5;
        &.select {
          background: #2e2e2e;
          color: #f4fbfd;
        }
        // &.select {
        //   background: #eeeeee;
        //   color: #2e2e2e;
        // }
      }
    }
    .cont {
      .radio_li {
        .lm_radio {
          border: 0.13rem solid #2e2e2e;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0);
          .radio_i {
            background: #2e2e2e;
          }
          &.select {
            border: 0.13rem solid #2e2e2e;
          }
        }
        .text {
          color: #2e2e2e;
        }
        .el-select {
          .el-input__inner {
            border-color: #2e2e2e;
            background: rgba(0, 0, 0, 0);
            color: #2e2e2e;
          }
          .el-input__icon {
            font-size: 1.8rem;
            line-height: 2rem;
            color: #2e2e2e;
          }
          .el-select-dropdown__item {
            &:hover {
                background: #eeeeee;
            }
          }
        }
      }
      .flex_box {
        .span {
          color: #2e2e2e;
        }
        .brightness {
          border: 0.1rem solid #2e2e2e;
          color: #2e2e2e;
        }
      }
      .rightToolbar2 {
        .bottom_btn {
          .btn2 {
            background: none;
            border: none;
            color: #ffffff;
            background-position: center;
            background-size: 100% 100%;
            background-image: url("../img/grey/bouttom_background.png");
            // padding-bottom: 1rem;
          }
        }
        .radio_li {
          .el-select-dropdown.text_select {
            border: 1px solid #2e2e2e;
            .el-select-dropdown {
              opacity: 0.9;
              border: 1px solid #2e2e2e;
            }
            .el-select-dropdown__item{
              color: #2e2e2e;
            }
          }
        }
        .slider_box .slider_b .span1, 
        .slider_box .slider_b .span2 {
          color: #2e2e2e;
        }
        
      }
      .rightToolbar1 {
        .lebel , .val1, .val2 {
          color: #2e2e2e;
        }
        .apply_box {
          .apply {
            background: none;
            border: none;
            color: #2e2e2e;
            background-position: center;
            background-size: 100% 100%;
            background-image: url("../img/grey/apply.png");
            padding-bottom: 0.5rem;
            &.select {
              padding-bottom: 0.5rem;
              background: none;
              border: none;
              color: #ffffff;
              background-position: center;
              background-size: 100% 100%;
              background-image: url("../img/grey/apply.png");
            }
          }
          .icon_box {
            .img {
              background-image: url(../img/grey/point3.png);
              height: 2rem;
              width: 0.5rem;
              padding: 0 ;
              cursor: pointer;
            }

            .bg {
              position: fixed;
              top: 0;
              left: 0;
              top: 0;
              bottom: 0;
              right: 0;
              background: rgba(0, 0, 0, 0);
              z-index: 1;
              display: none;

              &.show {
                display: block;
              }
            }
            .popper_ul {
              background: #dcdcdc;
              border: 1px solid #2e2e2e;
              &.position{
                .icon {
                  border-bottom: 0.1rem solid #2e2e2e;
                  border-right: 0.1rem solid #2e2e2e;
                }
              }
              .ul {
                background: #dcdcdc;
              }
              .icon {
                background: #dcdcdc;
                border-top: 0.1rem solid #2e2e2e;
                border-left: 0.1rem solid #2e2e2e;
                transform: rotateZ(45deg);
              }
              .popper_li {
                color: #2e2e2e;
              }
              &.show {
                display: block;
              }
            }
          }
        }
      }
    }
  }
  .light_control {
    .cont {
      background: #dcdcdc;
      // background: rgba(220 , 220 , 220 , 0.85);
      .center_box {
        .form_item {
          .label {
            color: #2e2e2e;
          }
          .form_item_content {
            .text {
              color: #2e2e2e;
            }
            .val_box {
              border-bottom: 0.15rem solid #2e2e2e;
              .icon_x {
                width: 1rem;
                height: 1.7rem;
                background-image: url("../img/grey/rightArrow.png");
              }
            }
            .el-input__inner {
              background: rgba(255, 255, 255, 0);
              border-bottom: 0.15rem solid #2e2e2e;
              color: #2e2e2e;
            }
          }
        }
      }
      .bottom_btn {
        .btn1{
          background: none;
          border: none;
          background-position: center;
          background-size: 100% 100%;
          background-image: url("../img/grey/bouttom_background.png");
          line-height: 2.6rem;
          color: #2e2e2e;
        }
        .btn2{
          background: none;
          border: none;
          background-position: center;
          background-size: 100% 100%;
          background-image: url("../img/grey/bouttom_background.png");
          line-height: 2.6rem;
          color: #ffffff;
        }
      }
    }
  }
  .group_bottom_btn{
    .btn1{
      background: none;
      border: none;
      background-position: center;
      background-size: 100% 100%;
      background-image: url("../img/grey/bouttom_background.png");
      line-height: 2.6rem;
      color: #2e2e2e;
    }
    .btn2{
      background: none;
      border: none;
      background-position: center;
      background-size: 100% 100%;
      background-image: url("../img/grey/bouttom_background.png");
      line-height: 2.6rem;
      color: #ffffff;
    }
  }
  .btn1{
    background: none;
    border: none;
    background-position: center;
    background-size: 100% 100%;
    background-image: url("../img/grey/bouttom_background.png");
    line-height: 2.6rem;
    color: #2e2e2e;
  }
  .btn2{
    background: none;
    border: none;
    background-position: center;
    background-size: 100% 100%;
    background-image: url("../img/grey/bouttom_background.png");
    line-height: 2.6rem;
    color: #ffffff;
  }
  .btn3 {
    background: none;
    border: none;
    background-position: center;
    background-size: 100% 100%;
    background-image: url("../img/grey/bouttom_background.png");
    line-height: 2.6rem;
    color: #f83172;
    
  }
  .select_popper.el-select-dropdown {
    background: #dcdcdc;
    border: 0.09rem solid #2e2e2e;
    border-radius: 0.44rem;
    .el-select-dropdown__item{
      &:hover {
        background: #eeeeee;
      }
    }
    
  }
  .el-select-dropdown__item.hover{
    background-color: #dcdcdc;
  }
  .scrollbar_style::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 0.5rem;
    // background: #DAE6E0;
    background: #2e2e2e;
  }
  .scrollbar_style::-webkit-scrollbar-track {/*滚动条里面轨道*/
      background: #dcdcdc;
  }
  .dialog_box{
    // .bg {
    //   background: rgba(0, 0, 0, 0);
    // }
    .form_box{
      background: #FFFFFF;
      border: 1px solid #2e2e2e;
      opacity: 1;
      .span{
        color: #2e2e2e;
      }
      .input1 {
        .el-input__inner{
          border: 0.09rem solid #2e2e2e;
          background-color: rgba(0,0,0,0);
          color: #2e2e2e;
        }
        .span{
          color: #2e2e2e;
        }
        .el-input .el-select__caret{
          color: #2e2e2e;
        }
      }
      .btn_box{
        .btn1{
          background: none;
          border: none;
          background-position: center;
          background-size: 100% 100%;
          background-image: url("../img/grey/bouttom_background.png");
          line-height: 2.6rem;
          color: #2e2e2e;
        }
        .btn2{
          background: none;
          border: none;
          background-position: center;
          background-size: 100% 100%;
          background-image: url("../img/grey/bouttom_background.png");
          line-height: 2.6rem;
          color: #ffffff;
        }
      }
    }
  }
  //账户设置
  .systemSetting_main{
    background: rgba(220 , 220 , 220 , 0.85);
    .cont_left {
      .p1{
        color: #2e2e2e;
      }
      .avatar_box .avatar {
          &.avatar0{
            background-image: url(../img/grey/login_1.png);
          }
      }
      .select1 .select_lm {
        .val_box{
          background: #dcdcdc;
          border: 0.15rem solid #2e2e2e;
          color: #2e2e2e;
          .icon_x {
            width: 0.8rem;
            height: 1.4rem;
            right: 1.6rem;
            top: 1.1rem;
            background-image: url("../img/grey/rightArrow.png");
          }
        }
        .select_xl_lm {
          border: 0.1rem solid #2e2e2e;
          background: #dcdcdc;
          .icon {
            border-top: 0.1rem solid #2e2e2e;
            border-left: 0.1rem solid #2e2e2e;
            background: #dcdcdc;
          }
          .ul {
            background: #dcdcdc;
            .text {
              color: #2e2e2e;
              .form_item .btn{
                  &.btn0{
                    background-image: url('../img/grey/btn_bg1.png');
                  }
              }
            }
            .li {
              &.select {
                background: #eeeeee;
              }
              &:hover {
                background: #eeeeee;
                
              }
            }
          }
        }
      }
      .form_box {
        background: rgba(181 , 181 , 181 , 0.5);
        .input1 .el-input__inner {
          background: #dcdcdc;
          border: 0.09rem solid #2e2e2e;
          color: #2e2e2e;
        }
        .addUser_btn {
          width: 5.1rem;
          height: 4.4rem;
          background-image: url(../img/grey/icon_add.png);
          .icon {
            display: none;
          }
        }
        .btn1{
          background: none;
          border: none;
          background-position: center;
          background-size: 100% 100%;
          background-image: url("../img/grey/bouttom_background.png");
          line-height: 2.6rem;
          color: #2e2e2e;
        }
        .btn2{
          background: none;
          border: none;
          background-position: center;
          background-size: 100% 100%;
          background-image: url("../img/grey/bouttom_background.png");
          line-height: 2.6rem;
          color: #ffffff;
        }
      }
    }
    .cont_right {
      .p1{
        color: #2e2e2e;
      }
      .input1 .select_lm {
        .val_box{
          background: #dcdcdc;
          border: 0.15rem solid #2e2e2e;
          .icon {
            background-image: url(../img/grey/timeZone.png);
          }
          .val {
            color: #2e2e2e;
          }
          .icon_x {
            width: 0.8rem;
            height: 1.4rem;
            right: 1.6rem;
            top: 1rem;
            background-image: url("../img/grey/rightArrow.png");
          }
        }
        .select_xl_lm {
          border: 0.1rem solid #2e2e2e;
          background: #dcdcdc;
          .icon {
            border-top: 0.1rem solid #2e2e2e;
            border-left: 0.1rem solid #2e2e2e;
            background: #dcdcdc;
          }
          .ul {
            background: #dcdcdc;
            .text {
              color: #2e2e2e;
            }
          }
          .li {
            &.select {
              background: #eeeeee;
            }
            &:hover {
              background: #eeeeee;
              
            }
          }
        }
        &.noSelect{
          .val_box{
            background:rgba(128,128,128,0.5);
            cursor: no-drop;
          }
        }
      }
      .skin_setting {
        .li {
          &.add {
            background-image: url(../img/grey/btn_bg1.png);
            background-position: center;
            background-size: 100% 100%;
          }
        }
      }
      .contacts_settings {
        .box{
          background: #2e2e2e;
          border: 0.1rem solid #2e2e2e;
          .box_r .el-input{
            .el-input__inner {
              background: #dcdcdc;
              border: 0.09rem solid #2e2e2e;
              color: #2e2e2e;
            }
          }
          .box_l .text {
            color: #ffffff;
          }
          &.box3 {
            .box_l {
              flex-direction: column;
              .icon {
                width: 1.6rem;
                height: 2.5rem;
                margin: 0.2rem 0 0;
                background-image: url(../img/grey/icon3.png);
              }
            }
          }
        }
        // .box.box3 .box_l .icon {
        //   background-image: url(../img/grey/icon3.png);
        // }
        
      }
      .project_settings {
        // width: 35rem;
        justify-content: space-between;
        .button{
          background: none;
          border: none;
          background-position: center;
          background-size: 100% 100%;
          background-image: url("../img/grey/bouttom_background.png");
          line-height: 2.6rem;
          color: #2e2e2e;
          padding: 0 1.5rem;
        }
        .button1 {
          padding: 0 2.3rem;
        }
      }
      .btn_box .btn1{
        background: none;
        border: none;
        background-position: center;
        background-size: 100% 100%;
        background-image: url("../img/grey/bouttom_background.png");
        line-height: 2.6rem;
        color: #2e2e2e;
      }
      .btn2{
        background: none;
        border: none;
        background-position: center;
        background-size: 100% 100%;
        background-image: url("../img/grey/bouttom_background.png");
        line-height: 2.6rem;
        color: #ffffff;
        &.noSelect{
          line-height: 3.13rem;
        }
      }
    }
  }
  //情景设置 
  .scensSetting_main {
    background: rgba(220 , 220 , 220 , 0.85);
    .search {
      .el-input__inner {
        border: 0.09rem solid #2e2e2e;
        background: #dcdcdc;
        color: #2e2e2e;
      }
      .el-input__icon {
        line-height: 45px;
      }
    }
    .cont_ul {
      background: rgb(255, 255, 255);
      .sceneSettingBox {
        border-bottom: 0.1rem solid #2e2e2e;
        .title {
          .el-icon-arrow-right {
            color: #2e2e2e;
          }
          .text {
            color: #2e2e2e;
          }
          .box_2 {
            .apply {
              background: none;
              border: none;
              color: #2e2e2e;
              background-position: center;
              background-size: 100% 100%;
              background-image: url("../img/grey/apply.png");
              padding-bottom: 0.8rem;
              &.select {
                padding-bottom: 0.8rem;
                background: none;
                border: none;
                color: #ffffff;
                background-position: center;
                background-size: 100% 100%;
                background-image: url("../img/grey/apply.png");
              }
            }
            .icon_box {
              .img {
                background-image: url(../img/grey/point3.png);
                background-position: center;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                padding: 0;

                height: 2rem;
                width: 0.5rem;
              }
              .popper_ul {
                background: #dcdcdc;
                border: 1px solid #2e2e2e;
                &.position{
                  .icon {
                    border-top: none;
                    border-left: none;
                    border-bottom: 0.1rem solid #2e2e2e;
                    border-right: 0.1rem solid #2e2e2e;
                  }
                }
                .ul {
                  background: #dcdcdc;
                }
                .icon {
                  background: #dcdcdc;
                  border-top: 0.1rem solid #2e2e2e;
                  border-left: 0.1rem solid #2e2e2e;
                }
                .popper_li {
                  color: #2e2e2e;
                }
                &.show {
                  display: block;
                }
              }
            }
          }
        }
        .body_paragraph {
          .paragraph {
            color: #2e2e2e;
          }
        }
      }
    }
    .flex_box {
      .button {
        // background: #f44336;
        // border: 0.09rem solid #f44336;
        // color: #ffffff;

        background: none;
        border: none;
        background-position: center;
        background-size: 100% 100%;
        background-image: url("../img/grey/bouttom_background.png");
        line-height: 2.8rem;
        color: #ffffff;
      }
    }
    .el-icon-circle-plus-outline {
      color: #2e2e2e;
    }
    // .dialog_box{
    //   // .bg {
    //   //   background: rgba(0, 0, 0, 0);
    //   // }
    //   .form_box{
    //     background: #FFFFFF;
    //     border: 1px solid #2e2e2e;
    //     opacity: 1;
    //     .span{
    //       color: #2e2e2e;
    //     }
    //     .btn_box{
    //       .btn1{
    //         background: none;
    //         border: none;
    //         background-position: center;
    //         background-size: 100% 100%;
    //         background-image: url("../img/grey/bouttom_background.png");
    //         line-height: 2.6rem;
    //         color: #2e2e2e;
    //       }
    //       .btn2{
    //         background: none;
    //         border: none;
    //         background-position: center;
    //         background-size: 100% 100%;
    //         background-image: url("../img/grey/bouttom_background.png");
    //         line-height: 2.6rem;
    //         color: #ffffff;
    //       }
    //     }
    //   }
    // }
  }
  //情景编辑
  .sceneSettingEdit_main {
    background-image: none;
    background: rgba(220 , 220 , 220 , 0.85);
    
    .foot_box {
      .paging_box {
        .paging {
          color: #2e2e2e;
        }
        .icon {
          &.icon1 {
            background-image: url('../img/grey/paging.png');
            transform: rotateZ(180deg);
          }

          &.icon2 {
            background-image: url('../img/grey/paging.png');
          }
        }
      }
      // .btn1 {
      //   background: #f2cd9b;
      //   border: 0.09rem solid #682411;
      //   color: #682411;
      // }
      // .btn2 {
      //   background: #f44336;
      //   border: 0.09rem solid #f44336;
      //   color: #ffffff;
      // }
    }
    .addBtn {
      background-image: url(../img/grey/btn_bg1.png);
    }
    .form_box {
      .flex_box {
        .delBtn {
          // background: #f2cd9b;
          // border: 0.1rem solid #2e2e2e;
          // color: #2e2e2e;

          background: none;
          border: none;
          background-position: center;
          background-size: 100% 100%;
          background-image: url("../img/grey/bouttom_background.png");
          line-height: 2.6rem;
          color: #2e2e2e;
        }
      }
      .form_item {
        .label {
          color: #2e2e2e;
        }
        .text_box {
          border: 0.1rem solid #2e2e2e;
          color: #2e2e2e;
        }

        .form_item_content {
          .label {
            color: #2e2e2e;
          }
          .el-input__inner {
            background-color: #dcdcdc;
            border: 0.1rem solid #2e2e2e;
            // background-color: rgba(0, 0, 0, 0);
            color: #2e2e2e;
          }

        }
        .input1 {
          .el-input__inner {
            border-bottom: 0.1rem solid #2e2e2e;
            background-color: rgba(0, 0, 0, 0);
            color: #2e2e2e;
          }
        }
        .span {
          color: #2e2e2e;
        }

        .el-input .el-select__caret {
          color: #2e2e2e;
        }
      }
    }
    .slider_box .el-silder_runway {
      background: #eeeeee;
    }
    .el-tooltip__popper.is-dark{
      color: #2e2e2e;
    }
  }
  //子账户
  .subAccountSetting_main {
    background: rgba(220 , 220 , 220 , 0.85);
    .cont_left{
      .p1{
        color: #2e2e2e;
        .i{
          color: #FF0101;
        }
      }
      .form_box{
        background: rgba(181 , 181 , 181 , 0.5);
        .select_lm{
          .val_box{
            background: #dcdcdc;
            border: 0.15rem solid #2e2e2e;
            .val {
              color: #2e2e2e;
            }
            .icon_x {
              top: 1rem;
            }
          }
        }
        .input1 {
          .el-input__inner{
            background: #dcdcdc;
            border: 0.09rem solid #2e2e2e;
            color: #2e2e2e;
          }
          .span{
            color: #2e2e2e;
          }
          .el-input .el-select__caret{
            color: #2e2e2e;
          }
          .el-input__prefix {
            top: 0.5rem;
          }
        }
        .btn1{
          background: none;
          border: none;
          background-position: center;
          background-size: 100% 100%;
          background-image: url("../img/grey/bouttom_background.png");
          line-height: 2.6rem;
          color: #2e2e2e;
        }
        .btn2{
          background: none;
          border: none;
          background-position: center;
          background-size: 100% 100%;
          background-image: url("../img/grey/bouttom_background.png");
          line-height: 2.6rem;
          color: #ffffff;
        }
      }
    }
    .cont_right{
      .p1{
        color: #2e2e2e;
        .i{
          color: #FF0101;
        }
      }
      .list_box{
        background: rgba(181 , 181 , 181 , 0.5);
        .tr{
          border-bottom: 0.09rem solid #2e2e2e;
          .th,.td{
            border-right: 0.09rem solid #2e2e2e;
          }
          .th{
            color: #2e2e2e;
            background: #dcdcdc;
          }
          .td{
            color: #2e2e2e;
          }
        }
      }
    }
    .select_popper.el-select-dropdown {
      background: #dcdcdc;
      border: 0.09rem solid #2e2e2e;
      .el-select-dropdown__item{
        &:hover {
          background: #eeeeee;
        }
      }
    }
  }
  //项目设置
  .projectSettings_main{
    background-image: none;
    background: rgba(220 , 220 , 220 , 0.85);
    .cont_left{
      .p1{
        color: #2e2e2e;
        .i{
          color: #FF0101;
        }
      }
      .form_box{
        .form_item{
          .icon{
            &.btn{
              background-image: url('../img/grey/icon7.png');
            }
          }
          .icon4{
            background-image: url('../img/grey/icon4.png');
          }
          .icon5{
            background-image: url('../img/grey/icon5.png');
          }
          .icon6{
            background-image: url('../img/grey/icon6.png');
          }
          .icon7{
            background-image: url('../img/grey/icon7.png');
          }
          .el-input__inner{
            border: 0.09rem solid #2e2e2e;
            background-color: rgba(0,0,0,0);
            color: #2e2e2e;
          }
          .span{
            color: #2e2e2e;
          }
          .el-input .el-select__caret{
            color: #2e2e2e;
          }
        }
      }
    }
    .cont_right{
      .p1{
        color: #2e2e2e;
      }
      .flex_box{
        .icon{
            &.btn{
              background-image: url('../img/orange/btn_bg1.png');
              cursor: pointer;
            }
          }
          .icon8{
            background-image: url('../img/orange/dev_setting.png');
          }
          // .icon9{
          //   background-image: url('../img/icon/icon9.png');
          // }
      }
    }
    .project_completed{
      .form_box{
        background: #FFFFFF;
        border: 0px solid #2e2e2e;
        opacity: 0.9;
        .span{
          color: #2e2e2e;
        }
        .btn_box2{
          .btn2{
            background: none;
            border: none;
            background-position: center;
            background-size: 100% 100%;
            background-image: url("../img/grey/bouttom_background.png");
            // line-height: 2.6rem;
            color: #ffffff;
          }
        }
      }
    }
  }
  //日程表
  .calendar_main{
    background: rgba(220 , 220 , 220 , 0.85);
    .calendar_right {
      background: rgba(220 , 220 , 220 , 0.8);
      border-left: 0.09rem solid #2e2e2e;
      .p {
        color: #2e2e2e;
        &:hover{
          color: rgba(58,99,11,0.8);
        }
        .el-button--text{
          color: #2e2e2e;
          &:hover{
            color: rgba(46,46,46,0.8);
          }
        }
      }
      .flex_box .button {
        background: none;
        border: none;
        background-position: center;
        background-size: 100% 100%;
        background-image: url("../img/grey/bouttom_background.png");
        line-height: 2.6rem;
        color: #ffffff;
      }
    }
    .calendar_top {
      .span1 {
        color: #2e2e2e;
      }
      .btn_box {
        .btn1,.btn2,.btn3,.btn4 {
          background: rgba(181 , 181 , 181 , 0.5);
          border: 0.09rem solid #2e2e2e;
          color: #2e2e2e;
        }
      }
    }
    .calendar_cont {
      .li {
        background: rgba(181 , 181 , 181 , 0.5);
        .i_box {
          .i {
            background: #2e2e2e;
          }
        }
        &:nth-child(1) {
          background: rgba(244, 251, 253, 0);
          .div {
            border-bottom: 0.09rem solid #2e2e2e !important;
            border-top: 0.18rem solid #2e2e2e !important;
          }
        }
        .div {
          color: #2e2e2e;
          width: 100%;
          border-bottom: 0.09rem solid #2e2e2e;
          border-right: 0.09rem solid #2e2e2e;
          &:nth-child(7n + 1) {
            border-left: 0.09rem solid #2e2e2e;
          }
          &.noOne {
            color: rgba(0, 0, 0, 0.2);
          }
        }
      }
      .li1 {
        .div {
          color: #2e2e2e;
        }
      }
    }
  }
  //功耗
  .powerConsumption {
    background: rgba(220 , 220 , 220 , 0.85);
    .powerConsumption_box {
      .powerConsumption_title {
        .el-select {
          .el-input__inner {
            border: 1px solid #2e2e2e;
            color: #2e2e2e;
          }
          .el-select__caret {
            color: #2e2e2e;
          }
          .el-select-dropdown {
            opacity: 0.9;
            border: 1px solid #2e2e2e;
          }
          .el-select-dropdown__item .selected {
            color: #2e2e2e;
            background-color: aliceblue;
          }
          .el-popper[x-placement^=bottom] .popper__arrow {
            left: 171px;
            border-bottom-color: #2e2e2e;
          }
        }
        .sport {
          margin-left: 1.84rem;
          border-radius: 0.33rem;
          border: 0px solid #2e2e2e;
        }
        .upload {
          .img {
            background-image: url("../img/grey/download_icon.png");
          }
        }
        .select1 {
          .select_lm1 {
            .val_box1 {
              border: 1px solid #2e2e2e;
              color: #2e2e2e;
              // .i {
              //   color: #ff0101;
              // }
              .val {
                color: #2e2e2e;
              }
              .icon_x {
                top: 0.6rem;
                right: 1rem;
                width: 0.8rem;
                height: 1.5rem;
                background-image: url("../img/grey/rightArrow.png");
              }
            }
            .select_xl_lm {
              border: 0.1rem solid #2e2e2e;
              background: #dcdcdc;
              .ul {
                background: #dcdcdc;
              }
              .icon {
                background: #dcdcdc;
                border-top: 0.1rem solid #2e2e2e;
                border-left: 0.1rem solid #2e2e2e;
              }
              .li {
                color: #2e2e2e;
                &:hover {
                  background: #eeeeee;
                }
              }
            }
          }
          .span {
            color: #2e2e2e;
          }
        }
      }
      .powerConsumption_body {
        // background: rgba(244, 251, 253, 0.9);
        background: rgba(181 , 181 , 181 , 0.9);
      }
    }
    .el-select__caret {
      color: #2e2e2e;
      font-size: 1.8rem;
    }
    .el-select-dropdown {
      opacity: 0.9;
      border: 1px solid #2e2e2e;
    }
    .el-select-dropdown__item .selected {
      color: #2e2e2e;
      background-color: aliceblue;
      font-weight: 500;
    }
    .el-popper[x-placement^=bottom] .popper__arrow {
      left: 171px;
      border-bottom-color: #2e2e2e;
    }
    .el-select-dropdown__item.selected {
        color: #2e2e2e;
        font-weight: 500;
        background-color: #2e2e2e;
    }
  }
  //添加日程
  .schedule_main {
    background: rgba(220 , 220 , 220 , 0.85);
    .cont_box {
      .p1 {
        color: #2e2e2e;
        .i {
          margin-right: 0.5rem;
          color: #ff0101;
        }
      }
      .form_box {
        .input1 {
          .el-input__inner {
            border: 0.09rem solid #2e2e2e;
            background-color: rgba(0, 0, 0, 0);
            color: #2e2e2e;
          }
          .span {
            color: #2e2e2e;
          }
          .el-input .el-select__caret {
            color: #2e2e2e;
          }
        }
        .picker {
          .el-input__inner {
            border: 0.09rem solid #2e2e2e;
            background-color: rgba(0, 0, 0, 0);
            color: #2e2e2e;
          }
          .el-icon-time,
          .el-icon-date {
            &:before {
              color: #2e2e2e;
            }
          }

          .el-icon-circle-close {
            &:before {
              color: #2e2e2e;
            }
          }
        }
      }
      .flex_box {
        .flex_li {
          background: #dcdcdc;
          color: #2e2e2e;
          &.select {
            background: #eeeeee;
            color: #2e2e2e;
          }
        }
      }
      .add_btn {
        .icon {
          background-image: url(../img/grey/btn_bg1.png);
        }
      }
    }
    .btn_box {
      .btn1,.btn2 {
        line-height: 3.6rem;
      }
    }
    .project_completed{
      .form_box{
        background: #FFFFFF;
        border: 0px solid #2e2e2e;
        opacity: 0.9;
        .span{
          color: #2e2e2e;
        }
        .btn_box2{
          .btn2{
            background: none;
            border: none;
            background-position: center;
            background-size: 100% 100%;
            background-image: url("../img/grey/bouttom_background.png");
            // line-height: 2.6rem;
            color: #ffffff;
          }
        }
      }
    }
  }
  //网关
  .gatewayInput_main{
    .cont_right{
      .table_box {
        background: rgba(220,  220, 220, 0.9);
        .date1 {
          .el-input__inner {
            border: 0.09rem solid #2e2e2e;
            background-color: rgba(0, 0, 0, 0);
            color: #2e2e2e;
          }
        }
        .input1 {
          .el-input__inner {
            border: 0.09rem solid #2e2e2e;
            background-color: rgba(0, 0, 0, 0);
            color: #2e2e2e;
          }
        }
        .tr {
          color: #2e2e2e;
          &:nth-child(2n + 1) {
            background: rgba(220,  220, 220, 0.9);
            opacity: 0.9;
          }
          .searchBtn,.wifiBtn,.delBtn{
            background: none;
            border: none;
            background-position: center;
            background-size: 100% 100%;
            background-image: url("../img/grey/bouttom_background.png");
            line-height: 2.6rem;
            color: #2e2e2e;
          }
        }
      }
      .foot_box {
        background: #dcdcdc;
        .btn3 {
          background-image: url(../img/grey/btn_bg1.png);
        }
        .btn1 {
          background: none;
          border: none;
          background-position: center;
          background-size: 100% 100%;
          background-image: url("../img/grey/bouttom_background.png");
          line-height: 2.6rem;
          color: #2e2e2e;
        }
        .btn2 {
          background: none;
          border: none;
          background-position: center;
          background-size: 100% 100%;
          background-image: url("../img/grey/bouttom_background.png");
          line-height: 2.6rem;
          color: #ffffff;
        }
      }
    }
    .wifi_wrap{
      .wifi_box{
        background: rgba(220, 220, 220, 0.9);
        .wifi_top{
          color: #2e2e2e;
        }
        .wifi_cont {
          .el-form-item__label,.el-input__inner{
            color: #2e2e2e;
          }
          
        }
        .wifi_btn{
          .btn1 {
            background: none;
            border: none;
            background-position: center;
            background-size: 100% 100%;
            background-image: url("../img/grey/bouttom_background.png");
            line-height: 2.6rem;
            color: #2e2e2e;
          }
          .btn2 {
            background: none;
            border: none;
            background-position: center;
            background-size: 100% 100%;
            background-image: url("../img/grey/bouttom_background.png");
            line-height: 2.6rem;
            color: #ffffff;
          }
        }
      }
    }
    .dialog_wrap{
      .dialog_box{
        background: rgba(220, 220, 220, 0.9);
        .dialog_top{
          color: #2e2e2e;
        }
        .dialog_cont{
          .el-checkbox{
            .el-checkbox__label{
              color: #2e2e2e;
            }
          }
        }
      }
      .dialog_cont {
        .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
          background-color: #2e2e2e;
          border-color: #2e2e2e;
        }
      }
      .bottom_btn {
        .btn1,.btn3 {
          background: none;
          border: none;
          background-position: center;
          background-size: 100% 100%;
          background-image: url("../img/grey/bouttom_background.png");
          line-height: 2.6rem;
          color: #2e2e2e;
        }
        .btn2 {
          background: none;
          border: none;
          background-position: center;
          background-size: 100% 100%;
          background-image: url("../img/grey/bouttom_background.png");
          line-height: 2.6rem;
          color: #ffffff;
        }
      }
    }
  }
  //分组
  .groupSetting_main {
    .cont_right {
      .table_box {
        background: rgba(220,  220, 220, 0.9);
        .btn{
          background: none;
          border: none;
          background-position: center;
          background-size: 100% 100%;
          background-image: url("../img/grey/bouttom_background.png");
          // line-height: 2.6rem;
          padding: 0.5rem 1rem;
          color: #2e2e2e;
        }
        .icon_x{
          background-image: url("../img/grey/rightArrow.png");
        }
        .lamp_list{
          border: 0.1rem solid #2e2e2e;
          // background: rgba(250, 237, 218, 0.9);
          .li {
            color: #2e2e2e;
          }
        }
        .input1 {
          .el-input__inner {
            border: 0.09rem solid #2e2e2e;
            background-color: rgba(0, 0, 0, 0);
            color: #2e2e2e;
          }
          .el-select__tags {
            .el-tag--small {
              color: #2e2e2e;
            }
          }
          .el-select__input {
            background-color: rgba(0, 0, 0, 0);
            color: #2e2e2e;
          }
          .span {
            color: #2e2e2e;
          }
          .el-input .el-select__caret {
            color: #2e2e2e;
          }
        }
        .tr {
          color: #2e2e2e;
          // background: rgba(250, 237, 218, 0.9);
          background: none;
          border-bottom: 2px solid rgba(220,  220, 220, 0.9);
          &:nth-child(2n + 1) {
            background: rgba(220,  220, 220, 0.9);
          }
          &.select{
            background: #fdbe6e;
            color: #ffffff;
          }
        }
        .trd {
          color: #2e2e2e;
          background: none;
          border-bottom: 2px solid rgba(220,  220, 220, 0.9);
          &:nth-child(2n + 1) {
            background: rgba(220,  220, 220, 0.9);
          }
          // .td {
          //   display: flex;
          // }
        }
      }
      .foot_box{
        background: #dcdcdc;
        opacity: 0.9;
        .btn1 {
          background: none;
          border: none;
          background-position: center;
          background-size: 100% 100%;
          background-image: url("../img/grey/bouttom_background.png");
          line-height: 2.6rem;
          color: #2e2e2e;
        }
        .btn2 {
          background: none;
          border: none;
          background-position: center;
          background-size: 100% 100%;
          background-image: url("../img/grey/bouttom_background.png");
          line-height: 2.6rem;
          color: #ffffff;
        }
        .btn3.icon{
          background-image: url(../img/grey/btn_bg1.png);
        }
      }
    }
    .project_completed{
      .bg {
        background-color: rgba(0, 0, 0, 0.6);
      }
      .form_box{
        background: #FFFFFF;
        border: 0px solid #2e2e2e;
        opacity: 0.9;
        .span{
          color: #2e2e2e;
        }
        .btn_box2{
          .btn2{
            background: none;
            border: none;
            background-position: center;
            background-size: 100% 100%;
            background-image: url("../img/grey/bouttom_background.png");
            // line-height: 2.6rem;
            color: #ffffff;
          }
        }
      }
    }
  }
  //灯控
  .controllerInput_main {
    .cont_right {
      .table_box {
        background: rgba(220,  220, 220, 0.9);
        // opacity: 0.9;
        .date1{
          .el-input__inner {
            border: 0.09rem solid #2e2e2e;
            background-color: rgba(0, 0, 0, 0);
            color: #2e2e2e;
          }
        }
        .input1 {
          .el-input__inner {
            border: 0.09rem solid #2e2e2e;
            background-color: rgba(0, 0, 0, 0);
            color: #2e2e2e;
          }
          .el-select__tags {
            .el-tag--small {
              color: #2e2e2e;
            }
          }
          .el-select__input {
            background-color: rgba(0, 0, 0, 0);
            color: #2e2e2e;
          }
          .span {
            color: #2e2e2e;
          }
          .el-input .el-select__caret {
            color: #2e2e2e;
          }
        }
        .tr {
          color: #2e2e2e;
          &:nth-child(2n + 1) {
            background: rgba(220, 220, 220, 0.9);
            opacity: 0.9;
          }
        }
        .delBtn {
          background: none;
          border: none;
          background-position: center;
          background-size: 100% 100%;
          background-image: url("../img/grey/bouttom_background.png");
          line-height: 2.6rem;
          color: #2e2e2e;
        }
      }
      .foot_box{
        background: #dcdcdc;
        .btn1 {
          background: none;
          border: none;
          background-position: center;
          background-size: 100% 100%;
          background-image: url("../img/grey/bouttom_background.png");
          line-height: 2.6rem;
          color: #2e2e2e;
        }
        .btn2 {
          background: none;
          border: none;
          background-position: center;
          background-size: 100% 100%;
          background-image: url("../img/grey/bouttom_background.png");
          line-height: 2.6rem;
          color: #ffffff;
        }
        .btn3.icon{
          background-image: url(../img/grey/btn_bg1.png);
        }
      }
    }
    .project_completed{
      .bg {
        background-color: rgba(0, 0, 0, 0.6);
      }
      .form_box{
        background: #FFFFFF;
        border: 0px solid #2e2e2e;
        opacity: 0.9;
        .span{
          color: #2e2e2e;
        }
        .btn_box2{
          .btn2{
            background: none;
            border: none;
            background-position: center;
            background-size: 100% 100%;
            background-image: url("../img/grey/bouttom_background.png");
            // line-height: 2.6rem;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>